export default {
  services_number_title: "Liczba usług do wyboru",
  additional_information_after_booking_title:
    "Dodatkowe informacje w e-mailu o rezerwacji",
  additional_information_after_booking_subtitle:
    "Dołączymy je do e-maili o utworzeniu, zmianie i przypomnieniu rezerwacji.",
  additional_information_after_booking_dummy_text:
    "To jest przykładowy tekst, który zostanie zastąpiony dodatkowymi informacjami po rezerwacji, jeśli zostały one podane w ustawieniach usługi.",
  plugins_storage_100gb_cd_base_pro_name: "Miejsce na pliki 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Miejsce na pliki 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Więcej miejsca na pliki. Zyskaj 100 GB dodatkowej przestrzeni na wymianę plików z klientami oraz przyjmowanie załączników przez formularze rezerwacji. Idealne rozwiązanie, które usprawni komunikację i ułatwi obsługę klientów.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maksymalna przestrzeń na Twoje pliki. Skorzystaj z 500 GB przestrzeni, aby bez ograniczeń wymieniać pliki z klientami i odbierać załączniki przez formularze rezerwacji. Niezbędne dla dynamicznie rozwijających się firm, które cenią profesjonalizm i wygodę obsługi.",
  bookings_this_month: "Rezerwacje w tym miesiącu",
  bookings_all_processed: "Wszystkie rezerwacje",
  simple_store_product_transactions_this_month:
    "Sprzedane produkty w tym miesiącu",
  files_storage_usage: "Wykorzystane miejsce na pliki",
  files_storage_usage_from_available_prefix: "z dostępnych",
  not_available_in_standard_plan: "Funkcja niedostępna w planie Standard",
  ai_tokens_usage: "Wykorzystane tokeny AI",
  ai_tokens_usage_from_available_prefix: "z dostępnych",
  ai_tokens_resets_at: "Resetuje się",
  cancel_reason_dropdown_label: "Powód anulowania subskrypcji",
  cancel_subscription_category_1_title: "Problemy techniczne",
  cancel_subscription_category_1_reason_1_title:
    "Częste awarie lub przerwy w działaniu",
  cancel_subscription_category_1_reason_2_title: "Wolne działanie systemu",
  cancel_subscription_category_1_reason_3_title: "Trudny w obsłudze interfejs",
  cancel_subscription_category_1_reason_4_title:
    "Problemy z integracjami (np. system płatności, kalendarze zewnętrzne)",
  cancel_subscription_category_1_reason_5_title:
    "Obawy dotyczące bezpieczeństwa (np. wycieki danych)",
  cancel_subscription_category_1_reason_6_title:
    "Problemy z aplikacją mobilną pracownika (np. zawieszanie się, błędy)",
  cancel_subscription_category_2_title: "Zmiany osobiste/firmowe",
  cancel_subscription_category_2_reason_1_title:
    "Zmiana modelu biznesowego (np. mniejsze zapotrzebowanie na rezerwacje)",
  cancel_subscription_category_2_reason_2_title:
    "Ograniczenia budżetowe lub trudności finansowe",
  cancel_subscription_category_2_reason_3_title:
    "Zbyt duża ilość pracy, by zarządzać systemem",
  cancel_subscription_category_2_reason_4_title:
    "Zamknięcie firmy lub jej ograniczenie",
  cancel_subscription_category_2_reason_5_title:
    "Brak czasu na zarządzanie rezerwacjami",
  cancel_subscription_category_3_title:
    "Czynniki związane z ceną i konkurencją",
  cancel_subscription_category_3_reason_1_title:
    "Tańsze alternatywy dostępne na rynku",
  cancel_subscription_category_3_reason_2_title:
    "Wzrost cen lub zmiana modelu rozliczeń",
  cancel_subscription_category_4_title: "Problemy z doświadczeniem użytkownika",
  cancel_subscription_category_4_reason_1_title:
    "Trudności w poruszaniu się po systemie",
  cancel_subscription_category_4_reason_2_title: "Brak wymaganych funkcji",
  cancel_subscription_category_4_reason_3_title:
    "Zbyt skomplikowane dla Twojego zespołu lub firmy",
  cancel_subscription_category_4_reason_4_title:
    "Wolna lub niepomocna obsługa klienta",
  cancel_subscription_category_4_reason_5_title:
    "Ograniczone opcje personalizacji",
  cancel_subscription_category_4_reason_6_title:
    "Trudny proces konfiguracji lub wdrożenia",
  cancel_subscription_category_5_title: "Czynniki zewnętrzne i rynkowe",
  cancel_subscription_category_5_reason_1_title:
    "Zmiany w trendach rynkowych (np. przejście na rezerwacje przez media społecznościowe)",
  cancel_subscription_category_5_reason_2_title:
    "Kryzys gospodarczy lub spowolnienie",
  cancel_subscription_category_5_reason_3_title: "Zmiany w przepisach prawnych",
  cancel_subscription_category_6_title: "Inne",
  cancel_subscription_category_6_reason_1_title:
    "Powód niewymieniony w pozostałych kategoriach",
  cancel_subscription_category_6_reason_2_title: "Nie chcę podawać powodu",
  cancel_plan_and_delete_data: "Anuluj i usuń dane",
  cancel_plan_do_nothing: "Nic nie rób",
  cancel_plan_and_keep_data_confirmation_label:
    "Czy na pewno chcesz anulować subskrypcję z opcją zachowania danych?",
  cancel_plan_and_keep_data_confirmation_info:
    "Subskrypcja zostanie anulowana z końcem już opłaconego okresu rozliczeniowego. Dane będą bezpiecznie przechowywane na naszych serwerach i mogą zostać przywrócone w dowolnym momencie po reaktywacji subskrypcji.",
  scheduled_cancel_keeps_data_info:
    "Twój plan zostanie anulowany i przejdzie w tryb zachowania danych",
  no_just_checking_title: "Nie, tylko sprawdzam",
  payment_deadline_before_start_variable:
    "Czas na opłacenie rezerwacji przed rozpoczęciem każdej z rezerwacji cyklicznej",
  send_payment_reminder_before_start_variable:
    "Czas wysyłanego powiadomienia o wymaganej płatności przed rezerwacją",
  variable_service_reschedule_deadline_before_start:
    "Termin zmiany rezerwacji przed jej rozpoczęciem",
  variable_service_cancel_deadline_before_start:
    "Termin anulowania rezerwacji przed jej rozpoczęciem",
  variable_customer_private_notes: "Prywatne notatki klienta",
  booking_awaiting_payment_full_description:
    "Pełna informacja o wymaganej płatności",
  booking_awaiting_payment_full_description_example:
    "Brak płatności w ciągu 30 min spowoduje anulowanie rezerwacji. Kliknij poniżej, aby przejść do rezerwacji i dokonać płatności.",
  recurring_meeting_in_the_past_warning:
    'Nie można utworzyć spotkania cyklicznego z datami rozpoczęcia w przeszłości. Wybierz datę początkową w przyszłości lub odznacz opcję „Powtarzaj cyklicznie".',
  booking_overlaps_dialog_title: "Wykryto konflikt w kalendarzu",
  booking_overlaps_dialog_message:
    "Podczas weryfikacji dostępności wykryliśmy, że wybrany termin koliduje z istniejącymi rezerwacjami lub blokadami. Szczegóły konfliktu:",
  booking_overlaps_count: "Liczba kolidujących rezerwacji",
  unavailable_slot_overlaps_count: "Liczba kolidujących blokad",
  booking_overlaps_dialog_question: "Czy mimo to chcesz kontynuować?",
  selected_date: "Wybrana data",
  single_booking: "Rezerwacja pojedyncza",
  external_api_service_not_enabled_error:
    "Niestety, funkcja API nie jest dostępna dla tego konta.",
  integration_auth_code_expired_error:
    "Nie udało się dokończyć łączenia konta, bo autoryzacja wygasła. Kliknij „Połącz” jeszcze raz i dokończ logowanie bez dłuższych przerw.",
  google_calendar_disconnected_info:
    "Połączenie z Kalendarzem Google jest wyłączone, bo Google nie daje Calendesk dostępu do Twojego kalendarza. Zwykle oznacza to, że przy łączeniu nie zaznaczono wszystkich uprawnień. Połącz konto jeszcze raz i na ekranie Google zaznacz wszystkie uprawnienia, o które prosimy.",
  google_calendar_reconnect: "Połącz ponownie",
  outlook_mailbox_not_available_error:
    "Nie udało się podłączyć kalendarza tego konta Microsoft. Powodem może być skrzynka działająca na serwerze firmy zamiast w Microsoft 365, brak aktywnej skrzynki na koncie albo jej usunięcie. Sprawdź to z administratorem Microsoft 365.",
  service_not_available_at_selected_time:
    "Usługa nie jest dostępna w wybranym czasie.",
  service_not_available_pool_full:
    "Usługa nie jest dostępna o tej godzinie: w puli „@{pool}” nie ma wolnej pozycji (zajęte: @{used} z @{capacity}).",
  service_not_available_pool_rule:
    "Usługa nie jest dostępna o tej godzinie: wolne pozycje puli „@{pool}” są przeznaczone dla innych rezerwacji.",
  service_not_available_resource_taken:
    "Usługa nie jest dostępna o tej godzinie: zasób „@{resource}” jest zajęty przez inną rezerwację.",
  offline_mode: "Jesteś offline",
  offline_description: "Aplikacja wymaga połączenia z internetem do działania.",
  retry: "Spróbuj ponownie",
  checking_connection: "Sprawdzanie połączenia...",
  waiting_for_connection: "Oczekiwanie na połączenie",
  "2fa_verify_title": "Uwierzytelnianie dwuskładnikowe",
  "2fa_verify_description":
    "Wprowadź swój 6-cyfrowy kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania:",
  "2fa_recovery_code_label": "Kod odzyskiwania",
  "2fa_use_recovery_code": "Użyj kodu odzyskiwania",
  "2fa_use_app_code": "Użyj kodu z aplikacji",
  "2fa_verify_incorrect_error": "Kod 2FA jest nieprawidłowy. Spróbuj ponownie.",
  "2fa_session_expired_error": "Twoja sesja 2FA wygasła. Zaloguj się ponownie.",
  "2fa_verification_cancelled":
    "Uwierzytelnianie dwuskładnikowe zostało anulowane. Spróbuj ponownie.",
  enable_2fa: "Włącz 2FA",
  enable_2fa_title: "Włącz weryfikację 2-etapową",
  disable_2fa: "Wyłącz 2FA",
  disable_2fa_title: "Wyłącz weryfikację 2-etapową",
  "2fa_manual_setup": "Nie możesz zeskanować? Wprowadź ten kod ręcznie:",
  "2fa_recovery_codes_title": "Kody odzyskiwania",
  "2fa_download_codes": "Pobierz kody",
  "2fa_disable_description":
    "Zamierzasz wyłączyć weryfikację 2-etapową. To sprawi, że Twoje konto będzie mniej bezpieczne.",
  "2fa_disable_warning":
    "Wyłączenie weryfikacji 2-etapowej zmniejszy bezpieczeństwo Twojego konta.",
  "2fa_verify_to_disable": "Zweryfikuj swoją tożsamość",
  "2fa_verify_to_disable_description":
    "Wprowadź kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania, aby wyłączyć weryfikację 2-etapową.",
  warning: "Ostrzeżenie",
  current_password: "Aktualne hasło",
  incorrect_password: "Nieprawidłowe hasło. Spróbuj ponownie.",
  "2fa_setup_failed": "Nie udało się skonfigurować 2FA",
  "2fa_activation_failed": "Nie udało się aktywować 2FA",
  "2fa_verification_code": "Kod weryfikacyjny",
  "2fa_disabled_success": "2FA zostało pomyślnie wyłączone",
  "2fa_disable_failed": "Nie udało się wyłączyć 2FA",
  "2fa_step_1_password_title": "Wprowadź hasło",
  "2fa_step_1_scan_title": "Zeskanuj kod QR",
  "2fa_step_2_verify_title": "Zweryfikuj konfigurację",
  "2fa_authenticator_apps_required": "Wymagana aplikacja uwierzytelniająca",
  "2fa_setup_secure_subtitle":
    "Wybierz i zainstaluj bezpieczną aplikację 2FA, aby zabezpieczyć swoje konto",
  "2fa_apps_installation_note":
    "Zainstaluj jedną z tych aplikacji na telefonie przed kontynuowaniem konfiguracji.",
  "2fa_scan_with_app": "Zeskanuj ten kod QR aplikacją uwierzytelniającą",
  "2fa_enter_code_from_app":
    "Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej",
  "2fa_recovery_codes_warning":
    "Przechowuj te kody w bezpiecznym miejscu. Każdy kod może być użyty tylko raz.",
  "2fa_enter_password_to_continue":
    "Wprowadź obecne hasło, aby wygenerować unikalny kod QR",
  "2fa_enter_password_to_disable":
    "Wprowadź obecne hasło, aby potwierdzić wyłączenie 2FA",
  "2fa_disable_verification_description":
    "Wprowadź obecne hasło i kod z aplikacji uwierzytelniającej lub użyj kodu odzyskiwania, aby wyłączyć weryfikację 2-etapową.",
  "2fa_recovery_codes_description":
    "Te kody zapasowe umożliwiają dostęp do konta w przypadku zgubienia aplikacji uwierzytelniającej. Każdy kod może być użyty tylko raz, przechowuj je w bezpiecznym miejscu.",
  security_settings: "Ustawienia bezpieczeństwa",
  security_settings_description:
    "Zarządzaj ustawieniami bezpieczeństwa konta i metodami uwierzytelniania.",
  "2fa_security_title": "Weryfikacja 2-etapowa",
  "2fa_security_description":
    "Dodaj dodatkową warstwę bezpieczeństwa do konta dzięki weryfikacji 2-etapowej.",
  reset_password_description:
    "Wyślij link do resetowania hasła na swój adres e-mail.",
  "2fa_enabled_success": "2FA zostało pomyślnie włączone",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input: "Link do profilu LinkedIn",
  logs_diff_linkedin: "Link do profilu LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Link do profilu TikTok",
  logs_diff_tiktok: "Link do profilu TikTok",
  wb_linkedin: "Adres URL - LinkedIn",
  wb_tiktok: "Adres URL - TikTok",
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Ulepsz komunikację z klientami dzięki Calendesk Chat. Zapewniaj wsparcie w czasie rzeczywistym, odpowiadaj na pytania i angażuj się w kontakt z klientami bezpośrednio ze strony rezerwacji. Idealne dla firm, które chcą budować silniejsze relacje z klientami.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Ulepsz komunikację z klientami dzięki Calendesk Chat. Zapewniaj wsparcie w czasie rzeczywistym, odpowiadaj na pytania i angażuj się w kontakt z klientami bezpośrednio ze strony rezerwacji. Idealne dla firm, które chcą budować silniejsze relacje z klientami.",
  number_of_agents: "Liczba agentów",
  agents_plural: "agentów",
  integrations_category_customer_support: "Obsługa klienta",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Zarządzaj wsparciem na czacie. Uzyskaj dostęp do panelu, konfiguruj agentów i przeglądaj rozmowy.",
  chatwoot_package_not_active:
    "Pakiet Calendesk Chat nie jest aktywny. Aktywuj go w ustawieniach subskrypcji.",
  chatwoot_setup_title: "Skonfiguruj obsługę czatu",
  chatwoot_setup_info:
    'Calendesk Chat to osobna aplikacja dostępna na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>, gdzie będziesz zarządzać rozmowami z klientami.',
  chatwoot_setup_sso_warning:
    "Wszyscy administratorzy Calendesk z dostępem do integracji będą mogli logować się do panelu czatu.",
  chatwoot_setup_next_steps_title: "Po konfiguracji:",
  chatwoot_setup_next_step_1:
    'Konto czatu zostanie utworzone na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Administratorzy będą mogli zalogować się do panelu czatu jednym kliknięciem z menu Calendesk",
  chatwoot_setup_next_step_3:
    "Będziesz mógł dodać widget czatu do strony rezerwacji - kod do osadzenia znajdziesz w panelu czatu",
  chatwoot_company_section_title: "Dane firmy",
  chatwoot_admin_section_title: "Administrator czatu",
  chatwoot_business_name: "Nazwa firmy",
  chatwoot_business_name_hint:
    "Widoczna dla klientów w oknie czatu i powiadomieniach",
  chatwoot_admin_name: "Imię i nazwisko",
  chatwoot_admin_email: "E-mail",
  chatwoot_support_email: "E-mail obsługi klienta",
  chatwoot_support_email_placeholder: "np. kontakt@twojafirma.pl",
  chatwoot_support_email_hint:
    "Klienci zobaczą ten adres jako nadawcę odpowiedzi e-mail od Twojego zespołu",
  chatwoot_start_integration: "Skonfiguruj",
  chatwoot_integration_active:
    "Calendesk Chat jest aktywny i gotowy do użycia.",
  chatwoot_dashboard_info:
    'Zarządzaj rozmowami, agentami i ustawieniami w panelu czatu na <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Wszyscy administratorzy Calendesk z dostępem do integracji mogą logować się do panelu czatu jednym kliknięciem.",
  chatwoot_open_dashboard: "Otwórz panel",
  chatwoot_agent_limit: "Miejsca dla agentów",
  chatwoot_buy_more_agents: "Potrzebujesz więcej agentów? Zmień pakiet",
  chatwoot_integration_success:
    "Calendesk Chat został pomyślnie skonfigurowany!",
  chatwoot_integration_error:
    "Nie udało się skonfigurować Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_sso_error:
    "Nie udało się otworzyć panelu czatu. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspend_button: "Zawieś",
  chatwoot_suspend_title: "Zawieś Calendesk Chat",
  chatwoot_suspend_warning:
    "Zawieszenie spowoduje dezaktywację wtyczki czatu na stronie WWW po stronie klientów końcowych, <strong>jednak nie wpływa na aktywność pakietu ani na związane z nim opłaty</strong>.<br><br>Aby zrezygnować z pakietu, przejdź do zakładki <strong>Rozliczenia → Subskrypcja</strong> i wybierz opcję <strong>Wyłącz</strong>.",
  chatwoot_suspend_confirm: "Zawieś",
  chatwoot_suspend_success: "Calendesk Chat został zawieszony.",
  chatwoot_suspend_error:
    "Nie udało się zawiesić Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspended_info:
    "Twoje konto Calendesk Chat jest obecnie zawieszone.",
  chatwoot_suspended_data_preserved:
    "Wszystkie Twoje rozmowy i ustawienia są zachowane i zostaną przywrócone po reaktywacji.",
  chatwoot_reactivate_button: "Reaktywuj",
  chatwoot_reactivation_success: "Calendesk Chat został reaktywowany!",
  chatwoot_reactivation_error:
    "Nie udało się reaktywować Calendesk Chat. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.",
  chatwoot_suspended_tooltip: "Zawieszony - kliknij, aby reaktywować",
  chatwoot_agent_limit_exceeded:
    "Masz @{current} agentów, ale Twój pakiet pozwala tylko na @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Aby reaktywować Calendesk Chat, skontaktuj się z naszym zespołem wsparcia. Pomożemy dostosować liczbę agentów do limitu pakietu.",
  contact_support: "Skontaktuj się z pomocą",
  chatwoot_min_agents_info:
    "Wymagana minimalna liczba agentów: @{count} (na podstawie aktualnej konfiguracji Calendesk Chat).",
  chatwoot_close_confirm_title: "Zamknąć formularz?",
  chatwoot_close_confirm_warning:
    "Wprowadzone dane nie zostały zapisane i zostaną utracone.",
  chatwoot_close_confirm_yes: "Zamknij",
  chatwoot_close_confirm_no: "Wróć do formularza",
  dialog_close_confirm_title: "Zamknąć?",
  dialog_close_confirm_warning: "Niezapisane zmiany zostaną utracone.",
  dialog_close_confirm_yes: "Zamknij",
  dialog_close_confirm_no: "Anuluj",
  reports: "Raporty",
  reports_granularity: "Grupuj wg",
  reports_revenue: "Przychody i płatności",
  reports_bookings: "Rezerwacje",
  reports_team: "Mój zespół",
  reports_customers: "Klienci i sprzedaż",
  reports_clients: "Klienci",
  reports_subscriptions: "Subskrypcje",
  reports_products: "Produkty",
  reports_tab_revenue: "Przychody",
  date_range: "Zakres dat",
  vs_previous_period: "vs poprzedni okres",
  reports_revenue_timeline: "Przychody w czasie",
  reports_top_services: "Najlepsze usługi",
  reports_top_products: "Najlepsze produkty",
  reports_payment_providers: "Metody płatności",
  reports_payment_methods_count: "Transakcje wg metody płatności",
  reports_payment_methods_value: "Przychody wg metody płatności",
  reports_payment_timeline: "Płatności w czasie",
  reports_bookings_timeline: "Rezerwacje w czasie",
  reports_by_service: "Wg usługi",
  reports_by_employee: "Wg pracownika",
  reports_by_delivery_type: "Wg typu realizacji",
  reports_cancellation_reasons: "Przyczyny anulowania",
  reports_by_day: "Wg dnia tygodnia",
  reports_by_hour: "Wg godziny",
  reports_heatmap: "Mapa cieplna rezerwacji",
  reports_employee_performance: "Wyniki zespołu",
  reports_service_ranking: "Ranking usług",
  reports_by_category: "Wg kategorii",
  reports_locations: "Lokalizacje",
  reports_customer_segments: "Zaangażowanie klientów",
  reports_top_customers: "Najlepsi klienci",
  reports_product_revenue_timeline: "Przychody z produktów w czasie",
  reports_booking_revenue_timeline: "Przychody z rezerwacji w czasie",
  reports_top_subscriptions: "Najlepsze subskrypcje",
  reports_subscription_timeline: "Nowe subskrypcje w czasie",
  reports_subscription_revenue_timeline: "Przychody z subskrypcji w czasie",
  reports_revenue_forecast: "Prognoza przychodów",
  reports_bookings_forecast: "Prognoza rezerwacji",
  reports_section_key_metrics: "Kluczowe wskaźniki",
  reports_section_key_metrics_tooltip:
    "<b>Kluczowe wskaźniki</b><br><br>Najważniejsze metryki Twojego biznesu w wybranym okresie. Strzałki pokazują zmiany w porównaniu z poprzednim okresem o tej samej długości.",
  reports_section_trends: "Trendy",
  reports_section_trends_tooltip:
    "<b>Trendy</b><br><br>Jak zmieniały się Twoje przychody i rezerwacje w wybranym okresie.",
  reports_section_revenue: "Przychody",
  reports_section_revenue_tooltip:
    "<b>Przychody</b><br><br>Łączny przychód ze wszystkich źródeł w wybranym okresie. Liczone są tylko <b>zrealizowane płatności</b>.<br><br>Zawiera:<br>• <b>Podział przychodów</b> — z rezerwacji, subskrypcji i produktów<br>• <b>Śr. wartość rezerwacji</b> i <b>wskaźnik opłacalności</b><br>• <b>Oś czasu przychodów</b> — jak zmieniał się przychód w czasie<br>• <b>Najlepsze usługi, subskrypcje i produkty</b> — uszeregowane wg przychodu<br>• <b>Metody płatności</b> — liczba transakcji i przychód na metodę",
  reports_section_bookings: "Rezerwacje",
  reports_section_bookings_tooltip:
    "<b>Rezerwacje</b><br><br>Statusy rezerwacji, zmiany liczby w czasie oraz podział wg usług i pracowników w wybranym okresie.<br><br>Zawiera:<br>• <b>Podział wg statusów</b> — zatwierdzone, zakończone, anulowane<br>• <b>Oś czasu rezerwacji</b> — zmiany liczby rezerwacji w czasie<br>• <b>Przychody z rezerwacji</b> — jak zmieniały się przychody z rezerwacji w czasie<br>• <b>Wg usługi i pracownika</b> — najczęściej rezerwowane usługi i najbardziej zapracowani pracownicy",
  reports_section_patterns: "Wzorce rezerwacji",
  reports_section_patterns_tooltip:
    "<b>Wzorce rezerwacji</b><br><br>Kiedy Twoi klienci najchętniej rezerwują. Wykorzystaj to do optymalizacji grafiku.<br><br>Zawiera:<br>• <b>Mapa cieplna</b> — najpopularniejsze dni i godziny<br>• <b>Najpopularniejszy dzień</b> — który dzień tygodnia ma najwięcej rezerwacji<br>• <b>Wg godzin</b> — rozkład rezerwacji na poszczególne godziny",
  reports_section_employees: "Mój zespół",
  reports_section_employees_tooltip:
    "<b>Mój zespół</b><br><br>Jak radził sobie każdy członek zespołu w wybranym okresie.<br><br>Zawiera:<br>• <b>Zrealizowane rezerwacje</b> — liczba zakończonych rezerwacji na osobę<br>• <b>Wygenerowany przychód</b> — dochód z ich rezerwacji<br>• <b>Zapełnienie grafiku</b> — ile z dostępnego czasu pracy było zarezerwowane",
  reports_section_services: "Usługi",
  reports_section_services_tooltip:
    "<b>Usługi</b><br><br>Najpopularniejsze usługi i ich przychody w wybranym okresie.<br><br>Zawiera:<br>• <b>Rezerwacje na usługę</b> — liczba zatwierdzonych i zakończonych rezerwacji<br>• <b>Przychód na usługę</b> — wygenerowany dochód",
  reports_section_locations: "Lokalizacje",
  reports_section_locations_tooltip:
    "<b>Lokalizacje</b><br><br>Wyniki wg lokalizacji i typu realizacji w wybranym okresie.",
  reports_section_customers: "Klienci",
  reports_section_customers_tooltip:
    "<b>Klienci</b><br><br>Kto rezerwuje najczęściej, kto wydaje najwięcej i jak zaangażowani są Twoi klienci w wybranym okresie.<br><br>Zawiera:<br>• <b>Nowi klienci</b> — zarejestrowani w wybranym okresie<br>• <b>Aktywni klienci</b> — mieli co najmniej jedną rezerwację<br>• <b>Wykres zaangażowania</b> — nowi, powracający i lojalni stali bywalcy<br>• <b>Najlepsi klienci</b> — z największymi wydatkami w wybranym okresie",
  reports_section_customer_overview: "Klienci",
  reports_section_customer_overview_tooltip:
    "<b>Klienci</b><br><br>Wartości za całą historię — nie zmieniają się po zmianie zakresu dat.",
  reports_section_customer_activity: "Aktywność w okresie",
  reports_section_customer_activity_tooltip:
    "<b>Aktywność w okresie</b><br><br>Jak klienci angażowali się w wybranym okresie — rezerwacje, retencja i preferencje.",
  reports_section_products: "Produkty",
  reports_section_products_tooltip:
    "<b>Produkty</b><br><br>Sprzedaż produktów, przychody w czasie i bestsellery w wybranym okresie.<br><br>Zawiera:<br>• <b>Łączny przychód z produktów</b> w wybranym okresie<br>• <b>Oś czasu przychodów</b> — jak sprzedaż produktów zmieniała się w czasie<br>• <b>Najlepsze produkty</b> — bestsellery według przychodu",
  reports_section_subscriptions: "Subskrypcje",
  reports_section_subscriptions_tooltip:
    "<b>Subskrypcje</b><br><br>Przychody, odnowienia i wykorzystanie planów subskrypcyjnych w wybranym okresie.<br><br>Zawiera:<br>• <b>Aktywne subskrypcje</b> — ilu klientów ma teraz aktywny plan<br>• <b>Przychód</b> — ile zarobiłeś na subskrypcjach w wybranym okresie<br>• <b>Współczynnik odnowień</b> — ilu subskrybentów zapłaciło więcej niż raz (wyższy = klienci wracają)<br>• <b>Nowe subskrypcje</b> — ile nowych subskrypcji rozpoczęto w danym okresie<br>• <b>Przychody z subskrypcji</b> — jak zmieniały się przychody z subskrypcji w czasie<br>• <b>Najlepsze subskrypcje</b> — które plany przynoszą najwięcej pieniędzy<br>• <b>Wykorzystanie</b> — czy subskrybenci faktycznie korzystają z dostępnych rezerwacji?",
  reports_section_payments: "Płatności",
  reports_section_payments_tooltip:
    "<b>Płatności</b><br><br>Dane transakcyjne i podział wg metod płatności w wybranym okresie.<br><br>Zawiera:<br>• <b>Łączna liczba transakcji</b> — liczba zrealizowanych płatności<br>• <b>Wskaźnik opłacalności</b> — procent opłaconych rezerwacji<br>• <b>Wg metody płatności</b> — liczba transakcji i przychód na metodę",
  reports_section_booking_status: "Status rezerwacji",
  reports_section_cancellation_reasons: "Powody anulowania",
  reports_section_peak_hours: "Godziny szczytu",
  reports_section_peak_hours_tooltip:
    "<b>Jak czytać ten wykres:</b><br><br><b>Wiersze</b> = dni tygodnia<br><b>Kolumny</b> = godziny (00:00–23:00)<br><br>Każda komórka pokazuje <b>łączną liczbę</b> zatwierdzonych i zakończonych rezerwacji zaplanowanych w danym dniu o danej godzinie w <b>całym wybranym okresie</b>.<br><br><b>Przykład:</b> Jeśli wybrałeś 3 miesiące, komórka poniedziałek 10:00 pokazuje ile rezerwacji przypadło na dowolny poniedziałek o 10:00 w ciągu tych 3 miesięcy łącznie.<br><br>🟦 Ciemniejszy kolor = więcej rezerwacji",
  reports_section_busiest_day: "Najbardziej pracowity dzień tygodnia",
  stats_monday: "Poniedziałek",
  stats_tuesday: "Wtorek",
  stats_wednesday: "Środa",
  stats_thursday: "Czwartek",
  stats_friday: "Piątek",
  stats_saturday: "Sobota",
  stats_sunday: "Niedziela",
  stats_mon: "Pon",
  stats_tue: "Wt",
  stats_wed: "Śr",
  stats_thu: "Czw",
  stats_fri: "Pt",
  stats_sat: "Sob",
  stats_sun: "Ndz",
  reports_section_delivery_type: "Według sposobu realizacji",
  reports_section_peak_times: "Najpopularniejsze terminy",
  reports_bookings_by_hour: "Rezerwacje wg godziny",
  reports_bookings_by_service: "Najczęściej rezerwowane usługi",
  reports_bookings_by_employee: "Najaktywniejszy zespół",
  reports_booking_lead_time: "Czas wyprzedzenia rezerwacji",
  reports_bookings_by_location: "Rezerwacje wg lokalizacji",
  reports_employee_performance_note:
    'Wypełnienie kalendarza pokazuje "--", jeśli dla danego pracownika nie ustawiono godzin pracy.',
  reports_customer_segments_chart: "Segmenty klientów",
  reports_customer_segments_note:
    "Podział aktywnych klientów na trzy grupy na podstawie historii rezerwacji. Suma trzech grup = aktywni klienci.",
  reports_services_by_category: "Rezerwacje wg kategorii",
  reports_service_ranking_note:
    "Sortowane wg liczby rezerwacji. Kliknij w nagłówek kolumny, aby zmienić sortowanie.",
  reports_mrr_trend: "Nowe subskrypcje",
  reports_subscription_usage: "Wykorzystanie subskrypcji",
  reports_subscription_usage_tooltip:
    "Czy Twoi subskrybenci faktycznie korzystają z rezerwacji zawartych w planach?<br><br>• <b>Wykorzystanie limitu</b> — jeśli plan zawiera 10 rezerwacji, a klient wykorzystał 3, to 30%. To jest średnia ze wszystkich subskrybentów.<br>• <b>Niewykorzystane rezerwacje</b> — łączna liczba rezerwacji z planów, których nikt nie wykorzystał. Duża liczba oznacza, że subskrybenci marnują dostępne rezerwacje.",
  stats_revenue: "Przychód",
  stats_bookings: "Rezerwacje",
  stats_subscriptions: "Subskrypcje",
  stats_products: "Produkty",
  stats_new_customers: "Nowi klienci",
  stats_cancellation_rate: "Wskaźnik anulacji",
  stats_avg_booking_value: "Śr. wartość rezerwacji",
  stats_total_revenue: "Łączny przychód",
  stats_from_bookings: "Rezerwacje",
  stats_from_products: "Produkty",
  stats_from_subscriptions: "Subskrypcje",
  stats_active_employees: "Aktywni pracownicy",
  stats_team_revenue: "Przychód zespołu",
  stats_schedule_fill_rate: "Wypełnienie kalendarza",
  stats_total_booked_hours: "Łącznie godzin",
  stats_total_bookings: "Wszystkie rezerwacje",
  stats_approved: "Zatwierdzone",
  stats_done: "Zakończone",
  stats_cancelled: "Anulowane",
  stats_payment: "Oczekujące na płatność",
  stats_status: "Status",
  stats_service: "Usługa",
  stats_employee: "Pracownik",
  stats_delivery_type: "Typ realizacji",
  stats_share: "Udział",
  stats_reason: "Powód",
  stats_cancellations: "Anulacje",
  stats_category: "Kategoria",
  stats_location: "Lokalizacja",
  stats_type: "Typ",
  stats_provider: "Metoda",
  stats_transactions: "Transakcje",
  stats_value: "Łącznie",
  stats_product: "Produkt",
  stats_quantity: "Ilość",
  stats_subscription: "Subskrypcja",
  stats_customer: "Klient",
  stats_email: "Email",
  stats_customers_served: "Obsłużeni klienci",
  stats_utilization: "Obłożenie",
  stats_available_hours: "Dostępne godziny",
  stats_booked_hours: "Zarezerwowane godziny",
  stats_unique_customers: "Unikalni klienci",
  stats_total_customers: "Wszyscy klienci",
  stats_active_customers: "Aktywni klienci",
  stats_returning_customers: "Powracający klienci",
  stats_retention_rate: "Wskaźnik retencji",
  stats_customer_ltv: "Wartość klienta",
  stats_avg_days_between_visits: "Śr. dni między rezerwacjami",
  stats_preferred_delivery: "Preferowana lokalizacja",
  stats_preferred_payment: "Preferowana płatność",
  stats_total_spent: "Łączne wydatki",
  stats_total_sold: "Łącznie sprzedano",
  stats_product_revenue: "Przychód z produktów",
  stats_active_subscriptions: "Aktywne subskrypcje",
  stats_subscription_revenue: "Przychód z subskrypcji",
  stats_renewal_rate: "Wskaźnik odnowień",
  stats_active_users: "Aktywni użytkownicy",
  stats_avg_utilization: "Wykorzystanie limitu rezerwacji",
  stats_booking_limit_usage: "Wykorzystanie limitu rezerwacji",
  stats_unused_booking_slots: "Niewykorzystane rezerwacje",
  stats_unused_bookings: "Niewykorzystane rezerwacje",
  stats_total_transactions: "Wszystkie transakcje",
  stats_total_value: "Łączna wartość",
  stats_booking_payment_rate: "% opłaconych rezerwacji",
  stats_method: "Metoda",
  stats_day: "Dzień",
  stats_hour: "Godzina",
  stats_busiest_day: "Najbardziej aktywny dzień",
  stats_busiest_hour: "Najbardziej aktywna godzina",
  stats_average_lead_time: "Śr. dni z wyprzedzeniem",
  stats_median_lead_time: "Mediana dni z wyprzedzeniem",
  stats_month: "Miesiąc",
  stats_projected: "Prognoza",
  stats_low_estimate: "Dolna granica",
  stats_high_estimate: "Górna granica",
  stats_period: "Okres",
  stats_count: "Liczba",
  stats_bookings_count: "Rezerwacje",
  stats_name: "Nazwa",
  stats_cancellation_rate_tooltip:
    "Jak często rezerwacje są anulowane.<br><br><b>Wzór:</b> anulowane ÷ (zatwierdzone + zakończone + anulowane)<br><b>Przykład:</b> 10 rezerwacji, 2 anulowane = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Ile klient wydał u Ciebie łącznie przez cały okres współpracy — nie tylko w wybranym okresie.",
  stats_utilization_tooltip:
    "Średnie obłożenie grafiku w Twoim zespole. Dla każdego pracownika: zarezerwowane godziny ÷ dostępne godziny.<br><br><b>Dostępne godziny</b> wynikają z <b>Grafiku dostępności</b> pracownika. Dni wolne i wyjątki w grafiku są uwzględniane.<br><br>Przykład: pracownik pracuje pon.–pt., 9:00–17:00 (40 godz./tyg.). Jeśli 30 godzin jest zarezerwowanych, obłożenie wynosi 75%.",
  stats_booking_payment_rate_tooltip:
    "Procent opłaconych rezerwacji spośród wszystkich zaplanowanych w wybranym okresie.<br><br>Liczymy po dacie usługi — rezerwacja utworzona dziś na maj trafia do raportu za maj.",
  stats_renewal_rate_tooltip:
    "Ilu subskrybentów przedłużyło swój plan po pierwszej płatności — to znak zadowolenia klientów.",
  stats_unused_booking_slots_tooltip:
    "Łączna liczba rezerwacji, które subskrybenci mogli zrobić (na podstawie limitów planu), ale tego nie zrobili.<br><br><b>Przykład:</b> 3 subskrybentów ma plan z 10 rezerwacjami/miesiąc. Jeden wykorzystał 7, drugi 3, trzeci 0. To daje 3 + 7 + 10 = <b>20 niewykorzystanych rezerwacji</b>.<br><br>Duża liczba może oznaczać, że limity są za wysokie lub subskrybenci potrzebują przypomnienia o rezerwacji.",
  stats_active_subscriptions_tooltip:
    "Nowe subskrypcje rozpoczęte w wybranym okresie. To <b>nie</b> jest łączna liczba wszystkich aktywnych subskrybentów.",
  stats_avg_utilization_tooltip:
    'Niektóre plany subskrypcyjne zawierają określoną liczbę rezerwacji (np. "10 rezerwacji na miesiąc"). To pokazuje jaki procent tych rezerwacji Twoi subskrybenci faktycznie wykorzystali.<br><br><b>Przykład:</b> Klient kupuje plan z 10 rezerwacjami/miesiąc, ale umawia się tylko 3 razy → to 30% wykorzystania.<br><br>Niski procent oznacza, że subskrybenci nie wykorzystują w pełni tego, za co zapłacili. Uwzględnia tylko zatwierdzone i zakończone rezerwacje.',
  stats_new_customers_tooltip:
    "Nowi klienci, którzy zarejestrowali się w wybranym okresie. Na podstawie daty utworzenia konta.",
  stats_total_revenue_tooltip:
    "Łączny przychód w wybranym okresie z:<br>• rezerwacji<br>• subskrypcji<br>• sprzedaży produktów<br><br>Liczone są tylko <b>zrealizowane płatności</b>, na podstawie daty płatności.",
  stats_from_bookings_tooltip:
    "Przychody z płatności za rezerwacje w wybranym okresie. Liczone są tylko <b>zrealizowane płatności</b>.",
  stats_from_products_tooltip:
    "Przychody ze sprzedaży jednorazowych produktów w wybranym okresie.",
  stats_from_subscriptions_tooltip:
    "Przychody z płatności za subskrypcje w wybranym okresie.",
  stats_total_bookings_tooltip:
    "Łączna liczba rezerwacji ze statusem <b>zatwierdzone</b> i <b>zakończone</b> w wybranym okresie. Rezerwacje <b>anulowane</b> i <b>oczekujące na płatność</b> nie są liczone.",
  stats_approved_tooltip:
    "Liczba rezerwacji ze statusem <b>zatwierdzone</b> w wybranym okresie.",
  stats_done_tooltip:
    "Liczba rezerwacji ze statusem <b>zakończone</b> w wybranym okresie.",
  stats_cancelled_tooltip:
    "Rezerwacje <b>anulowane</b> w wybranym okresie — przez klienta lub przez Ciebie.",
  stats_active_employees_tooltip:
    "Pracownicy, którzy mieli co najmniej jedną zatwierdzoną lub zakończoną rezerwację w wybranym okresie.",
  stats_team_revenue_tooltip:
    "Łączny przychód z rezerwacji wszystkich pracowników w wybranym okresie. Liczone tylko zrealizowane płatności.",
  stats_schedule_fill_rate_tooltip:
    'Ile dostępnego czasu twojego zespołu jest wypełnione rezerwacjami.<br><br><b>Jak to liczymy:</b><br>1. Dla każdego pracownika sprawdzamy każdy dzień w wybranym okresie<br>2. Na każdy dzień sprawdzamy grafik — nadpisania dat (dni wolne, specjalne godziny) mają pierwszeństwo przed grafikiem tygodniowym<br>3. Sumujemy godziny zarezerwowane (zatwierdzone i zakończone rezerwacje)<br>4. Wypełnienie = zarezerwowane godziny ÷ dostępne godziny<br>5. Uśredniamy wynik dla wszystkich pracowników<br><br><b>Przykład:</b> Anna ma 40h dostępnych, 20h zarezerwowanych → 50%. Marek ma 40h dostępnych, 30h zarezerwowanych → 75%. Średnia = <b>62,5%</b><br><br>Pracownicy bez ustawionego grafiku są pomijani. "--" oznacza, że nikt nie ma grafiku.',
  stats_total_booked_hours_tooltip:
    "Łączna liczba godzin spędzonych na rezerwacjach przez cały zespół w wybranym okresie.",
  stats_customers_served_tooltip:
    "Liczba różnych klientów, z którymi ten pracownik pracował w wybranym okresie.",
  stats_available_hours_tooltip:
    'Ile godzin ten pracownik mógł przepracować w wybranym okresie, na podstawie jego grafiku.<br><br><b>Jak to liczymy:</b> sprawdzamy każdy dzień w wybranym okresie. Jeśli na dany dzień jest nadpisanie (np. dzień wolny), używamy go. W przeciwnym razie używamy standardowego grafiku tygodniowego.<br><br><b>Przykład:</b> pon.–pt. 9:00–17:00. Okres = pon. do niedz. → 5 dni roboczych × 8h = <b>40h</b>. Jeśli środa jest oznaczona jako dzień wolny, to 4 × 8h = <b>32h</b>.<br><br>"--" oznacza brak ustawionego grafiku.',
  stats_booked_hours_tooltip:
    "Godziny pracy faktycznie wypełnione rezerwacjami w wybranym okresie.",
  stats_total_tooltip:
    "Łączna liczba klientów zarejestrowanych u Ciebie — przez cały czas, nie tylko w wybranym okresie.",
  stats_new_tooltip:
    "Klienci, którzy zarezerwowali po raz pierwszy w wybranym okresie — wcześniej nie mieli żadnych rezerwacji.",
  stats_active_tooltip:
    "Klienci, którzy mieli co najmniej jedną rezerwację ze statusem <b>zatwierdzone</b> lub <b>zakończone</b> w wybranym okresie.",
  stats_returning_tooltip:
    "Klienci, którzy mieli rezerwację przed wybranym okresem i powrócili w jego trakcie.",
  stats_ltv_tooltip:
    "Średnia łączna kwota wydana przez klienta od daty rejestracji — przez cały czas, nie tylko w wybranym okresie.",
  stats_preferred_delivery_type_tooltip:
    "Najczęściej wybierany typ lokalizacji przez Twoich klientów — np. Google Meet, adres, telefon lub Microsoft Teams.",
  stats_total_customers_tooltip:
    "Łączna liczba zarejestrowanych klientów — z całej historii, nie tylko z wybranego okresu.",
  stats_preferred_payment_method_tooltip:
    "Metoda płatności najczęściej używana przez Twoich klientów przy opłacaniu rezerwacji.",
  stats_active_customers_tooltip:
    "Klienci, którzy mieli co najmniej jedną rezerwację w wybranym okresie.",
  stats_returning_customers_tooltip:
    "Klienci, którzy mieli rezerwacje przed wybranym okresem i wrócili w jego trakcie. Przy wybranym <b>Od początku</b> wynik wyniesie 0.",
  stats_retention_rate_tooltip:
    "Jaki procent aktywnych klientów rezerwował u Ciebie już wcześniej.<br><br><b>Wzór:</b> powracający ÷ aktywni × 100<br><b>Przykład:</b> 10 aktywnych, 6 powracających = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "Średnia liczba dni między rezerwacjami klientów, którzy przychodzą więcej niż raz.",
  stats_total_sold_tooltip: "Liczba sprzedanych produktów w wybranym okresie.",
  stats_product_revenue_tooltip:
    "Łączne przychody ze sprzedaży produktów w wybranym okresie.",
  stats_subscription_revenue_tooltip:
    "Łączne przychody z płatności za subskrypcje w wybranym okresie.",
  stats_active_users_tooltip:
    "Subskrybenci, którzy dokonali co najmniej jednej rezerwacji w ramach swojej subskrypcji w wybranym okresie.",
  stats_total_value_tooltip:
    "Suma wszystkich <b>zrealizowanych</b> transakcji płatniczych (rezerwacje, produkty i subskrypcje) w wybranym okresie.",
  stats_busiest_day_tooltip:
    "Dzień tygodnia z największą liczbą rezerwacji w wybranym okresie.",
  stats_busiest_hour_tooltip:
    "Godzina dnia z największą liczbą rezerwacji w wybranym okresie.",
  stats_avg_booking_value_tooltip:
    "Średnia kwota zapłacona za rezerwację w wybranym okresie.<br><br><b>Wzór:</b> przychód z rezerwacji ÷ liczba opłaconych rezerwacji",
  stats_mrr_tooltip:
    "Łączny przychód z płatności za subskrypcje w wybranym okresie. Pokazuje sumę wszystkich opłaconych transakcji subskrypcyjnych, nie znormalizowaną stawkę miesięczną.",
  stats_top_clients_tooltip:
    "Klienci generujący największy przychód w wybranym okresie, posortowani malejąco.",
  stats_top_service_tooltip:
    "Usługa z największą liczbą rezerwacji w wybranym okresie.",
  stats_bookings_timeline_tooltip:
    "Jak zmieniała się liczba rezerwacji w wybranym okresie. Uwzględnia rezerwacje ze statusem <b>zatwierdzone</b> i <b>zakończone</b>.<br><br><b>Prognoza:</b> linia przerywana na nadchodzące okresy — rezerwacje, które są już zaplanowane (<b>zatwierdzone</b> lub <b>oczekujące na płatność</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Mapa cieplna pokazująca, kiedy najczęściej odbywają się rezerwacje — wg dnia tygodnia i godziny. Ciemniejsze komórki = więcej rezerwacji.",
  stats_booking_revenue_tooltip:
    "Przychód wyłącznie z płatności za rezerwacje w wybranym okresie — bez sprzedaży produktów i subskrypcji.",
  stats_total_transactions_tooltip:
    "Łączna liczba transakcji płatniczych przetworzonych w wybranym okresie ze wszystkich źródeł.",
  stats_revenue_timeline_tooltip:
    "Przychody w podziale na źródła — rezerwacje, subskrypcje i produkty. Tylko zrealizowane płatności, na podstawie daty płatności. Kliknij pozycję w legendzie, żeby pokazać lub ukryć linię.<br><br><b>Prognoza</b>: linie przerywane pokazują prognozowane przychody — z rezerwacji już opłaconych lub oczekujących na płatność oraz szacowany przychód z aktywnych subskrypcji.",
  stats_revenue_top_services_table_tooltip:
    "Usługi uszeregowane wg przychodu w wybranym okresie.",
  stats_revenue_top_products_table_tooltip:
    "Produkty uszeregowane wg przychodu w wybranym okresie.",
  stats_payment_providers_chart_tooltip:
    "Liczba <b>zrealizowanych</b> transakcji wg metod płatności (np. Stripe, gotówka, karta) w wybranym okresie.",
  stats_payment_methods_count_chart_tooltip:
    "Ile transakcji zostało przetworzonych przez każdą metodę płatności w wybranym okresie.",
  stats_payment_methods_value_chart_tooltip:
    "Łączny przychód z każdej metody płatności w wybranym okresie.",
  stats_booking_status_chart_tooltip:
    "Rezerwacje wg statusu — <b>zatwierdzone</b>, <b>zakończone</b>, <b>anulowane</b> i <b>oczekujące na płatność</b> — w wybranym okresie.",
  stats_cancellation_reasons_chart_tooltip:
    "Najczęstsze powody anulowania rezerwacji w wybranym okresie.",
  stats_busiest_day_chart_tooltip:
    "Które dni tygodnia mają najwięcej rezerwacji w wybranym okresie.",
  stats_delivery_type_chart_tooltip:
    "Jak rezerwacje rozkładają się między typy realizacji — osobiście, online, telefonicznie itp. — w wybranym okresie.",
  stats_peak_times_tooltip:
    "Dzień i godzina z największą liczbą rezerwacji ze statusem <b>zatwierdzone</b> i <b>zakończone</b> w wybranym okresie.",
  stats_bookings_by_hour_tooltip:
    "Jak rezerwacje rozkładają się na poszczególne godziny dnia w wybranym okresie.",
  stats_bookings_by_service_tooltip:
    "Które usługi były najczęściej rezerwowane w wybranym okresie.",
  stats_bookings_by_employee_tooltip:
    "Którzy członkowie zespołu obsłużyli najwięcej rezerwacji w wybranym okresie.",
  stats_booking_lead_time_tooltip:
    "Z jakim wyprzedzeniem klienci rezerwują — liczba dni między złożeniem rezerwacji a jej terminem.",
  stats_bookings_by_location_tooltip:
    "Jak rezerwacje rozkładają się między lokalizacjami w wybranym okresie.",
  stats_average_lead_time_tooltip:
    "Średnia liczba dni między utworzeniem rezerwacji a jej terminem.",
  stats_median_lead_time_tooltip:
    "Mediana liczby dni między utworzeniem rezerwacji a jej terminem. Mniej wrażliwa na wartości skrajne niż średnia.",
  stats_low_estimate_tooltip:
    "Dolna granica prognozy — Twoje wyniki mogą kształtować się na tym poziomie, jeśli kolejny okres będzie spokojniejszy niż zwykle.",
  stats_high_estimate_tooltip:
    "Górna granica prognozy — optymistyczny scenariusz na kolejny okres.",
  stats_booking_status_tooltip:
    "Podział rezerwacji wg statusu — <b>zatwierdzone</b>, <b>zakończone</b> i <b>anulowane</b> — w wybranym okresie.",
  stats_customer_segments_chart_tooltip:
    "Jak zaangażowani są Twoi aktywni klienci w wybranym okresie:<br>• <b>Pierwsza wizyta</b> — pierwsza rezerwacja w historii<br>• <b>Wrócili</b> — mieli wcześniej rezerwacje, odwiedzili raz w tym okresie<br>• <b>Lojalni</b> — mieli wcześniej rezerwacje i przyszli 2+ razy w tym okresie",
  stats_top_customers_table_tooltip:
    "Łączny wydatek w wybranym okresie — obejmuje wszystkie płatności klienta: za rezerwacje, subskrypcje i produkty.",
  stats_employee_table_tooltip:
    "Przegląd wyników pracowników — rezerwacje, godziny i obłożenie w wybranym okresie.",
  stats_service_table_tooltip:
    "Przegląd wyników usług — rezerwacje i przychody w wybranym okresie.",
  stats_services_by_category_tooltip:
    "Liczba zatwierdzonych i zakończonych rezerwacji dla każdej kategorii usług w wybranym okresie.",
  stats_booking_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z rezerwacji w wybranym okresie.",
  stats_subscription_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z subskrypcji w wybranym okresie.",
  stats_product_revenue_timeline_tooltip:
    "Jak zmieniały się przychody z produktów w wybranym okresie.",
  stats_subscription_timeline_tooltip:
    "Liczba nowych subskrypcji rozpoczętych w danym okresie.",
  stats_top_subscriptions_table_tooltip:
    "Plany subskrypcyjne uszeregowane wg przychodu w wybranym okresie.",
  stats_top_products_table_tooltip:
    "Produkty uszeregowane wg przychodu w wybranym okresie.",
  stats_not_assigned: "Nieprzypisane",
  stats_low: "Niska",
  stats_medium: "Średnia",
  stats_high: "Wysoka",
  stats_insufficient: "Niewystarczające dane",
  stats_type_name: "Typ dostawy",
  stats_new_subscriptions: "Nowe subskrypcje",
  stats_new: "Nowi",
  stats_returning: "Powracający",
  stats_first_time: "Pierwsza wizyta",
  stats_first_time_tooltip:
    "Klienci bez rezerwacji przed wybranym okresem — to ich pierwsza wizyta.",
  stats_came_back: "Wrócili",
  stats_came_back_tooltip:
    "Klienci, którzy mieli rezerwacje wcześniej i zarezerwowali raz w tym okresie.",
  stats_loyal: "Lojalni",
  stats_loyal_tooltip:
    "Klienci, którzy mieli rezerwacje wcześniej i zarezerwowali 2+ razy w tym okresie.",
  stats_staff: "Pracownik",
  stats_payment_timeout: "Brak płatności",
  stats_calendar_sync: "Synchronizacja kalendarza",
  stats_in_person: "Adres",
  stats_phone: "Telefon",
  stats_other: "Inna",
  stats_stripe: "Stripe",
  stats_cash: "Gotówka",
  stats_card: "Karta",
  stats_transfer: "Przelew",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Klient",
  stats_no_payment: "Brak płatności",
  stats_external: "Synchronizacja kalendarza",
  bulk_operation_progress: "Przetwarzanie: @{done} z @{total}",
  bulk_operation_counting: "Liczenie rekordów...",
  bulk_action_delete_events: "Usuwanie wydarzeń",
  bulk_action_delete_users: "Usuwanie użytkowników",
  bulk_action_update_users: "Aktualizowanie użytkowników",
  bulk_action_export_users: "Eksportowanie użytkowników",
  bulk_action_add_to_group: "Dodawanie do grup",
  bulk_action_remove_from_group: "Usuwanie z grup",
  bulk_action_send_notification: "Wysyłanie powiadomień",
  bulk_action_update_bookings: "Aktualizowanie rezerwacji",
  bulk_action_export_events: "Eksportowanie wydarzeń",
  bulk_action_export_unavailable_booking_slots: "Eksportowanie blokad",
  bulk_action_update_employees: "Aktualizowanie pracowników",
  bulk_action_delete_employees: "Usuwanie pracowników",
  bulk_action_delete_resources: "Usuwanie zasobów",
  bulk_action_delete_tags: "Usuwanie etykiet",
  bulk_action_delete_groups: "Usuwanie grup",
  bulk_action_delete_locations: "Usuwanie lokalizacji",
  bulk_action_delete_availability_schedules: "Usuwanie grafików dostępności",
  bulk_action_delete_subscriptions: "Usuwanie subskrypcji",
  bulk_action_delete_store_products: "Usuwanie produktów",
  bulk_action_delete_store_transactions: "Usuwanie transakcji",
  bulk_action_delete_user_subscriptions: "Usuwanie subskrypcji klientów",
  bulk_action_cancel_user_subscriptions: "Anulowanie subskrypcji klientów",
  bulk_action_delete_newsletter: "Usuwanie adresów z newslettera",
  bulk_action_export_newsletter: "Eksport newslettera",
  bulk_action_delete_websites: "Usuwanie stron www",
  bulk_action_disable_websites: "Wyłączanie stron www",
  bulk_action_delete_mobile_apps: "Usuwanie aplikacji mobilnych",
  bulk_action_export_employees: "Eksportowanie pracowników",
  bulk_notification_sending: "Wysyłanie powiadomień...",
  bulk_export_generating: "Generowanie pliku...",
  bulk_export_sent_to_email: "Plik wysłany na Twój e-mail",
  bulk_export_sent_to_email_with_errors:
    "Plik wysłany na Twój e-mail. Przetworzone: @{processed}, błędy: @{failed}.",
  download_csv: "Pobierz CSV",
  selection_all_on_page:
    "Zaznaczono wszystkie wiersze na tej stronie (@{amount}).",
  selection_select_all_records:
    "Zaznacz wszystkie wiersze ze wszystkich stron (@{total})",
  selection_all_records_selected:
    "Zaznaczono wszystkie wiersze ze wszystkich stron (@{total}).",
  your_overview: "Twój przegląd",
  add_widget: "Dodaj widget",
  widget_group_revenue: "Przychody",
  widget_group_bookings: "Rezerwacje",
  widget_group_clients: "Klienci",
  widget_group_team: "Mój zespół",
  widget_group_subscriptions: "Subskrypcje",
  widget_group_products: "Produkty",
  widget_revenue_kpi: "Przychody",
  widget_bookings_kpi: "Rezerwacje",
  widget_new_clients_kpi: "Nowi klienci",
  widget_cancellation_rate: "Wskaźnik anulacji",
  widget_top_clients: "Najlepsi klienci",
  widget_peak_hours_heatmap: "Godziny szczytu",
  widget_avg_booking_value: "Śr. wartość rezerwacji",
  widget_payment_method: "Preferowana metoda płatności",
  widget_bookings_timeline: "Rezerwacje w czasie",
  widget_booking_status: "Status rezerwacji",
  widget_busiest_day: "Najbardziej aktywny dzień",
  widget_busiest_hour: "Najbardziej aktywna godzina",
  widget_avg_lead_time: "Śr. czas wyprzedzenia",
  widget_active_clients: "Aktywni klienci",
  widget_retention_rate: "Wskaźnik retencji",
  widget_employee_utilization: "Obłożenie pracowników",
  widget_top_service: "Najlepsza usługa",
  widget_active_subscriptions: "Aktywne subskrypcje",
  widget_mrr: "Przychód z subskrypcji",
  widget_product_revenue: "Przychód z produktów",
  widget_booking_revenue: "Przychód z rezerwacji",
  widget_total_transactions: "Wszystkie transakcje",
  widget_payment_conversion: "% opłaconych rezerwacji",
  widget_revenue_timeline: "Przychody w czasie",
  widget_revenue_top_services_table: "Top usługi wg przychodu",
  widget_revenue_top_products_table: "Top produkty wg przychodu",
  widget_payment_providers_chart: "Metody płatności",
  widget_booking_status_chart: "Podział rezerwacji wg statusu",
  widget_cancellation_reasons_chart: "Powody anulowania",
  widget_busiest_day_chart: "Rezerwacje wg dnia tygodnia",
  widget_delivery_type_chart: "Podział wg typu realizacji",
  widget_customer_segments_chart: "Segmenty klientów",
  widget_top_customers_table: "Top klienci (pełna tabela)",
  widget_employee_table: "Wyniki pracowników",
  widget_service_table: "Wyniki usług",
  widget_subscription_timeline: "Nowe subskrypcje w czasie",
  widget_subscription_revenue_timeline: "Przychody z subskrypcji w czasie",
  widget_top_subscriptions_table: "Top plany subskrypcyjne",
  widget_product_revenue_timeline: "Przychody z produktów w czasie",
  widget_top_products_table: "Top produkty",
  widget_booking_revenue_timeline: "Przychody z rezerwacji w czasie",
  widget_bookings_by_service_table: "Rezerwacje wg usługi",
  widget_bookings_by_employee_table: "Najaktywniejszy zespół",
  widget_bookings_by_hour_chart: "Rezerwacje wg godziny",
  widget_locations_table: "Rezerwacje wg lokalizacji",
  widget_total_clients: "Wszyscy klienci",
  widget_customer_ltv: "Wartość klienta (LTV)",
  widget_returning_clients: "Powracający klienci",
  widget_avg_days_between_visits: "Śr. dni między wizytami",
  widget_first_time_clients: "Nowi klienci (pierwsza wizyta)",
  widget_loyal_clients: "Lojalni klienci",
  widget_services_by_category_chart: "Rezerwacje wg kategorii",
  widget_renewal_rate: "Wskaźnik odnowień",
  widget_subscription_utilization: "Wykorzystanie subskrypcji",
  widget_unused_booking_slots: "Niewykorzystane terminy",
  widget_total_products_sold: "Sprzedane produkty",
  restore_defaults: "Przywróć domyślne",
  restore_defaults_warning:
    "Spowoduje to zresetowanie pulpitu do domyślnych widżetów. Twój aktualny układ zostanie utracony.",
  drag_to_reorder: "Przeciągnij, aby zmienić kolejność",
  tooltip_add_widget: "Dodaj nowy widżet do pulpitu",
  tooltip_edit_layout: "Zmień kolejność lub usuń widżety",
  tooltip_restore_defaults: "Przywróć domyślny układ widżetów",
  tooltip_save_layout: "Zapisz aktualny układ widżetów",
  tooltip_remove_widget: "Usuń ten widżet",
  add_more_widgets: "Dodaj więcej widżetów",
  all_time: "Od początku",
  remove_from_group: "Usuń z grupy",
  change_status_to_approved: "Ustaw jako zatwierdzone",
  change_status_to_payment: "Ustaw jako oczekujące na płatność",
  change_status_to_cancelled: "Ustaw jako anulowane",
  change_status_to_done: "Ustaw jako zakończone",
  bulk_operation_already_active:
    "Masz już aktywną operację masową. Poczekaj na jej zakończenie.",
  go_to_fakturownia: "Przejdź do ustawień Fakturowni",
  invoice_no_integration_tooltip:
    "Faktura włączona, ale integracja z Fakturownią nie jest aktywna",
  affiliate: "Program poleceń",
  affiliate_page_title: "Program poleceń",
  affiliate_join_title: "Dołącz do programu poleceń",
  affiliate_join_description:
    "Udostępnij swój link i zarabiaj za każdego nowego klienta, który wykupi subskrypcję Calendesk.",
  affiliate_accept_terms: "Akceptuję regulamin programu poleceń",
  affiliate_terms_link_text: "Przeczytaj regulamin",
  affiliate_join_button: "Dołącz do programu",
  affiliate_balance_title: "Saldo programu poleceń",
  affiliate_link_title: "Twój link polecający",
  affiliate_link_description:
    "Udostępnij ten link, aby polecać nowych klientów i zarabiać.",
  affiliate_copy_link: "Kopiuj link",
  affiliate_link_copied: "Link skopiowany do schowka!",
  affiliate_request_payout: "Wypłać środki",
  affiliate_payout_method_title: "Wybierz metodę wypłaty",
  affiliate_payout_balance_credit: "Zasilenie salda",
  affiliate_payout_balance_credit_description:
    "Wykorzystaj zarobki jako kredyt na subskrypcję.",
  affiliate_payout_bank_transfer: "Przelew bankowy",
  affiliate_payout_bank_transfer_info:
    "Aby otrzymać przelew (min. {minAmount} netto), wyślij fakturę na support@calendesk.com po złożeniu wniosku.",
  affiliate_payout_bank_transfer_below_min:
    "Przelew bankowy wymaga minimum {minAmount}. Uzbieraj więcej albo skorzystaj z opcji zasilenia salda.",
  affiliate_payout_confirm: "Potwierdź wypłatę",
  affiliate_payout_success: "Wniosek o wypłatę został złożony.",
  affiliate_join_success: "Dołączyłeś do programu poleceń.",
  affiliate_no_referrals:
    "Brak poleceń. Udostępnij swój link, aby zacząć zarabiać!",
  affiliate_no_payouts: "Brak transakcji.",
  affiliate_referrals_title: "Polecenia",
  affiliate_payouts_title: "Historia transakcji",
  affiliate_status_pending: "Oczekujące",
  affiliate_status_rewarded: "Nagrodzone",
  affiliate_status_rejected: "Odrzucone",
  affiliate_status_approved: "Zatwierdzone",
  affiliate_status_completed: "Zrealizowane",
  affiliate_payout_method_balance: "Zasilenie salda",
  affiliate_payout_method_bank: "Przelew bankowy",
  affiliate_payout_method_adjustment: "Korekta salda",
  affiliate_welcome_bonus_banner:
    "Masz bonus powitalny! {amount} zniżki na pierwszą subskrypcję.",
  affiliate_welcome_bonus_applied: "Bonus powitalny: -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} na pierwszą płatność",
  first_payment: "Pierwsza płatność",
  affiliate_welcome_bonus_dashboard_title: "Czeka na Ciebie bonus powitalny",
  affiliate_welcome_bonus_dashboard_description:
    "Odbierz {amount} zniżki na pierwszą subskrypcję Calendesk.",
  affiliate_welcome_bonus_dashboard_cta: "Wybierz plan",
  affiliate_column_tenant: "Klient",
  affiliate_column_registered: "Rejestracja",
  affiliate_column_subscribed: "Subskrypcja",
  affiliate_column_status: "Status",
  affiliate_column_reward: "Nagroda",
  affiliate_column_date: "Data",
  affiliate_column_amount: "Kwota",
  affiliate_column_method: "Typ",
  affiliate_column_note: "Powód",
  affiliate_modal_headline: "Zarabiaj polecając Calendesk",
  affiliate_modal_cta_dismiss: "Może później",
  affiliate_accept_terms_with_link_prefix: "Akceptuję",
  affiliate_accept_terms_with_link_anchor: "regulamin programu poleceń",
  affiliate_total_earned: "Łączne zarobki",
  affiliate_total_paid: "Wypłacono",
  affiliate_hero_badge_new: "NOWOŚĆ",
  affiliate_hero_badge_label: "Program poleceń dla Twojej firmy",
  affiliate_hero_headline_main: "Udostępnij link. Zarabiaj na każdej",
  affiliate_hero_headline_accent: "rezerwacji.",
  affiliate_hero_subhead:
    "Każdy nowy klient, którego polecisz, to prowizja dla Ciebie, wypłacana automatycznie. Wszystko widzisz na żywo w panelu Calendesk.",
  affiliate_hero_cta_primary: "Dołącz do programu",
  affiliate_hero_cta_secondary: "Zobacz regulamin",
  affiliate_hero_headline:
    "Polecaj Calendesk: 50 zł dla Ciebie i 50 zł dla nowej firmy!",
  affiliate_hero_lead:
    "Zaakceptuj regulamin, dołącz do programu i odbierz swój link polecający. Za każdego klienta, który założy konto w Calendesk i opłaci subskrypcję, otrzymasz nagrodę. Zyska na tym również osoba polecona, która otrzyma bonus powitalny.",
  affiliate_hero_fine_print:
    "Program trwa od 01.04.2026 do 31.03.2028. Limit 2 000 zł brutto dla osób bez działalności gospodarczej. Rozliczenia w PLN, USD, EUR lub GBP.",
  affiliate_reward_you_label: "Ty otrzymujesz",
  affiliate_reward_you_amount: "50 zł",
  affiliate_reward_you_suffix: "netto",
  affiliate_reward_you_note: "za każdą nową firmę w Calendesk",
  affiliate_reward_new_label: "Nowa firma otrzymuje",
  affiliate_reward_new_amount: "50 zł",
  affiliate_reward_new_suffix: "netto",
  affiliate_reward_new_note: "kod rabatowy na subskrypcję Calendesk",
  affiliate_preview_copy: "Kopiuj",
  affiliate_preview_saldo_label: "Saldo · ten miesiąc",
  affiliate_preview_delta: "+7 poleceń",
  affiliate_preview_last_reward_title: "Ostatnia nagroda",
  affiliate_preview_paid_out: "Wypłacono",
  affiliate_preview_recent_title: "Ostatnie polecenia",
  affiliate_preview_recent_count: "7 w tym miesiącu",
  affiliate_preview_col_business: "Firma",
  affiliate_preview_col_reward: "Nagroda",
  affiliate_preview_col_status: "Status",
  affiliate_preview_status_reward: "NAGRODA",
  affiliate_preview_status_30days: "30 DNI",
  affiliate_hero_preview_link_title: "Twój link polecający",
  affiliate_hero_preview_link_description:
    "Wyślij go klientom i znajomym. Prowizja jest Twoja.",
  affiliate_hero_preview_this_month: "Ten miesiąc",
  affiliate_hero_preview_trend: "+34% vs. zeszły miesiąc",
  affiliate_hero_preview_recent_title: "Ostatnie polecenia",
  affiliate_hero_preview_recent_count: "12 w tym miesiącu",
  affiliate_hero_sample_data:
    "Dane przykładowe. Twoje liczby pojawią się po dołączeniu.",
  affiliate_hero_preview_label: "Podgląd",
  affiliate_announcement_title: "Zgarnijcie po 50 zł - Ty i Twoi znajomi!",
  affiliate_announcement_description:
    "Udostępnij swój link. Gdy nowa firma opłaci subskrypcję, oboje otrzymacie po 50 zł.",
  affiliate_announcement_description_2:
    "Nagrodę wypłacisz przelewem lub wykorzystasz na opłacenie własnego konta Calendesk.",
  affiliate_announcement_cta_learn_more: "Dowiedz się więcej",
  affiliate_announcement_cta_dismiss: "Może później",
  affiliate_hero_benefit_1:
    "Zarabiasz od każdej nowej subskrypcji. Bez limitu poleceń*",
  affiliate_hero_benefit_2:
    "Polecona firma dostaje kod rabatowy na subskrypcję",
  affiliate_hero_benefit_3: "Śledzisz polecenia na żywo w panelu",
  affiliate_suspended_title: "Twój program partnerski jest zawieszony",
  affiliate_suspended_message:
    "Nowe wypłaty są wstrzymane, a zespół Calendesk weryfikuje Twoje konto. Masz pytania? Napisz do wsparcia.",
  affiliate_rejection_cancelled_before_30d:
    "Polecony klient zrezygnował przed upływem 30 dni od subskrypcji.",
  affiliate_rejection_duplicate_tenant:
    "Polecony klient miał już konto w naszym systemie.",
  affiliate_rejection_fraud:
    "Polecenie oznaczone jako nieautoryzowane lub naruszające regulamin.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Twój program osiągnął maksymalny limit zarobków.",
  affiliate_rejection_note_label: "Notatka od wsparcia:",
  affiliate_leave_program: "Opuść program partnerski",
  affiliate_leave_dialog_title: "Opuścić program partnerski?",
  affiliate_leave_dialog_warning:
    "Przestaniesz zbierać nowe nagrody, a Twój link partnerski przestanie działać.",
  affiliate_leave_dialog_rejoin_hint:
    "Możesz wrócić w każdej chwili. Kod i historia są zachowane.",
  affiliate_leave_dialog_confirm: "Opuść program",
  affiliate_leave_success: "Nie uczestniczysz już w programie partnerskim.",
  affiliate_preview_copy_locked:
    "Zaakceptuj regulamin i dołącz do programu, aby wygenerować link.",
  affiliate_code_title: "Twój kod polecający",
  affiliate_code_description:
    "Klient może wpisać ten kod przy zakupie pierwszej subskrypcji.",
  affiliate_copy_code: "Kopiuj kod",
  affiliate_code_copied: "Kod skopiowany do schowka!",
  affiliate_terms_title: "Twoje warunki",
  affiliate_terms_description:
    "Indywidualne warunki uzgodnione z Calendesk. Mają pierwszeństwo przed standardowymi warunkami z regulaminu.",
  affiliate_terms_reward_monthly: "Nagroda za klienta z planem miesięcznym",
  affiliate_terms_reward_yearly: "Nagroda za klienta z planem rocznym",
  affiliate_terms_amount_net: "{amount} netto",
  affiliate_terms_percent_yearly:
    "{percent}% tego, co klient zapłaci netto za pierwszy rok",
  affiliate_terms_percent_monthly:
    "{percent}% tego, co klient zapłaci netto za pierwsze 3 miesiące",
  affiliate_terms_discount: "Rabat dla klienta",
  affiliate_terms_discount_value:
    "{amount} na pierwszą płatność za subskrypcję",
  affiliate_terms_qualification: "Okres kwalifikacji",
  affiliate_terms_qualification_value:
    "{days} dni od pierwszej płatności klienta",
  affiliate_terms_payout: "Wypłata",
  affiliate_terms_payout_value:
    "Od {amount} netto, przelewem na podstawie Twojej faktury",
  affiliate_terms_own_tax_id:
    "Klient kupuje subskrypcję na własne dane i własny NIP. Konto opłacone na Twój NIP albo na NIP, który już płacił, nie daje nagrody.",
  affiliate_contact_title: "Twój opiekun w Calendesk",
  affiliate_contact_description:
    "Masz pytanie o warunki, klientów albo wypłaty? Napisz do swojego opiekuna.",
  affiliate_column_plan: "Plan",
  affiliate_column_source: "Źródło",
  affiliate_column_qualifies_at: "Data kwalifikacji",
  affiliate_plan_month: "Miesięczny",
  affiliate_plan_year: "Roczny",
  affiliate_source_link: "Link",
  affiliate_source_code: "Kod",
  affiliate_source_admin: "Dodane przez Calendesk",
  affiliate_rejection_cancelled_before_qualification:
    "Polecony klient zrezygnował przed końcem okresu kwalifikacji.",
  affiliate_rejection_refunded: "Płatność poleconego klienta została zwrócona.",
  affiliate_rejection_not_covered_by_payments:
    "Płatności netto klienta w okresie kwalifikacji były niższe niż nagroda.",
  affiliate_rejection_returning_customer:
    "Klient płacił już wcześniej za Calendesk (ten sam e-mail albo NIP).",
  affiliate_rejection_partner_account:
    "Konto należy do partnera Calendesk albo zostało opłacone na Twój NIP.",
  fakturownia_department_id_title: "ID działu",
  fakturownia_department_id_hint: "Zostaw puste, aby użyć domyślnego działu.",
  fakturownia_department_id_description:
    "Numeryczne ID działu w Fakturowni, który ma wystawiać faktury z Calendesk. Każdy dział może mieć własne dane sprzedawcy i własne domyślne uwagi — przydatne, gdy jedno konto Fakturowni obsługuje kilka kanałów sprzedaży (np. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Ustawienia dodatkowe",
  fakturownia_additional_settings_subtitle:
    "Te pola są opcjonalne i nie są wymagane do podstawowej integracji. Wypełnij je tylko wtedy, gdy chcesz dostosować sposób wystawiania faktur.",
  fakturownia_credentials_error:
    "Nie udało się połączyć z Fakturownią. Sprawdź API token i adres konta.",
  fakturownia_department_id_single_hint:
    "Twoje konto Fakturowni ma tylko jeden dział. Utwórz kolejny dział w Fakturowni, aby kierować do niego faktury z Calendesk.",
  fakturownia_department_id_no_results:
    "Nie znaleziono działów na tym koncie Fakturowni.",
  google_calendar_auth_error:
    "Nie udało się połączyć Kalendarza Google, ponieważ odmówiono dostępu lub nie przyznano wszystkich wymaganych uprawnień. Spróbuj ponownie i zezwól na dostęp do kalendarza.",
  outlook_calendar_auth_error:
    "Nie udało się połączyć kalendarza Outlook, ponieważ odmówiono dostępu lub nie przyznano wszystkich wymaganych uprawnień. Spróbuj ponownie i zezwól na dostęp do kalendarza.",
  gov_status_demo_ok: "Demo (zaakceptowana)",
  availability_status: "Status",
  availability_period: "Okres",
  availability_status_active: "Aktywny",
  availability_status_active_tooltip:
    "Grafik jest aktualnie aktywny i przypisany do co najmniej jednego pracownika lub usługi.",
  availability_status_planned: "Zaplanowany",
  availability_status_planned_tooltip:
    "Grafik stanie się aktywny w przyszłości na podstawie okresu przypisania.",
  availability_status_inactive: "Nieaktywny",
  availability_status_inactive_tooltip:
    "Grafik był aktywny w przeszłości, ale okres jego przypisania już się zakończył.",
  availability_status_unassigned: "Nieprzypisany",
  availability_status_unassigned_tooltip:
    "Grafik nie jest przypisany do żadnego pracownika ani usługi.",
  availability_period_none: "–",
  availability_period_indefinite: "Bezterminowo",
  availability_period_various: "Różne okresy",
  availability_period_no_start: "Od zawsze",
  availability_period_no_end: "Bezterminowo",
  availability_period_assigned_to: "Przypisano do",
  edit_schedule: "Edytuj grafik",
  services_and_categories: "Usługi i kategorie",
  included_in_selected_category: "Zawarta w wybranej kategorii",
  availability_schedule_color: "Kolor grafiku",
  availability_schedule_color_tooltip:
    "Kolor grafiku w podglądzie dostępności. Ustaw go, aby szybko odróżniać grafiki, gdy pracownik lub usługa ma ich kilka.",
  employee_color_tooltip:
    "Tym kolorem oznaczamy rezerwacje pracownika w kalendarzu. Ustaw go, aby łatwo rozpoznać, do kogo należy wizyta.",
  availability_period_from: "Data rozpoczęcia",
  availability_period_to: "Data zakończenia",
  availability_period_no_end_date: "Bez daty zakończenia",
  availability_period_no_start_date: "Bez daty rozpoczęcia",
  availability_period_days: "@{count} dni",
  availability_period_day_one: "1 dzień",
  availability_assign_type_locked:
    "Ten grafik jest już przypisany do pracowników albo usług. Nie można łączyć obu typów w jednym grafiku.",
  availability_overlap_title: "Nakładające się okresy",
  availability_schedules: "Grafiki dostępności",
  availability_calendar_preview: "Podgląd grafików",
  availability_calendar_select_target: "Wybierz cel, aby zobaczyć podgląd.",
  availability_calendar_no_schedule: "Brak grafiku",
  availability_calendar_day_off: "Dzień wolny",
  availability_exception_hours_prefilled:
    "Godziny skopiowane ze standardowego grafiku dla tego dnia tygodnia. Możesz je zmienić tylko dla tego wyjątku.",
  availability_schedule_created:
    "Grafik został utworzony. Przypisz go do pracowników lub usług, aby klienci mogli rezerwować terminy.",
  availability_exception_day_off:
    "Dzień wolny – na podstawie standardowego tygodnia. Dodaj godziny, aby udostępnić ten dzień.",
  availability_calendar_show_for: "Pokaż dostępność dla",
  availability_preview_info:
    "Podgląd pokazuje, który grafik obowiązuje w którym dniu i jakie godziny z niego wynikają. Wolne terminy dla klientów sprawdzisz w kalendarzu rezerwacji.",
  availability_view_team: "Plan zespołu",
  availability_view_year: "Rok",
  availability_view_month: "Miesiąc",
  availability_test_info:
    "Przetestuj dostępność tak, jak widzą ją klienci: wybierz lokalizację, usługę i pracownika. Wolne terminy pochodzą z tego samego mechanizmu co strona rezerwacji.",
  availability_test_location_online: "Online",
  availability_test_location_phone: "Telefon",
  availability_test_no_location: "Bez lokalizacji",
  availability_test_any_employee: "Dowolny pracownik",
  availability_test_variant: "Wariant",
  availability_view_day: "Dzień",
  availability_view_week: "Tydzień",
  availability_test_morning: "Rano",
  availability_test_afternoon: "Popołudnie",
  availability_test_evening: "Wieczór",
  availability_test_free_slots: "wolnych terminów",
  availability_test_available_employees: "dostępnych pracowników",
  availability_test_first_slot: "najbliższy termin",
  availability_test_no_slots: "Brak terminów",
  availability_test_none_short: "Brak",
  availability_test_pick_service: "Wybierz usługę, aby przetestować dostępność",
  availability_test_unbookable:
    "Klient nie zobaczy tu żadnej godziny. Sprawdź grafik pracownika w zakładce Podgląd grafików albo jego godziny pracy.",
  availability_test_week_hint:
    "Cały wiersz bez terminów oznacza pracownika niedostępnego przez cały tydzień.",
  availability_test_past_period:
    "Nie da się zarezerwować terminu w przeszłości. Wybierz dzisiejszą lub późniejszą datę.",
  availability_test_past_day: "Minął",
  availability_preview_profile_hours_info:
    "Ten pracownik nie ma przypisanego grafiku. Obowiązują godziny pracy ustawione w jego profilu (stara wersja grafiku pracy).",
  availability_preview_profile_hours_short: "Godziny pracy z profilu",
  availability_preview_service_fallback_info:
    "Ta usługa nie ma własnego grafiku. Terminy wynikają z grafików pracowników, którzy ją wykonują.",
  availability_preview_service_fallback_short: "Grafiki pracowników",
  previous_month: "Poprzedni miesiąc",
  next_month: "Następny miesiąc",
  availability_calendar_no_availability_hint:
    "Ten dzień jest poza grafikiem. Klienci nie zobaczą wolnych terminów.",
  availability_period_title: "Okres obowiązywania",
  availability_period_dialog_info:
    "Ustaw okres, w którym grafik obowiązuje dla tego przypisania. W obrębie jednego pracownika lub jednej usługi okresy grafików nie mogą się nakładać.",
  availability_set_period: "Ustaw okres obowiązywania",
  availability_timeline_caption_single:
    "Oś czasu grafików tego przypisania (@{year})",
  availability_timeline_caption_multi_employees:
    "Oś czasu dla @{count} wybranych pracowników (@{year})",
  availability_timeline_caption_multi_services:
    "Oś czasu dla @{count} wybranych usług (@{year})",
  availability_overlap_days: "Nakładające się dni",
  availability_today_short: "dziś",
  availability_schedule_label: "Grafik",
  availability_overlap_conflict_target:
    "„@{target}” ma już w tym czasie grafik „@{name}” (@{from} – @{to}).",
  availability_overlap_resolve_hint:
    "Zmień ten okres albo skróć okresy powyższych grafików, aby zapisać zmiany.",
  copy_suffix: "(kopia)",
  availability_schedule_duplicated: "Grafik został zduplikowany",
  availability_unassign_employees_first:
    "Najpierw usuń przypisanych pracowników",
  availability_unassign_services_first: "Najpierw usuń przypisane usługi",
  availability_schedule_timezone_differs_info:
    "Godziny w tym grafiku są w strefie czasowej @{timezone}, innej niż Twoja (@{user_timezone}). Przykładowo 09:00 w grafiku to u Ciebie @{example}.",
  availability_timezone_previous_day: "dzień wcześniej",
  availability_timezone_next_day: "dzień później",
  availability_timezone_differs_tooltip:
    "Ten grafik ma inną strefę czasową niż Twoja (@{timezone}).",
  employee_working_hours_timezone_info:
    "Te godziny są w strefie czasowej Twojej firmy (@{timezone}), innej niż Twoja (@{user_timezone}).",
  color_group_pastel: "Pastelowe",
  color_group_solid: "Pełne kolory",
  wb_settings_group_website: "Strona i SEO",
  wb_settings_group_booking: "Rezerwacje",
  wb_settings_group_client_account: "Konto klienta",
  wb_settings_group_header_footer: "Nagłówek i stopka",
  wb_settings_group_advanced: "Integracje i zaawansowane",
  wb_settings_filter: "Szukaj ustawienia",
  wb_settings_filter_empty: "Żadne ustawienie nie pasuje do wyszukiwania.",
  wb_hide_booking_prices: "Ukryj ceny w rezerwacjach klienta",
  wb_hide_booking_prices_tooltip:
    "Klient nie zobaczy cen na liście swoich rezerwacji po zalogowaniu.",
  wb_hide_payments: "Ukryj sekcję płatności na koncie klienta",
  wb_hide_payments_tooltip:
    "Po zalogowaniu klient nie zobaczy zakładki płatności, historii transakcji ani sekcji zapisanej karty.",
  wb_hide_profile_billing_data: "Ukryj dane do faktury na koncie klienta",
  wb_hide_profile_billing_data_tooltip:
    "Klient nie uzupełni danych do faktury w ustawieniach swojego konta. Formularze rejestracji i rezerwacji działają bez zmian.",
  wb_hide_profile_photo_upload: "Wyłącz zmianę zdjęcia profilowego",
  wb_hide_profile_photo_upload_tooltip:
    "Klient nie wgra własnego zdjęcia profilowego na swoim koncie.",
  wb_favicon_url_tooltip:
    "Ikona strony widoczna na karcie przeglądarki. Adres URL skopiujesz z galerii zdjęć: kliknij podgląd obrazka, a na dole zobaczysz jego adres.",
  wb_og_image_url_tooltip:
    "Obrazek widoczny, gdy ktoś udostępni link do Twojej strony, np. na Facebooku (og:image). Adres URL skopiujesz z galerii zdjęć: kliknij podgląd obrazka, a na dole zobaczysz jego adres.",
  wb_newsletter_success_url_tooltip:
    "Adres, na który przeniesiemy klienta po zapisie do newslettera. Puste pole zostawia klienta na stronie.",
  wb_account_activation_success_url_tooltip:
    "Adres, na który trafi klient po kliknięciu linku aktywacyjnego z maila.",
  wb_section_group_content: "Treść",
  wb_section_group_offer: "Oferta",
  wb_section_group_booking_flow: "Przebieg rezerwacji",
  wb_section_group_form: "Formularz",
  wb_section_group_account: "Konto klienta",
  wb_section_group_menu: "Strony i nawigacja",
  wb_section_group_company: "Dane firmy i social media",
  wb_section_group_images: "Zdjęcia i galeria",
  wb_section_group_map: "Mapa",
  wb_section_group_appearance: "Wygląd",
  wb_section_group_other: "Pozostałe",
  wb_section_group_booking_form: "Formularz rezerwacji",
  html_editor_tooltip_fullscreen: "Pełny ekran",
  html_editor_tooltip_fullscreen_exit: "Zamknij pełny ekran",
  wb_setting_tooltip_help_link: "Kliknij, aby otworzyć poradnik",
  wb_enable_discounts_tooltip:
    "Przy płatności za rezerwację, subskrypcję lub produkt klient zobaczy pole na kod rabatowy. Same kody tworzysz w Stripe, w sekcji kuponów.",
  wb_enable_discounts_tooltip_url:
    "https://calendesk.com/pl/help/jak-stworzyc-kody-rabatowe",
  wb_hide_booking_employees_tooltip:
    "Klient w ogóle nie zobaczy nazwisk pracowników podczas rezerwacji, wybierze tylko usługę i termin. To ustawienie dotyczy samej strony, więc sprawdź też szablony powiadomień w panelu Calendesk i usuń z nich dane pracownika, jeśli klient nie ma ich widzieć.",
  wb_hide_time_zone_tooltip:
    "Klient nie zobaczy przy kalendarzu przełącznika strefy czasowej. Godziny pokaże mu się w strefie wykrytej z jego przeglądarki, a gdy ta nie jest obsługiwana, w strefie Twojej firmy (@{timeZone}).",
  gdpr_fields: "Zgody klienta",
  gdpr_field_required: "zgoda obowiązkowa",
  wb_account_title_tooltip:
    "Nagłówek nad linkami do konta klienta w stopce strony. Pod nim klient widzi logowanie i rejestrację, a po zalogowaniu swoje rezerwacje i ustawienia.",
  wb_align_center_tooltip:
    "Ustawia treść sekcji na środku jej wysokości, zamiast przy górnej krawędzi. Różnicę zobaczysz głównie w wysokich sekcjach z krótkim tekstem.",
  wb_any_employee_enabled_tooltip:
    "Zaznaczone: krok wyboru pracownika wypełnia się sam opcją „dowolna osoba” i klient od razu przechodzi do wyboru terminu, a przyciskiem „Zmień” nadal może wskazać konkretną osobę. Odznaczone: klient sam wybiera osobę z listy, na której „dowolna osoba” jest pierwszą opcją.",
  wb_book_now_label_tooltip:
    "Twój własny tekst na przycisku, który klient klika, żeby potwierdzić wybrany termin. Jeśli zostawisz pole puste, przycisk pokaże standardowy napis „Zarezerwuj”.",
  wb_booking_dynamic_form_tooltip:
    "Dodaj własne pytania do formularza rezerwacji, np. uwagi albo załącznik. Każde pole możesz przypisać do wybranych usług, wtedy klient zobaczy je tylko przy rezerwacji tych usług.",
  wb_button_tooltip:
    "Przycisk w tej sekcji. Ustaw jego napis i stronę, na którą klient trafi po kliknięciu.",
  wb_button_size_tooltip:
    "Wielkość przycisków w górnym pasku strony. Wybierz od XS (bardzo małe) do XL (bardzo duże).",
  wb_buttons_tooltip:
    "Przyciski wyświetlane w tej sekcji. Każdy z nich ma własny napis i prowadzi klienta na wybraną przez Ciebie stronę.",
  wb_buttons_position_tooltip:
    "Określa, gdzie w sekcji stoją przyciski: przy lewej krawędzi, na środku albo przy prawej.",
  wb_calendar_max_date_tooltip:
    "Klient może przeglądać i rezerwować terminy najpóźniej do wybranego dnia. Dalszych dat kalendarz w ogóle nie pokaże.",
  wb_calendar_min_date_tooltip:
    "Klient zobaczy wolne terminy dopiero od wybranego dnia. Wcześniejszych dat nie da się przeglądać ani rezerwować, przydatne np. przy otwarciu zapisów od konkretnej daty.",
  wb_color_bg_tooltip:
    "Kolor tła większości sekcji na stronie. Sekcje z włączoną opcją „Odwróć kolory” używają zamiast niego drugiego tła.",
  wb_color_bg_2_tooltip:
    "Zapasowy kolor tła. Widać go w sekcjach z włączoną opcją „Odwróć kolory”, dzięki czemu możesz przeplatać na stronie dwa kolory tła.",
  wb_color_primary_tooltip:
    "Główny kolor Twojej strony. Zobaczysz go na przyciskach, linkach i wyróżnionych elementach, na przykład w kalendarzu rezerwacji.",
  wb_color_text_tooltip:
    "Kolor tekstu w sekcjach z pierwszym tłem. Wybierz taki, który wyraźnie odróżnia się od koloru tła, inaczej tekst będzie słabo czytelny.",
  wb_color_text_2_tooltip:
    "Kolor tekstu w sekcjach z drugim tłem. Zadbaj o wyraźny kontrast z kolorem drugiego tła.",
  wb_column_width_tooltip:
    "Jaką część szerokości sekcji zajmuje jedna opinia na komputerze. Podaj procent, na przykład 50 to dwie opinie obok siebie, 33 to trzy. Na telefonach opinie zawsze zajmują całą szerokość.",
  wb_company_address_tooltip:
    "Adres Twojej firmy pokazywany w stopce strony w części kontaktowej.",
  wb_company_email_tooltip:
    "Adres e-mail w stopce strony. Po kliknięciu klientowi otworzy się nowa wiadomość zaadresowana do Ciebie.",
  wb_company_name_tooltip:
    "Nazwa Twojej firmy pokazywana na górnym pasku strony. Wpisz ją tak, jak mają ją widzieć klienci.",
  wb_company_phone_tooltip:
    "Numer telefonu w stopce strony. Klient może w niego kliknąć na telefonie, aby od razu do Ciebie zadzwonić.",
  wb_company_slogan_tooltip:
    "Krótkie hasło Twojej firmy widoczne pod logo w sekcji rezerwacji. Jedno zdanie, które mówi klientowi, czym się zajmujesz.",
  wb_container_fluid_tooltip:
    "Rozciąga treść sekcji na całą szerokość okna przeglądarki. Wyłączone: treść trzyma się węższej kolumny na środku, co zwykle wygląda spokojniej na dużych ekranach.",
  wb_count_places_in_dates_tooltip:
    "Przy usługach grupowych klient zobaczy przy dacie łączną liczbę wolnych miejsc, a nie liczbę wolnych godzin. Działa tylko dla usług, w których może uczestniczyć więcej niż jedna osoba.",
  wb_custom_code_tooltip:
    "Miejsce na własny kod, np. skrypt czatu, statystyk lub piksela reklamowego. Wklejony kod działa na wszystkich podstronach. To opcja dla zaawansowanych.",
  wb_cycle_tooltip:
    "Zdjęcia w galerii przesuwają się same, bez klikania. Jak szybko, ustawisz w polu „Szybkość zmiany”.",
  wb_dark_mode_tooltip:
    "Przełącza całą stronę na ciemną kolorystykę. Dobierz do niej ciemne tła i jasne kolory tekstu, żeby wszystko było czytelne.",
  wb_date_label_tooltip:
    "Twój własny podpis na polu, w którym klient wybiera dzień rezerwacji, np. „Wybierz dzień wizyty”.",
  wb_description_tooltip:
    "Tekst wyświetlany pod nagłówkiem sekcji. Opisz tu krótko, co oferujesz lub co klient znajdzie w tej części strony.",
  wb_elevation_tooltip:
    "Siła cienia pod górnym paskiem strony, od 0 (brak cienia) do 24 (mocny cień). Cień wizualnie oddziela pasek od treści strony.",
  wb_email_form_success_url_tooltip:
    "Po wysłaniu formularza klient trafi pod podany adres, np. na stronę z podziękowaniem. Gdy go ustawisz, wiadomość o wysłaniu formularza nie będzie pokazywana.",
  wb_email_sent_tooltip:
    "Tekst, który pojawi się w miejscu formularza po jego wysłaniu, np. „Dziękujemy, odezwiemy się wkrótce”. Nie zobaczy go klient, którego przekierowujesz na inny adres.",
  wb_email_subject_tooltip:
    "Ten tekst zobaczysz jako temat e-maila z odpowiedziami z formularza. Ustaw coś rozpoznawalnego, np. „Zapytanie ze strony”, żeby łatwo znaleźć te wiadomości w skrzynce.",
  wb_employee_info_label_tooltip:
    "Krótki tekst wyświetlany nad listą pracowników, np. „Wybierz osobę, do której chcesz się umówić”. Pojawia się tylko wtedy, gdy klient ma kogo wybierać, czyli usługę wykonuje więcej niż jedna osoba.",
  wb_employee_label_tooltip:
    "Twój własny podpis na rozwijanej liście, z której klient wybiera pracownika, np. „Specjalista” albo „Terapeuta”.",
  wb_employee_list_tooltip:
    "Wybierz, którzy pracownicy mają być widoczni w tej sekcji strony. Klient zobaczy tylko zaznaczone osoby, w kolejności z listy.",
  wb_employee_search_tooltip:
    "Nad listą pracowników pojawi się pole do wyszukiwania po nazwisku. Klient zobaczy je dopiero wtedy, gdy pracowników na liście jest co najmniej pięciu.",
  wb_end_calendar_time_tooltip:
    "Ostatnia godzina widoczna w kalendarzu tygodniowym na stronie. Terminy po tej godzinie nie będą wyświetlane, ustaw ją tak, żeby obejmowała godziny pracy.",
  wb_expand_collapse_service_panels_tooltip:
    "Lista usług będzie zwinięta do kategorii, a klient rozwinie interesującą go grupę jednym kliknięciem. Przydatne, gdy masz dużo usług i długa lista robi się nieczytelna.",
  wb_facebook_tooltip:
    "Link do Twojego profilu na Facebooku. Gdy go wpiszesz, na stronie pojawi się ikona Facebooka prowadząca do profilu.",
  wb_features_tooltip:
    "Lista elementów pokazywanych w tej sekcji jako kafelki, np. zalety Twojej oferty albo opinie klientów. Każdy element ma swój tytuł, opis i obrazek.",
  wb_forgotten_password_confirmation_modal_tooltip:
    "Ustawienia komunikatu, który klient widzi po wysłaniu prośby o nowe hasło. Potwierdza on, że link do zmiany hasła poszedł na podany e-mail.",
  wb_forgotten_password_modal_tooltip:
    "Ustawienia okna, w którym klient podaje swój e-mail, żeby ustawić nowe hasło do konta klienta.",
  wb_forgotten_password_modal_confirmation_subtitle_tooltip:
    "Treść komunikatu po wysłaniu maila ze zmianą hasła. Powiedz klientowi, że link jest w jego skrzynce i co zrobić, jeśli mail nie dotarł.",
  wb_forgotten_password_modal_confirmation_title_tooltip:
    "Nagłówek komunikatu, który klient widzi po wysłaniu prośby o nowe hasło, np. „Sprawdź swoją skrzynkę”.",
  wb_forgotten_password_subtitle_tooltip:
    "Tekst pod nagłówkiem okna zmiany hasła. Wyjaśnij klientowi, że po podaniu e-maila dostanie link do ustawienia nowego hasła.",
  wb_forgotten_password_title_tooltip:
    "Nagłówek okna, w którym klient prosi o zmianę hasła. Napisz krótko, np. „Nie pamiętasz hasła?”",
  wb_form_tooltip:
    "Ułóż pola formularza kontaktowego, np. pole na wiadomość, e-mail czy załącznik. Wszystko, co klient wpisze, dostaniesz e-mailem.",
  wb_form_position_tooltip:
    "Wybierz, po której stronie sekcji stoi formularz: po lewej czy po prawej. Na telefonie ta sama opcja decyduje o kolejności: „po lewej” pokaże formularz nad treścią, „po prawej” pod nią.",
  wb_gallery_distance_tooltip:
    "Odstęp między zdjęciami w galerii, w pikselach. Sensowny zakres to 0 do 50. Im większy odstęp, tym węższe robią się zdjęcia.",
  wb_gallery_height_tooltip:
    "Wysokość galerii w pikselach, na przykład 200 to niski pasek, 500 to duża galeria. Wszystkie zdjęcia dopasują się do tej wysokości.",
  wb_gallery_image_number_tooltip:
    "Ile zdjęć widać obok siebie na komputerze, zanim galeria przewinie się dalej. Zwykle sprawdza się od 1 do 4.",
  wb_gallery_mobile_image_number_tooltip:
    "Ile zdjęć widać obok siebie na telefonie. Na małym ekranie najlepiej zostawić 1, najwyżej 2.",
  wb_gallery_style_tooltip:
    "Wygląd sterowania galerią. Styl 1 kładzie strzałki i kropki na zdjęciach, styl 2 umieszcza je pod galerią, styl 3 działa jak 1, ale bez ciemnego paska pod kropkami.",
  wb_gallery_width_tooltip:
    "Jaką część szerokości sekcji zajmuje galeria na komputerze. Podaj procent od 10 do 100, na przykład 50 to połowa szerokości. Na telefonach galeria zawsze zajmuje całość.",
  wb_gdpr_fields_tooltip:
    "Dodaj zgody, które klient zaznacza przy zakładaniu konta, np. zgodę marketingową. Każdą możesz oznaczyć jako obowiązkową. Treść zgody i decyzję klienta zapisujemy przy jego koncie.",
  wb_google_tag_id_tooltip:
    "Identyfikator Twojego kontenera Google Tag Manager, np. GTM-XXXXXX. Po jego wpisaniu zbierzesz statystyki odwiedzin i podepniesz narzędzia Google.",
  wb_height_tooltip:
    "Wysokość sekcji w pikselach, na przykład 400 to niska sekcja, 700 to sekcja na większość ekranu. Gdy treści jest więcej, sekcja sama się powiększy.",
  wb_hide_arrows_tooltip:
    "Chowa strzałki do przewijania galerii. Włącz, gdy zdjęcia mają się zmieniać tylko automatycznie.",
  wb_hide_booking_time_to_tooltip:
    "Klient zobaczy tylko godzinę rozpoczęcia wizyty, bez godziny zakończenia i czasu trwania. Przydatne, gdy faktyczny czas usługi bywa inny niż ten ustawiony w systemie.",
  wb_hide_delimiters_tooltip:
    "Chowa kropki pod galerią, którymi można przeskoczyć do wybranego zdjęcia. Galeria wygląda wtedy czyściej.",
  wb_hide_footer_tooltip:
    "Ukrywa stopkę na dole wszystkich podstron, razem z danymi kontaktowymi i ikonami social media.",
  wb_hide_header_tooltip:
    "Ukrywa górny pasek strony z logo i menu na wszystkich podstronach. Przydatne, gdy stronę osadzasz w innej witrynie.",
  wb_hide_login_tooltip:
    "Wyłącza logowanie na całej stronie. Klient nie zobaczy przycisków logowania ani sekcji dostępnych po zalogowaniu, wszystko załatwi bez konta klienta.",
  wb_hide_signup_tooltip:
    "Wyłącza zakładanie nowych kont klienta. Klienci, którzy już mają konto, nadal mogą się logować, ale nikt nowy się nie zarejestruje.",
  wb_html_code_tooltip:
    "Własny kod HTML wyświetlany jako treść tej sekcji. Skorzystaj z niego, gdy gotowe sekcje nie wystarczają i chcesz wstawić coś swojego.",
  wb_image_contain_tooltip:
    "Pokazuje całe zdjęcie bez przycinania, nawet jeśli obok zostaną puste marginesy. Wyłączone: zdjęcie wypełnia całą ramkę, ale jego brzegi mogą zostać ucięte.",
  wb_image_height_tooltip:
    "Wysokość zdjęcia w pikselach, na przykład 200. Zdjęcie zostanie dopasowane do tej wysokości.",
  wb_image_hide_tooltip:
    "Wyłącza zdjęcie w tej sekcji na wszystkich urządzeniach. Treść zajmie zwolnione miejsce.",
  wb_image_hide_on_mobile_tooltip:
    "Chowa zdjęcie tylko na telefonach, żeby nie zabierało miejsca na małym ekranie. Na komputerze zdjęcie zostaje.",
  wb_image_margin_bottom_tooltip:
    "Pusty odstęp pod zdjęciem, w pikselach. Sensowny zakres to 0 do 50. Większa wartość odsuwa tekst od zdjęcia.",
  wb_image_position_tooltip:
    "Miejsce zdjęcia względem treści sekcji: po lewej, po prawej albo na środku, u góry albo na dole.",
  wb_image_rounded_tooltip:
    "Jak mocno zaokrąglone są rogi zdjęcia: od ostrych rogów, przez lekkie zaokrąglenie, po pełne koło. Koło dobrze wygląda przy zdjęciach osób.",
  wb_image_to_right_tooltip:
    "Przenosi zdjęcie na prawą stronę tekstu. Widoczne na komputerach; na telefonach zdjęcie i tekst zawsze układają się jedno pod drugim.",
  wb_image_width_tooltip:
    "Szerokość zdjęcia w pikselach, maksymalnie 1200. Na telefonach zdjęcie zawsze wypełnia całą szerokość ekranu.",
  wb_image_zoom_on_click_tooltip:
    "Po kliknięciu zdjęcie z galerii otwiera się w powiększeniu na całym ekranie. Klient może obejrzeć szczegóły.",
  wb_init_calendar_title_tooltip:
    "Nagłówek ekranu, na którym klient wybiera usługę, np. „Co chcesz zarezerwować?”. Znika, gdy klient wybierze usługę.",
  wb_initial_location_select_tooltip:
    "W polu lokalizacji będzie od razu ustawiona pierwsza dostępna lokalizacja, klient może ją zmienić. Po wyłączeniu klient musi sam wybrać lokalizację, zanim zobaczy wolne terminy.",
  wb_initial_service_selection_tooltip:
    "Przed kalendarzem klient wybierze usługę na osobnym ekranie, z listą pogrupowaną w kategorie. Przy jednej usłudze bez wariantów ekran się nie pojawia.",
  wb_instagram_tooltip:
    "Link do Twojego profilu na Instagramie. Gdy go wpiszesz, na stronie pojawi się ikona Instagrama prowadząca do profilu.",
  wb_interval_tooltip:
    "Co ile galeria sama zmienia zdjęcie, w milisekundach. 1000 to jedna sekunda; zwykle dobrze działa 4000 do 8000. Wymaga włączonej opcji „Przełączanie automatyczne”.",
  wb_interval_minutes_tooltip:
    "Co ile minut kalendarz tygodniowy rysuje kolejne wiersze z godzinami, np. co 15 lub co 30 minut. Mniejsza wartość to gęstsza siatka i dokładniejszy widok dnia.",
  wb_invert_colors_tooltip:
    "Zamienia w tej sekcji kolory: tło pierwsze staje się drugim, a kolor tekstu odpowiednio się dopasowuje. Dzięki temu sekcja odróżnia się od sąsiednich.",
  wb_latitude_tooltip:
    "Pierwsza z dwóch liczb wskazujących miejsce na mapie, np. 52.2297. Otwórz Mapy Google, kliknij swoje miejsce prawym przyciskiem myszy, a na samej górze menu zobaczysz obie liczby; kliknięcie w nie kopiuje je do schowka. Wpisz tutaj pierwszą, z kropką zamiast przecinka.",
  wb_linkedin_tooltip:
    "Link do Twojego profilu na LinkedIn. Gdy go wpiszesz, na stronie pojawi się ikona LinkedIn prowadząca do profilu.",
  wb_location_search_tooltip:
    "Nad listą lokalizacji pojawi się pole do wyszukiwania po nazwie. Klient zobaczy je dopiero wtedy, gdy lokalizacji na liście jest co najmniej pięć.",
  wb_login_modal_tooltip:
    "Ustawienia okna, w którym klient loguje się na swoje konto klienta. Tu zmienisz teksty widoczne w tym oknie.",
  wb_login_subtitle_tooltip:
    "Krótki tekst, który klient widzi u góry okna logowania, zaraz pod tytułem. Możesz tu np. przywitać klienta albo wyjaśnić, po co jest konto.",
  wb_longitude_tooltip:
    "Druga z liczb skopiowanych z Map Google, np. 21.0122, czyli ta po przecinku. Wpisz ją z kropką zamiast przecinka.",
  wb_main_pages_number_tooltip:
    "Ustal, ile stron pokaże się w górnym menu jako osobne przyciski. Pozostałe strony klient znajdzie w rozwijanej liście obok.",
  wb_map_maker_hide_tooltip:
    "Chowa czerwoną pinezkę wskazującą Twoją lokalizację. Mapa nadal się wyświetla, tylko bez oznaczenia miejsca.",
  wb_menu_column_1_tooltip:
    "Strony pokazywane w pierwszej kolumnie linków w stopce. Klient przejdzie do nich jednym kliknięciem.",
  wb_menu_column_2_tooltip:
    "Strony pokazywane w drugiej kolumnie linków w stopce, obok pierwszej.",
  wb_menu_title_tooltip:
    "Nagłówek nad listą linków w stopce, np. „Na skróty” albo „Menu”. Klient widzi go nad pierwszą kolumną stron.",
  wb_more_pages_button_tooltip:
    "Napis na przycisku rozwijającym dodatkowe strony w górnym menu, gdy nie wszystkie mieszczą się jako osobne zakładki.",
  wb_newsletter_input_placeholder_tooltip:
    "Tekst widoczny w pustym polu na adres e-mail w sekcji newslettera, np. „Twój adres e-mail”. Podpowiada klientowi, co ma wpisać.",
  wb_newsletter_success_message_tooltip:
    "Ten komunikat pojawi się na stronie, gdy klient zapisze się na newsletter, np. „Sprawdź skrzynkę i potwierdź zapis”. Klient dostaje wtedy e-mail z linkiem do potwierdzenia.",
  wb_only_services_with_subscriptions_tooltip:
    "Klient zobaczy tylko usługi ze swojej aktywnej subskrypcji. Uwaga: bez subskrypcji i po wylogowaniu lista jest pusta.",
  wb_page_list_tooltip:
    "Wybierz, które strony pojawią się jako pozycje menu. Klient zobaczy je w podanej tu kolejności.",
  wb_primary_language_tooltip:
    "Język, w którym klienci zobaczą Twoją stronę, np. przyciski, formularze i widok rezerwacji.",
  wb_privacy_policy_page_tooltip:
    "Wskaż stronę z polityką prywatności. Klient otworzy ją, klikając link w informacji wyświetlanej przy zakładaniu konta.",
  wb_redirect_after_login_tooltip:
    "Wybierz stronę, na którą klient trafi zaraz po zalogowaniu, np. stronę z rezerwacją wizyty.",
  wb_redirect_after_signup_tooltip:
    "Wybierz stronę, na którą klient trafi zaraz po założeniu konta, np. stronę z rezerwacją wizyty.",
  wb_redirect_logo_tooltip:
    "Wybierz stronę, która otworzy się po kliknięciu logo w górnym menu. Zwykle jest to strona główna.",
  wb_regulations_page_tooltip:
    "Wskaż stronę z regulaminem. Klient otworzy ją, klikając link w informacji o akceptacji regulaminu przy zakładaniu konta.",
  wb_require_billing_data_tooltip:
    "Klient musi podać dane do faktury, żeby dokończyć rezerwację. Działa tylko wtedy, gdy masz włączone pokazywanie danych do faktury w formularzu.",
  wb_require_phone_number_tooltip:
    "Klient nie dokończy rezerwacji bez podania numeru telefonu. Działa tylko wtedy, gdy pole telefonu jest widoczne w formularzu.",
  wb_section_text_tooltip:
    "Tekst widoczny w sekcji z formularzem. Wyjaśnij w nim klientowi, po co jest formularz i co się stanie po jego wysłaniu.",
  wb_select_date_hour_tooltip:
    "Twój własny tekst wyświetlany nad kalendarzem z wolnymi terminami, np. „Wybierz dogodny termin wizyty”.",
  wb_select_date_title_label_tooltip:
    "Nagłówek nad kalendarzem w kroku, w którym klient wybiera dzień i godzinę wizyty, np. „Wybierz termin”.",
  wb_select_employees_title_label_tooltip:
    "Nagłówek nad listą pracowników w kroku, w którym klient wybiera osobę, np. „Do kogo chcesz się umówić?”.",
  wb_select_locations_title_label_tooltip:
    "Nagłówek nad listą lokalizacji w kroku, w którym klient wybiera miejsce wizyty, np. „Gdzie chcesz się umówić?”.",
  wb_select_services_title_label_tooltip:
    "Nagłówek nad listą usług w kroku, w którym klient wybiera usługę, np. „Wybierz usługę”.",
  wb_selected_services_tooltip:
    "Nagłówek nad listą terminów, które klient dodał do koszyka, np. „Twoje wybrane wizyty”. Widoczny tylko przy włączonym koszyku rezerwacji.",
  wb_selection_order_tooltip:
    "Ustalasz, w jakiej kolejności klient przechodzi kroki rezerwacji: usługa, lokalizacja, pracownik. Przy kilku lokalizacjach warto zacząć właśnie od nich.",
  wb_separate_online_locations_tooltip:
    "Klient wybierze konkretny komunikator: Google Meet, Zoom, Teams albo WhatsApp. Bez tej opcji zobaczy jedną pozycję „online” dla wszystkich spotkań zdalnych.",
  wb_service_label_tooltip:
    "Twój własny podpis na rozwijanej liście, z której klient wybiera usługę, np. „Konsultacja” albo „Rodzaj wizyty”.",
  wb_service_list_tooltip:
    "Zostaw puste, a sekcja pokaże wszystkie Twoje usługi, razem z tymi, które dodasz później. Gdy wybierzesz konkretne usługi, każdą nową trzeba będzie dopisać tutaj.",
  wb_service_search_tooltip:
    "Nad listą usług pojawi się pole do wyszukiwania po nazwie. Klient zobaczy je dopiero wtedy, gdy usług na liście jest co najmniej pięć.",
  wb_show_active_button_tooltip:
    "Podświetla w górnym menu nazwę strony, na której klient właśnie jest, żeby łatwiej mu było się odnaleźć.",
  wb_show_billing_data_tooltip:
    "Klient zobaczy w formularzu opcję podania danych do faktury, jako firma lub osoba prywatna. Sam decyduje, czy chce je uzupełnić, chyba że dodatkowo ustawisz je jako wymagane.",
  wb_show_booked_slots_tooltip:
    "Zajęte godziny pozostaną widoczne w kalendarzu jako przekreślone i nie da się ich kliknąć. Klient widzi wtedy, że dany dzień jest oblegany, zamiast pustej listy godzin.",
  wb_show_company_name_tooltip:
    "Zdecyduj, czy obok logo na górnym pasku ma być widoczna nazwa Twojej firmy. Wyłącz, jeśli wystarczy samo logo.",
  wb_show_expand_collapse_button_tooltip:
    "Gdy dzień ma dużo wolnych godzin, klient zobaczy tylko sześć pierwszych i przycisk do rozwinięcia reszty. Lista robi się dzięki temu krótsza i czytelniejsza.",
  wb_show_name_surname_tooltip:
    "Gdy włączysz, klient poda imię i nazwisko przy rezerwacji. Gdy wyłączysz, pola znikną i wystarczy sam e-mail.",
  wb_show_phone_number_tooltip:
    "Gdy włączysz, w formularzu rezerwacji pojawi się pole na numer telefonu. Przyda Ci się, jeśli dzwonisz do klientów albo wysyłasz SMS-y.",
  wb_show_remind_password_link_tooltip:
    "Po włączeniu klient zobaczy na stronie logowania link do przypomnienia hasła. Kliknięcie otwiera okno, w którym poda e-mail i dostanie link do nowego hasła.",
  wb_show_service_column_tooltip:
    "Obok kalendarza klient zobaczy panel z podsumowaniem wybranej usługi: nazwą, ceną i czasem trwania. Po wyłączeniu zostaje sam kalendarz z terminami.",
  wb_show_service_description_tooltip:
    "Pod wybraną usługą klient zobaczy jej opis z panelu Calendesk. Dłuższe opisy są skracane, a pełną treść klient rozwinie linkiem „Pokaż więcej”.",
  wb_show_sign_in_button_tooltip:
    "Pokazuje w górnym menu przycisk, którym klient otwiera okno logowania na swoje konto klienta. Widzą go tylko osoby niezalogowane.",
  wb_show_sign_up_button_tooltip:
    "Pokazuje w górnym menu przycisk, którym klient otwiera okno zakładania konta klienta. Widzą go tylko osoby niezalogowane.",
  wb_sign_in_button_tooltip:
    "Tekst i wygląd przycisku logowania w górnym menu. Zmienisz tu np. napis na przycisku i jego styl.",
  wb_sign_up_button_tooltip:
    "Tekst i wygląd przycisku zakładania konta w górnym menu. Zmienisz tu np. napis na przycisku i jego styl.",
  wb_sign_up_modal_tooltip:
    "Ustawienia okna, w którym klient zakłada konto klienta. Tu włączysz m.in. informację o regulaminie i dane do faktury.",
  wb_sign_up_terms_info_tooltip:
    "Klient zobaczy przy rejestracji informację, że zakładając konto akceptuje regulamin i politykę prywatności. Wskaż niżej obie strony, bo bez tego linki w tej informacji nie będą działać.",
  wb_start_calendar_time_tooltip:
    "Pierwsza godzina widoczna w kalendarzu tygodniowym na stronie. Wcześniejsze godziny nie będą wyświetlane, ustaw ją na początek dnia pracy.",
  wb_subtitle_tooltip:
    "Krótki dopisek pod tytułem sekcji. Dobre miejsce na jedno zdanie, które rozwija myśl z nagłówka.",
  wb_summary_headline_tooltip:
    "Nagłówek okna, które klient widzi zaraz po udanej rezerwacji, np. „Dziękujemy za rezerwację!”.",
  wb_summary_text_tooltip:
    "Tekst w oknie potwierdzenia rezerwacji, pod nagłówkiem. Powiedz klientowi, co dalej, np. że dostanie e-mail z potwierdzeniem.",
  wb_text_tooltip:
    "Główny tekst tej sekcji. Możesz go formatować, np. pogrubiać i dodawać listy.",
  wb_text_hide_tooltip:
    "Chowa tekst wyświetlany obok formularza. Formularz zajmie wtedy więcej miejsca.",
  wb_text_margin_bottom_tooltip:
    "Pusty odstęp pod tekstem opinii, w pikselach. Sensowny zakres to 0 do 50.",
  wb_tiktok_tooltip:
    "Link do Twojego profilu na TikToku. Gdy go wpiszesz, na stronie pojawi się ikona TikToka prowadząca do profilu.",
  wb_title_tooltip:
    "Główny tytuł tej sekcji. Klient widzi go jako duży napis u góry sekcji.",
  wb_twitter_tooltip:
    "Link do Twojego profilu w serwisie X (dawniej Twitter). Gdy go wpiszesz, na stronie pojawi się ikona X prowadząca do profilu.",
  wb_use_booking_cart_tooltip:
    "Klient będzie mógł dodać do koszyka kilka terminów, także różnych usług, i zarezerwować wszystkie naraz jednym potwierdzeniem. Bez koszyka każda wizyta jest rezerwowana osobno.",
  wb_view_flat_tooltip:
    "Usuwa cień z okienek rezerwacji, przez co wyglądają płasko i minimalistycznie. Wyłączone: okienka mają delikatny cień.",
  wb_view_rounded_tooltip:
    "Jak mocno zaokrąglone są rogi okienek rezerwacji i kalendarza: od ostrych rogów po mocne zaokrąglenie.",
  wb_website_description_tooltip:
    "Opis Twojej strony dla wyszukiwarek, np. Google. Klient zobaczy go pod nazwą strony w wynikach wyszukiwania i przy udostępnianiu linku, ale nie na samej stronie.",
  wb_youtube_tooltip:
    "Link do Twojego kanału na YouTube. Gdy go wpiszesz, na stronie pojawi się ikona YouTube prowadząca do kanału.",
  wb_zoom_tooltip:
    "Jak blisko mapa jest przybliżona, w skali od 1 do 20. Wartość 12 pokazuje całe miasto, 16 pokazuje ulicę i okolicę.",
  custom_duration_value: "Inna wartość…",
  payment_authentication_failed_error:
    "Twój bank nie potwierdził płatności. Spróbuj jeszcze raz i dokończ potwierdzenie w aplikacji banku. Jeśli to się powtórzy, wybierz inną kartę lub napisz do nas na czacie.",
  insufficient_funds_error:
    "Na karcie zabrakło środków, więc bank odrzucił płatność. Doładuj konto albo użyj innej karty i spróbuj jeszcze raz.",
  card_declined_error:
    "Bank odrzucił płatność tą kartą. Użyj innej karty albo zapytaj w banku o powód. Jeśli potrzebujesz pomocy, napisz do nas na czacie.",
  wb_auto_save_short: "Autozapis",
  wb_save_status_saving: "Zapisywanie...",
  wb_save_status_saved_at: "Zapisano o @{time}",
  wb_save_status_error: "Nie udało się zapisać zmian",
  wb_save_retry: "Ponów",
  wb_change_history: "Historia zmian",
  wb_step_generic: "Zmiana ustawień",
  wb_step_moved_section: "Przeniesiono sekcję",
  wb_step_added_section: "Dodano sekcję",
  wb_step_added_page: "Dodano podstronę",
  wb_step_updated_page: "Zmieniono podstronę",
  wb_booking_dynamic_form: "Pola formularza rezerwacji",
  wb_form: "Pola formularza",
  wb_buttons: "Przyciski",
  wb_buttons_position: "Pozycja przycisków",
  wb_form_position: "Pozycja formularza",
  wb_image_position: "Pozycja zdjęć",
  hide_client_facing_ids_checkbox:
    "Ukryj numery ID rezerwacji i transakcji przed klientami",
  hide_client_facing_ids_tooltip:
    "<b>Jakie numery ukrywamy?</b><br>Numery rezerwacji, subskrypcji, zakupionych produktów, transakcji i płatności.<br><br><b>Gdzie klient ich nie zobaczy?</b><br>• w potwierdzeniu rezerwacji na stronie www<br>• w panelu klienta: rezerwacje, płatności, subskrypcje<br>• w domyślnych powiadomieniach e-mail<br>• na stronie płatności Stripe<br>• w nazwach pozycji na fakturze (sam numer faktury zostaje)<br><br>W panelu administracyjnym zawsze widzisz wszystkie numery. Jeśli sam dodasz numer rezerwacji do własnego szablonu powiadomienia, nadal będzie działał.",
  variable_employee_title: "Stanowisko pracownika",
  employee_example_title: "Starszy specjalista",
  news: "Aktualności",
  no_news_yet: "Brak aktualności",
  mark_all_news_as_read: "Oznacz wszystkie jako przeczytane",
  news_read_more: "Czytaj więcej",
  menu: "Menu",
  news_unread_tooltip: "Aktualności - nieprzeczytane: @{amount}",
  news_intro_title: "Nowość: aktualności",
  news_intro_text:
    "Od teraz wszystkie zmiany w Calendesk i nowości znajdziesz pod tym dzwonkiem.",
  spotlight_got_it: "Rozumiem",
  mobile_menu_intro_title: "Nowość: dolne menu",
  mobile_menu_intro_text:
    "Menu, kalendarz, dodawanie rezerwacji, sprzedaż i klienci są teraz na dolnym pasku.",
  merge_clients_title: "Scal klientów",
  merge_clients_single_title: "Scal z innym klientem",
  merge_clients_target_label: "Konto, które zostaje",
  merge_clients_add_client: "Dodaj klienta do scalenia",
  merge_clients_account_summary: "Rezerwacje: @{bookings}",
  merge_clients_warning:
    "Pozostałe konta zostaną usunięte, a ich adresy e-mail przestaną działać przy logowaniu. Wszystkie rezerwacje i historia powiadomień przejdą na konto, które zostaje. Klient nie dostanie żadnej wiadomości. Notatki z kart zostaną połączone. Puste pola konta, które zostaje, uzupełnią się danymi z pozostałych kont, a to, czego nie da się przenieść, trafi do notatki. Tej operacji nie można cofnąć.",
  merge_clients_refusal_has_payments:
    "To konto ma płatności lub subskrypcje i nie może być scalone.",
  merge_clients_refusal_not_client:
    "To konto należy do pracownika i nie może być scalone.",
  merge_clients_success: "Klienci scaleni.",
  merge_clients_selection_hint: "Zaznacz od 2 do 5 kont klientów.",
  merge_clients_confirm: "Scal",
  max_user_bookings_period: "W jakim okresie?",
  max_user_bookings_period_info:
    "Przykład: limit 1 i okres 30 dni oznacza, że klient może mieć kolejną rezerwację tej usługi najwcześniej 30 dni po poprzedniej. Liczy się data wizyty, nie dzień, w którym klient rezerwuje. Strona rezerwacji twoich klientów zablokuje rezerwację ponad limit. W panelu administratora i w aplikacji mobilnej dla pracowników dodasz rezerwację mimo limitu, zobaczysz tylko ostrzeżenie.",
  booking_limit_dialog_title: "Limit rezerwacji osiągnięty",
  booking_limit_dialog_message:
    "Limit rezerwacji tej usługi to @{max} na klienta. Ten limit został już osiągnięty. Utworzyć rezerwację mimo to?",
  booking_limit_dialog_message_period:
    "Limit rezerwacji tej usługi to @{max} na klienta w ciągu @{period}. Ten limit został już osiągnięty. Utworzyć rezerwację mimo to?",
  logs_diff_max_user_bookings_period: "Okres limitu rezerwacji klienta",
  "account_email-change": "Zmiana adresu e-mail - potwierdzenie",
  "account_email-change_info":
    "Wiadomość z linkiem potwierdzającym, wysyłana na nowy adres, gdy klient zmienia swój e-mail. Zmiana zadziała dopiero po kliknięciu linku.",
  "account_email-change_email_subject_client":
    "Potwierdź nowy adres e-mail w [COMPANY_NAME]",
  "account_email-change_email_text_client":
    "<h1>Potwierdź nowy adres e-mail</h1><p>Otrzymaliśmy prośbę o zmianę adresu e-mail Twojego konta w [COMPANY_NAME] na [NEW_EMAIL]. Kliknij poniżej, aby potwierdzić nowy adres. Zmiana zadziała dopiero po potwierdzeniu. Jeśli to nie Ty, zignoruj tę wiadomość.</p>",
  "account_email-change_email_cta_button_client": "Potwierdzam nowy adres",
  "account_email-changed": "Zmiana adresu e-mail - powiadomienie",
  "account_email-changed_info":
    "Wiadomość informacyjna wysyłana na poprzedni adres po potwierdzonej zmianie e-maila.",
  "account_email-changed_email_subject_client":
    "Adres e-mail Twojego konta w [COMPANY_NAME] został zmieniony",
  "account_email-changed_email_text_client":
    "<h1>Adres e-mail został zmieniony</h1><p>Adres e-mail Twojego konta w [COMPANY_NAME] został zmieniony na [NEW_EMAIL]. Jeśli to nie Ty, jak najszybciej skontaktuj się z nami.</p>",
  variable_new_email: "Nowy adres e-mail",
  email_change_pending_banner:
    "Zmiana adresu e-mail czeka na potwierdzenie. Wysłaliśmy link na @{email}. Do czasu kliknięcia linku konto działa na obecnym adresie.",
  email_change_pending_sent_info:
    "Wysłaliśmy link potwierdzający na @{email}. Adres e-mail zmieni się po jego kliknięciu.",
  email_change_cancel_button: "Anuluj zmianę",
  email_change_resend_success: "Link został wysłany ponownie.",
  email_change_resend_too_soon:
    "Link wysłaliśmy przed chwilą. Odczekaj kilka sekund i spróbuj ponownie.",
  email_change_cancel_success: "Zmiana adresu e-mail została anulowana.",
  email_change_confirm_success:
    "Adres e-mail został zmieniony. Zaloguj się nowym adresem.",
  email_change_confirm_error:
    "Link potwierdzający wygasł albo jest nieprawidłowy. Zaloguj się i wyślij go ponownie z ustawień profilu.",
  account_activation_completed:
    "Twoje konto jest aktywne. Zaloguj się, aby zacząć.",
  email_change_confirm_taken_error:
    "Ten adres e-mail jest już używany przez inne konto. Zaloguj się i rozpocznij zmianę od nowa z innym adresem.",
  email_change_no_pending:
    "Nie ma zmiany adresu e-mail oczekującej na potwierdzenie.",
  notification_category_14: "Zmiana adresu e-mail",
  wb_employee_selection_mode: "Wybór pracownika podczas rezerwacji",
  wb_employee_selection_mode_any_person_first:
    "Klient wybiera osobę, na liście jest „dowolna osoba”",
  wb_employee_selection_mode_specific_only: "Klient wybiera konkretną osobę",
  wb_employee_selection_mode_auto_assign:
    "Pomiń krok wyboru, przydziel automatycznie",
  wb_employee_selection_mode_tooltip:
    "Decyduje, jak działa krok wyboru pracownika. „Klient wybiera osobę” pokazuje listę, na której pierwszą opcją jest „dowolna osoba”. „Klient wybiera konkretną osobę” ukrywa opcję „dowolna osoba”, więc klient musi wskazać kogoś z listy. „Pomiń krok wyboru” wypełnia krok automatycznie opcją „dowolna osoba” i przenosi klienta od razu do wyboru terminu, a przyciskiem „Zmień” nadal można wskazać konkretną osobę.",
  customer_captcha_enabled_checkbox:
    "Chroń formularze rezerwacji, rejestracji i logowania przez Google reCAPTCHA",
  customer_captcha_enabled_tooltip:
    "<b>Co to robi?</b><br>Google reCAPTCHA działa w tle i zatrzymuje boty, które zapełniają kalendarz fałszywymi rezerwacjami albo próbują zgadnąć hasła twoich klientów. Klient niczego nie klika.<br><br><b>Co się stanie po wyłączeniu?</b><br>Twoja strona rezerwacji przestanie ładować skrypty Google i nie zapisze żadnych ciasteczek Google, co łatwiej opisać w polityce cookies. W zamian formularze tracą filtr botów. Jeśli wyłączasz, włącz powyżej potwierdzenie e-mail przy rezerwacji, żeby każdy, kto rezerwuje bez konta, musiał potwierdzić swój adres.",
  wb_cookie_banner_enabled: "Pokazuj baner cookies na stronie",
  wb_cookie_banner_enabled_tooltip:
    "Gość sam decyduje, czy zgadza się na statystyki i reklamy. Do czasu zgody Google Tag Manager i Twój własny kod czekają, a działa tylko to, czego strona potrzebuje (logowanie, rezerwacje, płatności, ochrona formularzy). Każdy tekst banera możesz zmienić poniżej.",
  wb_cookie_banner_edit_texts: "Ustawienia banera cookies",
  wb_google_tag_mode: "Google Tag Manager uruchamia się",
  wb_google_tag_mode_tooltip:
    "Wybierz „Od razu” tylko wtedy, gdy w swoim koncie Google Tag Manager ustawiłeś, które tagi wymagają zgody. Inaczej kontener czeka, aż gość zaakceptuje statystyki albo reklamy.",
  wb_google_tag_mode_after_consent: "Po zgodzie gościa na cookies",
  wb_google_tag_mode_immediately:
    "Od razu, z przekazaniem wyboru gościa do Google",
  wb_custom_code_mode: "Kod poniżej uruchamia się",
  wb_custom_code_mode_tooltip:
    'Jeden fragment może czekać na inną zgodę niż reszta. Dopisz mu data-category="analytics", "marketing" albo "functionality", a pilnuje już tylko tej jednej zgody, np. <script data-category="marketing" src="...">. Działa w script, link i style. Meta uruchamia się zawsze.',
  wb_custom_code_mode_always: "Od razu, bez pytania o zgodę",
  wb_custom_code_mode_functionality: "Po zgodzie na funkcje dodatkowe",
  wb_custom_code_mode_analytics: "Po zgodzie na statystyki",
  wb_custom_code_mode_marketing: "Po zgodzie na reklamy",
  wb_custom_code_blocked_info:
    "Fragmenty bez własnej kategorii: @{count}. Wszystkie czekają na zgodę, więc sprawdź, czy nie ma wśród nich czcionki, stylu albo czatu.",
  wb_custom_code_mode_hint_always:
    "Ten kod uruchomi się u każdego gościa, także wtedy, gdy odrzuci cookies. Zostaw tak tylko kod, który nikogo nie śledzi.",
  wb_custom_code_mode_hint_consent:
    'Gdy gość odrzuci cookies, ten kod się nie uruchomi. Żeby jeden fragment działał zawsze, dopisz mu data-category="necessary":\n<script ... data-category="necessary">',
  wb_cookie_banner_title: "Tytuł banera",
  wb_cookie_banner_description: "Tekst banera",
  wb_cookie_banner_accept_all_button: "Przycisk „Akceptuję wszystkie”",
  wb_cookie_banner_reject_all_button: "Przycisk „Odrzucam wszystkie”",
  wb_cookie_banner_settings_button: "Przycisk „Ustawienia”",
  wb_cookie_banner_privacy_policy_page: "Podstrona z polityką prywatności",
  wb_cookie_banner_privacy_policy_url: "Adres polityki prywatności",
  wb_cookie_banner_privacy_policy_url_tooltip:
    "Link do polityki prywatności poza tą stroną. Gdy jest wpisany, baner używa go zamiast podstrony powyżej.",
  wb_cookie_banner_privacy_policy_link: "Tekst linku do polityki prywatności",
  wb_cookie_banner_block_page: "Zablokuj stronę do czasu decyzji",
  wb_cookie_banner_block_page_tooltip:
    "Domyślnie wyłączone: gość może rezerwować, zanim odpowie na baner.",
  wb_cookie_banner_preferences_title: "Tytuł okna ustawień",
  wb_cookie_banner_save_button: "Przycisk „Zapisz”",
  wb_cookie_banner_necessary_title: "Niezbędne, tytuł",
  wb_cookie_banner_necessary_description: "Niezbędne, opis",
  wb_cookie_banner_functionality_title: "Funkcje dodatkowe, tytuł",
  wb_cookie_banner_functionality_description: "Funkcje dodatkowe, opis",
  wb_cookie_banner_analytics_title: "Statystyki, tytuł",
  wb_cookie_banner_analytics_description: "Statystyki, opis",
  wb_cookie_banner_marketing_title: "Reklamy, tytuł",
  wb_cookie_banner_marketing_description: "Reklamy, opis",
  wb_cookie_banner_default_title: "Ta strona korzysta z plików cookies",
  wb_cookie_banner_default_description:
    "Cookies to małe pliki zapisywane w Twojej przeglądarce. Niezbędne cookies obsługują logowanie, rezerwacje i płatności i działają zawsze. Za Twoją zgodą używamy też cookies do statystyk odwiedzin i dopasowania reklam. Zgodę możesz w każdej chwili zmienić lub wycofać w ustawieniach cookies.",
  wb_cookie_banner_default_accept_all_button: "Akceptuję wszystkie",
  wb_cookie_banner_default_reject_all_button: "Odrzucam wszystkie",
  wb_cookie_banner_default_settings_button: "Ustawienia cookies",
  wb_cookie_banner_default_privacy_policy_link: "Polityka prywatności",
  wb_cookie_banner_default_preferences_title: "Ustawienia prywatności",
  wb_cookie_banner_default_save_button: "Zapisz mój wybór",
  wb_cookie_banner_default_necessary_title: "Niezbędne",
  wb_cookie_banner_default_necessary_description:
    "Te cookies są konieczne do działania strony i nie da się ich wyłączyć. Ustawiane są w odpowiedzi na Twoje działania, takie jak logowanie, złożenie rezerwacji, płatność (Stripe) czy wysłanie formularza (ochrona reCAPTCHA). Możesz zablokować je w przeglądarce, ale wtedy część strony przestanie działać. Nie przechowują danych, które pozwalają Cię zidentyfikować.",
  wb_cookie_banner_default_functionality_title: "Funkcje dodatkowe",
  wb_cookie_banner_default_functionality_description:
    "Te cookies rozszerzają stronę o dodatkowe funkcje, na przykład czat, mapę dojazdu albo osadzone wideo. Mogą je ustawiać dostawcy tych usług. Bez Twojej zgody funkcje te mogą nie działać albo działać w ograniczonym zakresie.",
  wb_cookie_banner_default_analytics_title: "Statystyki",
  wb_cookie_banner_default_analytics_description:
    "Te cookies pozwalają liczyć odwiedziny i źródła ruchu, żeby mierzyć i poprawiać działanie strony, na przykład przez Google Analytics. Pokazują, które podstrony są odwiedzane najczęściej i jak goście poruszają się po stronie. Zebrane dane są zagregowane i anonimowe. Bez Twojej zgody Twoja wizyta nie trafi do statystyk.",
  wb_cookie_banner_default_marketing_title: "Reklamy",
  wb_cookie_banner_default_marketing_description:
    "Te cookies ustawiają partnerzy reklamowi, na przykład Google Ads albo Meta. Służą do budowania profilu Twoich zainteresowań i pokazywania dopasowanych reklam na innych stronach. Nie przechowują bezpośrednio danych osobowych, ale rozpoznają Twoją przeglądarkę i urządzenie. Bez Twojej zgody reklamy będą mniej dopasowane.",
  wb_cookie_banner_enabled_info:
    "Baner jest włączony. Teksty, kategorie, link do polityki prywatności i sposób powrotu do ustawień znajdziesz pod przyciskiem poniżej albo klikając baner w podglądzie. Ustawienia zależne od banera mają kolorowy pasek z lewej.",
  wb_cookie_banner_preview_edit:
    "Kliknij, aby otworzyć ustawienia banera cookies",
  wb_section_preview_edit: "Kliknij, aby otworzyć ustawienia sekcji",
  wb_navbar_preview_edit: "Kliknij, aby otworzyć ustawienia nagłówka",
  wb_footer_preview_edit: "Kliknij, aby otworzyć ustawienia stopki",
  wb_cookie_banner_section_bar: "Pasek na stronie",
  wb_cookie_banner_section_link: "Link do polityki prywatności",
  wb_cookie_banner_section_preferences: "Okno ustawień",
  wb_cookie_banner_privacy_policy_target: "Dokąd prowadzi link?",
  wb_cookie_banner_privacy_policy_target_none: "Bez linku",
  wb_cookie_banner_privacy_policy_target_page: "Podstrona tej strony",
  wb_cookie_banner_privacy_policy_target_url: "Adres zewnętrzny",
  wb_cookie_banner_default_preferences_description:
    "Podczas korzystania ze strony przeglądarka może zapisywać lub odczytywać informacje, zwykle w formie cookies. Mogą one dotyczyć Ciebie, Twoich preferencji lub urządzenia i zazwyczaj nie identyfikują Cię bezpośrednio. Poniżej wybierasz, na które rodzaje cookies się zgadzasz. Zablokowanie części z nich może ograniczyć niektóre funkcje strony.",
  wb_cookie_banner_preferences_description: "Okno ustawień, tekst wstępny",
  wb_cookie_banner_categories: "Kategorie do wyboru dla gościa",
  wb_cookie_banner_categories_tooltip:
    "Odznacz kategorię, żeby ukryć ją w oknie ustawień. Ukryta kategoria nigdy nie jest akceptowana, więc kod do niej przypisany nigdy się nie uruchomi. Google Tag Manager w trybie „po zgodzie” startuje tylko po zgodzie na statystyki albo reklamy, więc zostaw choć jedną z nich, jeśli z niego korzystasz.",
  wb_cookie_banner_category_hidden: "ukryta",
  wb_cookie_banner_reopen: "Jak gość wraca do ustawień cookies?",
  wb_cookie_banner_reopen_icon: "Mała ikonka ciasteczka w rogu strony",
  wb_cookie_banner_reopen_link:
    "Link, który sam dodam (menu, stopka lub przycisk)",
  wb_cookie_banner_reopen_both: "Oba: ikonka i mój własny link",
  wb_cookie_banner_reopen_link_info:
    "Ikonka jest widoczna cały czas, więc gość zmieni zdanie w każdej chwili bez Twojej pracy. Jeśli wolisz link w stopce albo w menu, dodaj pozycję menu albo podstronę z przekierowaniem i użyj tego adresu:",
  wb_cookie_banner_reopen_link_missing:
    "Nic na Twojej stronie nie prowadzi jeszcze do ustawień cookies. Dodaj pozycję menu, link w stopce albo przycisk z powyższym adresem, inaczej gość nie ma jak zmienić zdania.",
  wb_cookie_banner_reopen_tooltip:
    "Gość może w każdej chwili zmienić lub wycofać zgodę. Wybierz ikonkę, link umieszczony przez Ciebie (na przykład w stopce, tak robi większość stron) albo oba.",
  employee_no_panel_access: "Bez dostępu do panelu",
  guest_retention_days_label: "Po ilu dniach usunąć dane?",
  guest_retention_anchor_label: "Od kiedy liczyć dni?",
  guest_retention_anchor_last_booking:
    "od ostatniej rezerwacji tej osoby (zalecane)",
  guest_retention_anchor_record_created: "od pierwszej rezerwacji tej osoby",
  client_password_min_length_label: "Minimalna długość hasła",
  client_password_classes_label: "Wymagane rodzaje znaków",
  client_password_class_upper: "Wielka litera",
  client_password_class_lower: "Mała litera",
  client_password_class_digit: "Cyfra",
  client_password_class_special: "Znak specjalny",
  client_password_breach_check_checkbox: "Odrzucaj hasła znane z wycieków",
  client_password_breach_check_tooltip:
    "Sprawdzamy, czy hasło pojawiło się w publicznych wyciekach danych. Do serwisu sprawdzającego trafia tylko fragment skrótu hasła, nigdy samo hasło ani adres e-mail. Jeśli serwis nie odpowiada, hasło przechodzi bez tej kontroli.",
  client_password_email_similarity_checkbox:
    "Hasło nie może zawierać części adresu e-mail sprzed „@”",
  client_password_email_similarity_tooltip:
    "Sprawdzamy fragment adresu przed „@”, bez rozróżniania wielkości liter. Dla adresu <b>anna.kowalska@example.com</b> odpadnie hasło <b>Anna.Kowalska2024!</b>, ale <b>Kowalska2024!</b> przejdzie. Gdy ta część ma mniej niż 4 znaki (np. <b>jk@</b>), reguła nic nie blokuje.",
  client_password_settings_tooltip:
    "Zasady działają na stronie rezerwacji i w aplikacji klienta. Hasła Twoich pracowników się nie zmieniają.",
  settings_privacy: "Prywatność",
  privacy_account_card_title: "Co klient widzi po zalogowaniu?",
  privacy_account_card_description:
    "Teraz klient po zalogowaniu widzi wszystkie rezerwacje zrobione na jego adres e-mail, także te sprzed założenia konta.",
  privacy_account_switch:
    "Pokazuj klientowi tylko rezerwacje od założenia konta",
  privacy_account_warning:
    "Starsze rezerwacje, płatności i pliki zostają w Twoim panelu, ale znikają z konta klienta. Każdy nowy klient zaloguje się dopiero po kliknięciu linku z e-maila. Klienci, którzy mają konto, ale nie potwierdzili adresu, przy następnym logowaniu dostaną prośbę o potwierdzenie: wystarczy kliknąć link z e-maila albo użyć opcji „Przypomnij hasło”. Kto rezerwował bez konta, zakłada je przez rejestrację, bo „Przypomnij hasło” nic mu nie wyśle. Pracowników to nie dotyczy.",
  privacy_account_example_caption:
    "Przykład: pani Anna zarezerwowała bez konta, a później założyła konto.",
  privacy_account_example_now: "Teraz",
  privacy_account_example_after: "Po włączeniu",
  privacy_account_example_booking_before: "3 marca: rezerwacja bez konta",
  privacy_account_example_signup: "10 maja: pani Anna zakłada konto",
  privacy_account_example_booking_after: "2 października: rezerwacja z konta",
  privacy_account_example_hidden: "widoczna tylko w Twoim panelu",
  guest_retention_example_last_booking:
    "Przykład: ktoś rezerwuje dziś bez konta. Jeśli nie zarezerwuje nic więcej, jego dane usuniemy w nocy po @{date}, ale nigdy przed terminem jego rezerwacji.",
  guest_retention_example_record_created:
    "Przykład: ktoś rezerwuje dziś pierwszy raz bez konta. Jego dane usuniemy w nocy po @{date}, nawet jeśli w tym czasie zarezerwuje ponownie, ale nigdy przed terminem jego rezerwacji.",
  guest_retention_timeline_label: "Jak działa usuwanie?",
  guest_retention_timeline_booking: "Rezerwacja bez konta",
  guest_retention_timeline_booking_last:
    "liczymy od ostatniej rezerwacji tej osoby",
  guest_retention_timeline_booking_first:
    "liczymy od pierwszej rezerwacji tej osoby",
  guest_retention_timeline_wait:
    "Mija @{days} dzień|Mijają @{days} dni|Mija @{days} dni",
  guest_retention_timeline_wait_detail: "i nie ma już zaplanowanej rezerwacji",
  guest_retention_timeline_delete: "W nocy usuwamy dane osoby",
  guest_retention_timeline_delete_detail:
    "imię, kontakt, wysłane wiadomości, pliki i opinie",
  guest_retention_timeline_kept: "Zostaje rezerwacja bez danych osoby",
  guest_retention_timeline_kept_detail:
    "usługa, pracownik i termin, więc statystyki się zgadzają",
  guest_retention_advanced_title: "Ustawienia zaawansowane",
  guest_retention_scope_checkbox:
    "Usuwaj też dane osoby ze starych rezerwacji bez konta, nawet jeśli ta osoba założyła później konto",
  guest_retention_scope_hint:
    "Przykład: pani Anna zarezerwowała 3 marca bez konta, a 10 maja założyła konto. Po ustawionym czasie rezerwacja z 3 marca zostanie w Twoim panelu bez jej danych (tylko usługa, pracownik i termin) i nie będzie już przypisana do jej konta. Konto pani Anny i rezerwacje od 10 maja się nie zmieniają. Rezerwacji z płatnością nie ruszamy.",
  guest_retention_scope_why:
    "Po co? Tamtą rezerwację mógł zrobić ktoś inny na jej adres e-mail, a ona nie widzi jej w koncie, więc nie ma powodu, żeby jej dane dalej tam były.",
  guest_retention_never_title: "Kogo nigdy nie usuwamy?",
  guest_retention_never_account: "Klientów z kontem",
  guest_retention_never_payment: "Klientów z płatnością",
  guest_retention_never_subscription: "Klientów z subskrypcją",
  guest_retention_never_upcoming: "Klientów z zaplanowaną rezerwacją",
  guest_retention_never_manual: "Klientów dodanych ręcznie w panelu",
  client_password_preview_title: "Jak te zasady działają na przykładach?",
  client_password_preview_email:
    "Dla klientki z adresem @{email}. Wycieki sprawdzamy dopiero, gdy klient ustawia hasło.",
  client_password_preview_passes: "przejdzie",
  client_password_preview_too_short: "za krótkie (min. @{min} znaków)",
  client_password_preview_missing: "brak: @{what}",
  client_password_preview_has_email: "zawiera część adresu e-mail",
  guest_retention_scope_table_label: "Co zmienia to pole",
  guest_retention_scope_table_booking: "Rezerwacja z 3 marca",
  guest_retention_scope_table_unchecked: "Pole odznaczone",
  guest_retention_scope_table_checked: "Pole zaznaczone",
  guest_retention_scope_table_account: "W koncie pani Anny",
  guest_retention_scope_table_panel: "W Twoim panelu",
  guest_retention_scope_table_hidden:
    "Nie widać jej, bo włączona jest opcja „Pokazuj klientowi tylko rezerwacje od założenia konta”",
  guest_retention_scope_table_kept: "Zostaje z danymi pani Anny, bez końca",
  guest_retention_scope_table_removed:
    "Po @{days} dniu zostaje bez jej danych: tylko usługa, pracownik i termin|Po @{days} dniach zostaje bez jej danych: tylko usługa, pracownik i termin|Po @{days} dniach zostaje bez jej danych: tylko usługa, pracownik i termin",
  guest_retention_scope_requires_account_history:
    "Działa tylko wtedy, gdy włączona jest opcja „Pokazuj klientowi tylko rezerwacje od założenia konta” w sekcji „Co klient widzi po zalogowaniu?”.",
  guest_retention_dpo_title: "Szczegóły dla inspektora ochrony danych",
  guest_retention_dpo_details:
    "<b>Co usuwamy?</b> Dane osoby (imię, nazwisko, e-mail, telefon, adres), wysłane do niej e-maile i SMS-y, wpisy w dzienniku aktywności, załączniki i opinie. Po każdej rezerwacji zostaje wpis bez danych osoby: usługa, pracownik, termin i status.<br><br><b>Kogo nie usuwamy?</b> Osób z kontem, z prośbą o konto albo takich, które choć raz się zalogowały. Osób z płatnością, subskrypcją lub zaplanowaną rezerwacją. Pracowników, klientów dodanych w panelu bez rezerwacji i nikogo, czyje dane pojawiły się przed pierwszym włączeniem opcji.<br><br><b>Kopie zapasowe</b> Usunięte dane znikają z kopii zapasowych w ciągu 21 dni.<br><br><b>Potwierdzenie usunięcia</b> Lista „Usunięcia danych” pokazuje każdy przebieg: datę, liczbę usuniętych osób, rezerwacji bez danych osoby, pominiętych osób (płatność albo zaplanowana rezerwacja) i błędów. Zapisujemy tylko liczby. Przez 90 dni trzymamy nieodwracalny skrót adresów e-mail usuniętych osób, żeby na prośbę sprawdzić, czy dany adres został usunięty. „Próba” oznacza przebieg bez usuwania.",
  privacy_retention_confirm_preview_bookings:
    "Usuniemy też dane osób z @{bookings} starych rezerwacji klientów, którzy później założyli konto.",
  client_password_extra_rules_title: "Dodatkowe zasady",
  client_password_policy_empty:
    "Samego minimum 8 znaków bez żadnej innej zasady nie zapiszemy. Zaznacz co najmniej jeden rodzaj znaków, wydłuż hasło albo włącz jedną z dodatkowych zasad.",
  client_password_weaker_than_default:
    "Te zasady są łagodniejsze niż obecne: strona rezerwacji przyjmie hasło bez odznaczonych rodzajów znaków.",
  logs_diff_account_requested_at: "Prośba o konto",
  logs_diff_account_requested_via: "Skąd prośba o konto",
  account_request_via_signup_form: "rejestracja na stronie",
  account_request_via_booking_form: "formularz rezerwacji",
  account_request_via_store_form: "sklep",
  account_request_via_admin_panel: "panel (pracownik)",
  account_request_via_password_reset: "reset hasła",
  account_request_via_backfill: "konto sprzed zmiany",
  account_status_account: "Konto",
  account_status_pending: "Czeka na potwierdzenie",
  account_status_guest: "Bez konta",
  account_status_blocked: "Zablokowany",
  account_status_filter: "Konto",
  account_status_account_details: "Konto potwierdzone @{date}",
  account_status_pending_details:
    "Prośba o konto @{date} (@{via}), adres jeszcze niepotwierdzony",
  account_status_guest_details: "Rezerwuje bez konta",
  retention_forecast_kept: "Tych danych nie usuwamy: @{reason}.",
  retention_forecast_due_tonight: "Dane usuniemy najbliższej nocy.",
  retention_forecast_due_after: "Dane usuniemy najwcześniej w nocy po @{date}.",
  retention_forecast_due_after_booking:
    "Dane usuniemy najwcześniej w nocy po @{date}, gdy minie termin rezerwacji.",
  retention_forecast_reason_account: "klient ma konto",
  retention_forecast_reason_account_request: "klient prosił o konto",
  retention_forecast_reason_staff: "to pracownik",
  retention_forecast_reason_before_enabled:
    "dane powstały przed włączeniem usuwania",
  retention_forecast_reason_logged_in: "klient logował się na stronie",
  retention_forecast_reason_no_booking: "klient nie ma rezerwacji",
  retention_forecast_reason_managed_by_staff:
    "rezerwację dla klienta dodał pracownik albo import",
  event_customer_removed: "Dane klienta usunięte",
  retention_forecast_reason_payment: "klient ma płatność",
  retention_forecast_reason_subscription: "klient ma subskrypcję",
  privacy_account_confirm_warning:
    "Klienci zobaczą w koncie tylko rezerwacje zrobione od założenia konta, a nowi zalogują się dopiero po potwierdzeniu adresu e-mail. Kto rezerwował bez konta, musi się zarejestrować. Wszystkie rezerwacje nadal masz w panelu.",
  privacy_account_confirm_unconfirmed:
    "Klienci z kontem, którzy przy najbliższym logowaniu potwierdzą adres: @{count}.",
  privacy_retention_card_title: "Usuwanie danych osób bez konta",
  privacy_retention_card_description:
    "Teraz dane osób, które rezerwują bez zakładania konta, zostają w systemie na stałe.",
  privacy_retention_switch: "Usuwaj te dane automatycznie po wybranym czasie",
  privacy_retention_confirm_warning:
    "Od teraz co noc trwale usuniemy dane osób bez konta, u których minął @{days} dzień. Tego nie da się cofnąć.|Od teraz co noc trwale usuniemy dane osób bez konta, u których minęły @{days} dni. Tego nie da się cofnąć.|Od teraz co noc trwale usuniemy dane osób bez konta, u których minęło @{days} dni. Tego nie da się cofnąć.",
  privacy_retention_confirm_reenable:
    "Opcja była już włączona od @{date}, więc obejmie też osoby, które rezerwowały bez konta, gdy była wyłączona.",
  privacy_password_card_title: "Hasła klientów",
  privacy_password_card_description:
    "Teraz hasło klienta musi mieć co najmniej 8 znaków, w tym małą i wielką literę, cyfrę i znak specjalny, np. ! albo #.",
  privacy_password_switch: "Ustaw własne zasady haseł",
  privacy_confirm_title: "Zapisać zmiany w prywatności?",
  profile_account_details: "Dane konta",
  guest_retention_coverage_on_save:
    "Usuwanie obejmie tylko osoby, których dane pojawią się od chwili zapisania. Obecnych klientów nie usuwamy.",
  guest_retention_coverage_since:
    "Usuwamy tylko osoby, których dane pojawiły się od @{date}. Klientów sprzed tej daty nie usuwamy, także po ponownym włączeniu opcji.",
  guest_data_purges_title: "Usunięcia danych",
  guest_data_purges_description:
    "Tu zapisujemy każde nocne usuwanie. Listę pobierzesz jako CSV dla inspektora ochrony danych.",
  guest_data_purges_after_save:
    "Lista pojawi się po zapisaniu ustawień. Dane sprawdzamy co noc, ale pierwsze osoby usuniemy najwcześniej w nocy po @{date}.",
  guest_data_purges_status_none:
    "Jeszcze nie było przebiegu. Dane sprawdzamy co noc, pierwsze osoby usuniemy najwcześniej w nocy po @{date}.",
  guest_data_purges_status_last:
    "Ostatni przebieg: @{date}, usunięto @{users} os.",
  guest_data_purges_none: "Brak przebiegów.",
  guest_data_purges_none_with_changes:
    "Żaden przebieg jeszcze niczego nie usunął. Wszystkie są w pliku CSV.",
  guest_data_purges_rest_in_csv:
    "Pozostałe przebiegi niczego nie usunęły. Wszystkie są w pliku CSV.",
  guest_data_purges_show_more: "Pokaż więcej",
  guest_data_purges_export: "Pobierz CSV",
  guest_data_purges_dry_run: "próba (bez usuwania)",
  guest_data_purges_col_run: "Przebieg",
  guest_data_purges_col_users: "Usunięte osoby",
  guest_data_purges_col_bookings: "Zanonimizowane rezerwacje",
  guest_data_purges_col_excluded:
    "Pominięte (płatność lub przyszła rezerwacja)",
  guest_data_purges_col_errors: "Błędy",
  privacy_retention_confirm_preview:
    "Najbliższej nocy usuniemy dane @{users} os. bez konta.",
  guest_data_purges_load_failed:
    "Nie udało się pobrać listy usunięć. Ustawienia są zapisane, odśwież stronę, żeby zobaczyć listę.",
  guest_data_purges_export_failed:
    "Nie udało się pobrać pliku CSV. Spróbuj ponownie.",
  plan_preview_title: "Ile zapłacisz dziś?",
  plan_preview_subtotal: "Razem netto",
  plan_preview_discount: "Rabat",
  plan_preview_tax: "VAT",
  plan_preview_credit_used: "Z Twojego salda",
  plan_preview_amount_due: "Do zapłaty dziś",
  plan_preview_credit_after: "Zostanie na Twoim saldzie: {amount}",
  plan_preview_renews_at: "Kolejna płatność: {date}",
  plan_preview_no_change:
    "To Twój obecny plan. Nic się nie zmieni i nic nie pobierzemy.",
  plan_preview_resume:
    "Zostajesz przy obecnym planie, a zaplanowaną zmianę odwołujemy. Dziś nic nie pobierzemy.",
  plan_preview_credit_note:
    "Różnica trafi na Twoje saldo i pokryje kolejne płatności.",
  plan_preview_credit_covers:
    "Kolejne płatności po {amount} opłaci Twoje saldo. Kartą zapłacisz dopiero {date}.",
  plan_preview_carried_to_next:
    "{amount} doliczymy do kolejnej płatności. Tak małej kwoty nie da się pobrać z karty.",
  plan_preview_applied_discount:
    "Twój rabat ({discount}) jest już uwzględniony w cenach.",
  plan_preview_loading: "Sprawdzamy, ile zapłacisz dziś…",
  plan_preview_discount_code: "Kod {code}",
  plan_preview_discount_forever: "na stałe",
  plan_preview_discount_until: "do {date}",
  plan_preview_discount_once: "tylko przy pierwszej płatności",
  change_plan: "Zmień plan",
  plan_changes_adding: "Dodajesz: {items}",
  plan_changes_removing: "Wyłączasz: {items}",
  plan_changes_changing: "Zmieniasz: {items}",
  plan_changes_due_today: "Dziś zapłacisz: {amount}",
  max_gap_between_bookings_checkbox_text:
    "Ogranicz odstęp między rezerwacjami pracownika",
  max_gap_between_bookings: "Maksymalny odstęp",
  max_gap_between_bookings_info:
    "Gdy pracownik ma już rezerwację danego dnia, klient zobaczy online tylko terminy oddalone od niej o najwyżej tyle minut (liczone razem z przerwami przed i po usłudze). Dzień bez rezerwacji pokazuje wszystkie terminy z grafiku. Odstęp ustawiony u pracownika ma pierwszeństwo przed tym z usługi. W panelu i w aplikacji pracownika dodasz rezerwację bez tego ograniczenia.",
  logs_diff_max_gap_between_bookings: "Maksymalny odstęp między rezerwacjami",
  invoice_not_issued: "Faktura niewystawiona",
  invoice_retry_queued: "W kolejce",
  invoice_retry_button: "Wystaw fakturę ponownie",
  invoice_retry_confirm_title: "Wystawić fakturę ponownie?",
  invoice_retry_confirm_warning:
    "Wystawimy fakturę jeszcze raz. Jako datę sprzedaży wpiszemy datę płatności, a klient otrzyma ją tak jak każdą inną fakturę.",
  invoice_retry_queued_info:
    "Faktura w kolejce do wystawienia. Status odświeży się za chwilę.",
  invoice_retry_skipped_already_issued: "Ta faktura jest już wystawiona.",
  invoice_retry_skipped_in_progress:
    "Ta faktura jest już w trakcie wystawiania.",
  invoice_retry_skipped_not_eligible:
    "Dla tej płatności nie da się wystawić faktury ponownie.",
  invoice_retry_skipped_forbidden:
    "Nie masz uprawnień, żeby wystawić tę fakturę.",
  event_bulk_count_bookings:
    "@{count} rezerwację|@{count} rezerwacje|@{count} rezerwacji",
  event_bulk_count_blockades:
    "@{count} blokadę|@{count} blokady|@{count} blokad",
  event_bulk_delete_summary: "Usuniesz @{bookings} i @{blockades}.",
  event_bulk_delete_summary_bookings: "Usuniesz @{bookings}.",
  event_bulk_delete_summary_blockades: "Usuniesz @{blockades}.",
  event_deleting_bookings_title: "Usuwanie rezerwacji",
  event_deleting_blockades_title: "Usuwanie blokad",
  event_bulk_status_summary:
    "Status „@{status}” dostanie @{count} rezerwacja.|Status „@{status}” dostaną @{count} rezerwacje.|Status „@{status}” dostanie @{count} rezerwacji.",
  event_bulk_status_skipped_blockades:
    "Pominiemy @{blockades}, bo blokady nie mają statusu.",
  event_bulk_skipped_bookings_no_permission:
    "Pominiemy @{bookings}, bo nie masz do nich uprawnień.",
  event_bulk_skipped_blockades_no_permission:
    "Pominiemy @{blockades}, bo nie masz do nich uprawnień.",
  event_bulk_skipped_company_blockades:
    "Pominiemy @{blockades} dla całej firmy (bez przypisanego pracownika), bo filtrujesz po pracowniku.",
  event_bulk_no_filters_warning:
    "Nie ustawiono żadnego filtra, więc operacja obejmie wszystkie wydarzenia na koncie.",
  event_bulk_over_limit_delete:
    "Jednorazowo możesz usunąć najwyżej @{limit} wydarzeń. Zawęź filtry, np. do krótszego zakresu dat.",
  event_bulk_over_limit_update:
    "Jednorazowo możesz zmienić status najwyżej @{limit} rezerwacji. Zawęź filtry, np. do krótszego zakresu dat.",
  event_bulk_nothing_to_process: "Ta operacja nie obejmie żadnego wydarzenia.",
  panel_company_account_not_found:
    "Nie znaleźliśmy tego konta firmy. Mogło zostać usunięte. Zaloguj się ponownie, żeby kontynuować.",
  bulk_operation_completed_with_skipped:
    "Zakończono. Przetworzono: @{processed}, nieudane: @{failed}, pominięte: @{skipped}. Pominięte to te, które ktoś już usunął albo do których nie masz uprawnień.",
  employee_panel_access_title: "Dostęp do panelu Calendesk",
  employee_public_profile_title: "Profil widoczny dla klientów",
  employee_advanced_settings_title: "Ustawienia zaawansowane",
  employee_max_gap_card_info:
    "Grafik dostępności nadal decyduje, kiedy pracownik w ogóle przyjmuje klientów. Odstęp działa tylko w dniach, w których ktoś już się zapisał: klient zobaczy wtedy terminy blisko istniejących rezerwacji. W dniu bez rezerwacji widzi wszystkie terminy z grafiku. „Bez limitu” wyłącza to ograniczenie.",
  employee_max_gap_switch: "Własny odstęp dla tego pracownika",
  employee_max_gap_none: "Bez limitu",
  employee_max_gap_title: "Maksymalny odstęp między rezerwacjami",
  max_gap_timeline_booking: "Rezerwacja",
  max_gap_timeline_open: "Wolne",
  max_gap_timeline_closed: "Ukryte",
  max_gap_timeline_caption_limited:
    "Klient widzi tylko terminy w odległości do @{gap} od rezerwacji. Terminy dalej od niej ukrywamy, ale tylko w dniach, w których ktoś już się zapisał. Godziny pracy nadal wynikają z grafiku dostępności.",
  max_gap_timeline_caption_unlimited:
    "Bez limitu klient widzi wszystkie wolne terminy z grafiku, niezależnie od rezerwacji.",
  employee_services_section_title: "Usługi i grafik dostępności",
  employee_availability_scope_from_employee: "Terminy z grafiku pracownika",
  employee_availability_scope_own_schedule: "Terminy z grafiku usługi",
  employee_availability_scope_none_here: "Żadna z wybranych usług",
  employee_availability_scope_caption:
    "Jeśli usługa ma własny grafik, klienci widzą terminy z grafiku tej usługi, a grafik pracownika jest wtedy pomijany. W pozostałych usługach klienci widzą terminy z grafiku dostępności pracownika wybranego wyżej.",
  employee_availability_scope_not_public:
    "Pracownik nie przyjmuje rezerwacji online, więc klienci nie zobaczą jego terminów w żadnej usłudze.",
  employee_availability_scope_no_services:
    "Wybierz usługi, które wykonuje ten pracownik. Bez nich klienci nie zarezerwują u niego terminu.",
  employee_availability_scope_no_schedule:
    "Bez grafiku dostępności klienci nie zobaczą tu żadnych wolnych terminów.",
  employee_legacy_hours_warning:
    "Ten pracownik ma jeszcze stary grafik pracy. Przenieś go do grafiku dostępności: ten sam grafik przypiszesz innym osobom i zmienisz w jednym miejscu.",
  employee_legacy_hours_migrate: "Przenieś do grafiku dostępności",
  employee_legacy_hours_migrated:
    "Godziny trafią do nowego grafiku „@{name}”, gdy zapiszesz pracownika.",
  employee_legacy_schedule_name: "@{name} - grafik pracy",
  employee_public_preview_caption:
    "Tak zobaczą to klienci. Zależnie od wybranego kalendarza rezerwacji dłuższy opis zwija się po @{limit} znakach pod linkiem „Pokaż więcej” albo cały opis i linki chowają się pod strzałką przy nazwisku. Sekcja Zespół na stronie www pokazuje cały opis.",
  employee_public_preview_name_placeholder: "Imię i nazwisko",
  employee_public_preview_description_placeholder:
    "Tu pojawi się opis pracownika.",
  employee_send_set_password_link:
    "Wyślij pracownikowi link do ustawienia hasła",
  employee_send_set_password_link_hint:
    "Link trafi na @{email} w języku pracownika i działa 7 dni.",
  employee_role_matrix_label: "Porównanie ról",
  employee_role_matrix_own_calendar: "Własny kalendarz i rezerwacje",
  employee_role_matrix_others_calendars: "Kalendarze innych pracowników",
  employee_role_matrix_customers: "Dane klientów",
  employee_role_matrix_booking_payments: "Płatności za rezerwacje",
  employee_role_matrix_team_services_website: "Pracownicy, usługi i strona www",
  employee_role_matrix_account_settings: "Ustawienia konta",
  employee_role_matrix_plan_invoices: "Plan Calendesk i faktury",
  employee_role_matrix_cell_yes: "Tak",
  employee_role_matrix_cell_no: "Nie",
  employee_role_matrix_cell_own: "Tylko swoje",
  employee_role_matrix_cell_view: "Tylko podgląd",
  employee_role_matrix_cell_own_customers:
    "Tylko swoich: z rezerwacji, które prowadzi lub przy których pomaga, i dodanych przez siebie",
  employee_role_matrix_cell_no_delete: "Tak, bez usuwania",
  employee_locale_time_zone_title: "Język i strefa czasowa",
  employee_locale_time_zone_info:
    "Język ustawia panel i wiadomości systemowe Calendesk do pracownika, np. link do ustawienia hasła. Powiadomienia o rezerwacjach wysyłamy w języku Twoich szablonów. Strefa czasowa ustawia godziny w panelu pracownika. Puste pola oznaczają ustawienia całego konta.",
  employee_locale_time_zone_locked:
    "Własny język i strefę czasową pracowników włączysz w ustawieniach platformy.",
  employee_locale_time_zone_locked_link: "Przejdź do ustawień",
  max_gap_timeline_badge: "Przykład",
  max_gap_timeline_title:
    "Przykładowy dzień pracy z grafiku, z jedną rezerwacją",
  max_gap_timeline_row_without: "Bez odstępu",
  max_gap_timeline_row_with: "Z odstępem @{gap}",
  max_gap_timeline_row_empty: "Dzień bez rezerwacji",
  max_gap_timeline_start: "początek pracy",
  max_gap_timeline_end: "koniec pracy",
  max_gap_timeline_caption_nothing_hidden:
    "W tym przykładzie odstęp @{gap} niczego nie ukrywa, bo cały dzień mieści się w jego zasięgu.",
  max_gap_timeline_empty_note:
    "Gdy nikt jeszcze nie zarezerwował, odstęp nic nie zmienia: klient widzi wszystkie terminy z grafiku.",
  employee_max_gap_subtitle:
    "Jak daleko od istniejącej rezerwacji klient może wybrać termin.",
  employee_max_gap_switch_hint_off:
    "Teraz obowiązuje odstęp ustawiony przy każdej usłudze.",
  employee_max_gap_switch_hint_on:
    "Ten odstęp działa przy wszystkich usługach tego pracownika i zastępuje ustawienia usług.",
  employee_public_preview_show_more: "Pokaż więcej",
  employee_public_preview_collapse: "Zwiń",
  variable_booking_resources: "Zasoby rezerwacji z pulą (np. Sale › Sala A)",
  variable_booking_resources_block:
    "Zasoby rezerwacji albo tekst, gdy ich brak",
  booking_resources_block_with: "Przydzielone zasoby: [BOOKING_RESOURCES]",
  booking_resources_block_without: "Zasoby przydzielimy przed terminem.",
  resource_example_name: "Sala A",
  booking_resources_preview_title: "Zasoby w podglądzie",
  booking_resources_preview_with: "Z zasobem",
  booking_resources_preview_without: "Bez zasobu",
  booking_resource_conflicts_dialog_title: "Kolizja zasobów",
  booking_resource_conflicts_dialog_message:
    "W tym czasie wybrane zasoby są już przypisane do innych rezerwacji:",
  booking_resource_conflicts_dialog_question: "Czy mimo to zapisać rezerwację?",
  booking_resource_conflicts_other_employee: "Rezerwacja innego pracownika",
  booking_resource_conflicts_truncated: "Pokazujemy tylko część kolizji.",
  booking_resources_day_preview_title: "Rezerwacje z tymi zasobami w tym dniu",
  booking_reminder_custom_content_button: "Edytuj treść",
  booking_reminder_custom_content_chip: "Własna treść",
  booking_reminder_use_default_content_information:
    "To przypomnienie znów będzie wysyłać treść z szablonu „Przypomnienie o rezerwacji”.",
  logs_subject_type_bookingresource: "Powiązanie zasobu z rezerwacją",
  booking_resources_info:
    "Wybierz, co przydzielasz do tej rezerwacji, np. gabinet albo salę. Klient zobaczy to w szczegółach rezerwacji, a o zmianie dostanie powiadomienie, jeśli je wysyłasz.",
  booking_tags_info:
    "Etykiety widzisz tylko Ty i Twój zespół, klient ich nie widzi. Pomagają oznaczać rezerwacje i filtrować je na liście rezerwacji.",
  resource_type_resource: "Zasób",
  resource_type_pool: "Pula",
  resource_group_usage_per_participant: "Każdy uczestnik zajmuje jedno miejsce",
  resource_group_usage_per_slot: "Cała grupa zajmuje jedno miejsce",
  resource_assignment_manual_only: "Nikomu, przydzielę go ręcznie",
  resource_assignment_always: "Wszystkim rezerwacjom",
  resource_assignment_by_rule: "Tylko wybranym rezerwacjom",
  resource_convert_to_pool: "Zamień w pulę",
  resource_convert_to_pool_info:
    "Podaj nazwy pozycji. Liczba sztuk będzie równa ich liczbie.",
  resource_convert_to_resource: "Zamień w zwykły zasób",
  resource_convert_to_resource_info:
    "Usuniemy wszystkie pozycje tej puli i zdejmiemy je z rezerwacji. Nie da się tego cofnąć.",
  booking_resources_group_locked:
    "Tę pozycję ma cała grupa. Zmienisz ją w edycji rezerwacji grupowej.",
  booking_resources_group_single_date:
    "Zasoby grupy zmienisz tylko w tym terminie.",
  booking_resources_awaiting: "brak, czeka na przydział",
  booking_resources_awaiting_pool: "„@{pool}”: czeka na przydział",
  booking_resource_rule_mismatch_title_service:
    "Ta pozycja nie jest przeznaczona dla tej usługi",
  booking_resource_rule_mismatch_title_booking:
    "Ta pozycja nie jest przeznaczona dla tej rezerwacji",
  booking_resource_rule_only_services:
    "„@{resource}” (pula „@{pool}”) jest tylko dla: @{services}.",
  booking_resource_rule_only_employees:
    "„@{resource}” (pula „@{pool}”) jest tylko dla rezerwacji u: @{employees}.",
  booking_resource_rule_services_with_employees:
    "„@{resource}” (pula „@{pool}”) jest tylko dla: @{services}, i to tylko u: @{employees}.",
  booking_resource_rule_services_or_employees:
    "„@{resource}” (pula „@{pool}”) jest tylko dla: @{services} albo dla rezerwacji u: @{employees}.",
  booking_resource_rule_other:
    "„@{resource}” (pula „@{pool}”) ma regułę przydziału, która nie obejmuje tej rezerwacji.",
  booking_resource_rule_booking: "Ta rezerwacja dotyczy: @{service}.",
  booking_resource_rule_booking_with_employee:
    "Ta rezerwacja dotyczy: @{service}, prowadzi: @{employee}.",
  booking_resource_rule_mismatch_question_one:
    "Czy mimo to zapisać rezerwację z tą pozycją?",
  booking_resource_rule_mismatch_question_many:
    "Czy mimo to zapisać rezerwację z tymi pozycjami?",
  booking_resource_suggestions_none:
    "O tej porze w puli „@{pool}” nie ma wolnej pozycji.",
  booking_resource_shortage_title: "Brak wolnego zasobu o tej godzinie",
  booking_resource_shortage_title_pool: "Brak wolnej pozycji o tej godzinie",
  booking_resource_shortage_pool:
    "Wszystkie pozycje puli „@{pool}” są zajęte o @{time} (@{used} z @{capacity}). Jeśli zapiszesz rezerwację, nie dostanie żadnej pozycji z tej puli.",
  booking_resource_shortage_pool_rule:
    "W puli „@{pool}” nie ma o @{time} wolnej pozycji dla tej rezerwacji: wolne pozycje są przeznaczone dla innych rezerwacji. Jeśli zapiszesz rezerwację, nie dostanie żadnej pozycji z tej puli.",
  booking_resource_shortage_resource:
    "Zasób „@{resource}” jest zajęty o @{time} (@{used} z @{capacity}).",
  booking_resource_suggestions_title: "Wolne i pasujące o tej porze:",
  availability_schedule_resources_condition_info:
    "Te godziny dostaną tylko usługi, które używają wybranych zasobów. Gdy wybierzesz konkretne pozycje, rezerwacja w tych godzinach dostanie jeden z nich.",
  resource_wizard_step_type: "Co dodajesz",
  resource_wizard_step_names: "Nazwy",
  resource_wizard_step_quantity: "Ile sztuk",
  resource_wizard_step_services: "Usługi",
  resource_wizard_step_group: "Zajęcia grupowe",
  resource_wizard_step_assignment: "Przydział",
  resource_wizard_step_summary: "Sprawdź",
  resource_wizard_step_of: "Krok @{step} z @{total}",
  resource_wizard_steps_label: "Kroki kreatora",
  resource_wizard_title_new_pool: "Nowa pula „@{name}”",
  resource_wizard_title_new_resource: "Nowy zasób „@{name}”",
  resource_wizard_title_edit: "Edytuj „@{name}”",
  resource_wizard_title_add_position: "Dodaj pozycję do „@{name}”",
  resource_wizard_type_title: "Co chcesz dodać?",
  resource_wizard_type_subtitle: "Wybierz to, co pasuje do Twojej sytuacji.",
  resource_wizard_type_resource_title: "Kilka takich samych rzeczy",
  resource_wizard_type_resource_info:
    "Na przykład 2 sale albo 3 projektory. Nie ma znaczenia, która dokładnie trafi do rezerwacji.",
  resource_wizard_type_pool_title: "Rzeczy, które mają swoje nazwy",
  resource_wizard_type_pool_info:
    "Na przykład gabinety 106, 107 i 108. Każda rezerwacja dostaje jeden z nich, a Ty widzisz który.",
  resource_wizard_name_label: "Jak to nazwiemy?",
  resource_wizard_name_hint_pool: "Nazwa całej puli, np. „Gabinety”.",
  resource_wizard_name_hint_resource: "Np. „Sale” albo „Projektory”.",
  resource_wizard_names_title: "Co jest w puli „@{name}”?",
  resource_wizard_names_subtitle:
    "Wpisz nazwy, które zobaczysz Ty i Twój zespół. Potrzebne są co najmniej dwie różne pozycje.",
  resource_wizard_position_name: "Nazwa",
  resource_wizard_add_position: "Dodaj pozycję",
  resource_wizard_empty_rows_skipped: "Puste wiersze pominiemy.",
  resource_wizard_removed_positions_info:
    "Gdy zapiszesz zmiany, usunięte pozycje znikną też z rezerwacji, do których były przypisane. Same rezerwacje zostaną.",
  resource_guide_title: "Jak działają zasoby?",
  resource_guide_intro:
    "Zasób to coś, czego rezerwacja potrzebuje i czego masz ograniczoną liczbę: gabinet, sala, sprzęt. Gdy wszystko jest zajęte, klienci nie zobaczą wolnego terminu.",
  resource_guide_resource_text:
    "Liczysz tylko sztuki. Trzy rzutniki to najwyżej trzy rezerwacje o tej samej godzinie, bez wskazywania, który rzutnik.",
  resource_guide_pool_text:
    "Każda sztuka ma swoją nazwę, np. gabinety 106, 107 i 108. Rezerwacja dostaje konkretną pozycję, a Ty widzisz ją w kalendarzu i w oknie rezerwacji.",
  resource_guide_assignment_title: "Komu system przydziela pozycję?",
  resource_guide_assignment_always:
    "Każdej rezerwacji usługi, która korzysta z puli.",
  resource_guide_assignment_by_rule:
    "Tylko wybranym osobom albo usługom, np. gabinet 108 tylko do terapii par.",
  resource_guide_assignment_manual_only:
    "Rezerwacja czeka, aż wybierzesz pozycję w oknie rezerwacji. Takie rezerwacje znajdziesz na liście rezerwacji pod filtrem „Czeka na zasób”.",
  resource_guide_schedules_title: "Zasoby w grafikach",
  resource_guide_schedules_text:
    "W grafiku dostępności możesz wskazać pulę albo konkretne pozycje. W tych godzinach rezerwacja dostanie jedną z nich. Pozycja z ręcznym przydziałem nie daje wolnych terminów, więc wskazuj te przydzielane automatycznie.",
  resource_guide_groups_title: "Zajęcia grupowe",
  resource_guide_groups_text:
    "Przy każdym zasobie wybierasz, czy każdy uczestnik zajmuje jedno miejsce, czy cała grupa zajmuje jedno.",
  resource_delete_pool_info:
    "Usunięcie puli usuwa też jej pozycje i zdejmuje je z rezerwacji, do których były przypisane. Same rezerwacje zostaną.",
  delete_failed_for: "Usunięto: @{deleted}. Nie udało się usunąć: @{failed}",
  delete_failed_item: "„@{name}”: @{reason}",
  resource_wizard_quantity_title: "Ile masz „@{name}”?",
  resource_wizard_quantity_subtitle:
    "Tyle rezerwacji o tej samej godzinie przyjmiesz.",
  resource_wizard_quantity_less: "Mniej",
  resource_wizard_quantity_more: "Więcej",
  resource_wizard_services_title: "Które usługi korzystają z „@{name}”?",
  resource_wizard_services_subtitle_pool:
    "Każda rezerwacja zaznaczonej usługi zajmie jedną pozycję z puli. Możesz to zmienić później w ustawieniach usługi.",
  resource_wizard_services_subtitle_resource:
    "Każda rezerwacja zaznaczonej usługi zajmie jedną sztukę. Możesz to zmienić później w ustawieniach usługi.",
  resource_wizard_no_services:
    "Nie masz jeszcze usług. Gdy je dodasz, wybierzesz zasób w ustawieniach usługi.",
  resource_wizard_services_online_note:
    "Usług online zwykle nie trzeba tu zaznaczać.",
  resource_wizard_service_minutes: "@{minutes} min",
  resource_wizard_service_group: "grupowa, do @{max} osób",
  resource_wizard_group_title:
    "@{service}: ile miejsc w „@{name}” zajmuje grupa?",
  resource_wizard_group_subtitle:
    "Ta usługa jest grupowa, więc trzeba to ustalić.",
  resource_wizard_group_one_position: "jedną pozycję „@{name}”",
  resource_wizard_group_one_unit: "jedną sztukę „@{name}”",
  resource_wizard_group_per_participant_info: "Każda osoba zajmie @{unit}.",
  resource_wizard_group_per_slot_info:
    "Cała grupa zajmie @{unit}, niezależnie od liczby osób. Pozostałe zostają dla innych rezerwacji.",
  resource_wizard_assignment_title: "Jak przydzielać z puli „@{name}”?",
  resource_wizard_assignment_subtitle:
    "Do każdej nowej rezerwacji system sam dopina jedną wolną pozycję. Tu możesz to ograniczyć. Jeśli jest Ci obojętne, do której rezerwacji system przypisze daną pozycję, nic nie zmieniaj.",
  resource_wizard_assignment_question: "Komu system może dać „@{name}”?",
  resource_wizard_assignment_always_info:
    "System może przydzielić tę pozycję każdej rezerwacji zaznaczonych usług.",
  resource_wizard_assignment_by_rule_info:
    "Wybierasz, u kogo i przy jakich usługach system może przydzielić tę pozycję. Możesz zaznaczyć osoby, usługi albo jedno i drugie. Pozostałe rezerwacje dostaną inną pozycję z puli.",
  resource_wizard_assignment_manual_only_info:
    "System nie przydzieli tej pozycji sam, zrobisz to w oknie rezerwacji. Nadal liczy się do limitu: przy @{positions} pozycji klienci zarezerwują najwyżej @{count} rezerwację o tej samej godzinie, nawet zanim cokolwiek przydzielisz.|System nie przydzieli tej pozycji sam, zrobisz to w oknie rezerwacji. Nadal liczy się do limitu: przy @{positions} pozycjach klienci zarezerwują najwyżej @{count} rezerwacje o tej samej godzinie, nawet zanim cokolwiek przydzielisz.|System nie przydzieli tej pozycji sam, zrobisz to w oknie rezerwacji. Nadal liczy się do limitu: przy @{positions} pozycjach klienci zarezerwują najwyżej @{count} rezerwacji o tej samej godzinie, nawet zanim cokolwiek przydzielisz.",
  resource_wizard_set_all_always: "Ustaw wszędzie „Wszystkim rezerwacjom”",
  resource_wizard_rule_employees: "U kogo?",
  resource_wizard_rule_services: "Przy jakich usługach?",
  resource_wizard_rule_empty_means_all: "Puste pole znaczy „wszyscy”.",
  resource_wizard_rule_match_question:
    "Zaznaczone są osoby i usługi. Kto może dostać tę pozycję?",
  resource_wizard_rule_match_all: "Muszą pasować oba",
  resource_wizard_rule_match_all_example:
    "Np. tylko „@{service}”, gdy prowadzi @{employee}.",
  resource_wizard_rule_match_any: "Wystarczy jeden",
  resource_wizard_rule_match_any_example:
    "Np. każda rezerwacja, którą prowadzi @{employee}, i każda „@{service}”.",
  resource_wizard_rule_needs_services:
    "Najpierw zaznacz usługi w kroku „Usługi”.",
  resource_wizard_rule_pool_without_services:
    "Ta pula nie jest jeszcze przypięta do żadnej usługi.",
  resource_wizard_rule_advanced:
    "Ta pozycja ma regułę ustawioną przez API, której nie da się tu pokazać. Zostanie bez zmian, dopóki jej nie zastąpisz.",
  resource_wizard_rule_replace: "Zastąp prostym wyborem",
  resource_wizard_rule_advanced_short: "reguła z API",
  resource_wizard_or: "albo",
  resource_wizard_summary_title: "Sprawdź, zanim zapiszesz",
  resource_wizard_summary_subtitle:
    "Po prawej: ten sam przykładowy dzień z Twoimi ustawieniami.",
  resource_wizard_summary_type: "Rodzaj",
  resource_wizard_summary_name: "Nazwa",
  resource_wizard_summary_positions: "Pozycje",
  resource_wizard_summary_quantity: "Ilość",
  resource_wizard_summary_services: "Usługi",
  resource_wizard_summary_group: "Zajęcia grupowe",
  resource_wizard_summary_daily_limit: "Limit dzienny",
  resource_wizard_summary_assignment: "Przydział",
  resource_wizard_summary_no_services: "Żadne, dodasz je później w usłudze",
  resource_wizard_change: "Zmień",
  resource_wizard_create_pool: "Utwórz pulę",
  resource_wizard_create_resource: "Utwórz zasób",
  resource_wizard_count_positions:
    "@{count} pozycja|@{count} pozycje|@{count} pozycji",
  resource_wizard_count_units: "@{count} sztuka|@{count} sztuki|@{count} sztuk",
  resource_wizard_error_name_required: "Wpisz nazwę.",
  resource_wizard_error_name_too_long:
    "Nazwa może mieć najwyżej @{max} znaków.",
  resource_wizard_error_name_characters:
    "Nazwa nie może zawierać nawiasów kwadratowych ani klamrowych ani znaków < i >.",
  resource_wizard_error_duplicate: "Ta nazwa już jest na liście.",
  resource_wizard_error_two_names: "Wpisz co najmniej dwie różne nazwy.",
  resource_wizard_error_too_many: "Pula może mieć najwyżej 200 pozycji.",
  resource_wizard_error_quantity: "Wpisz liczbę od 1 do @{max}.",
  resource_wizard_error_rule_empty:
    "Zaznacz co najmniej jedną osobę albo usługę.",
  resource_wizard_close_title: "Zamknąć bez zapisywania?",
  resource_wizard_close_warning:
    "Wpisane nazwy i ustawienia nie zostaną zapisane.",
  resource_wizard_close_keep: "Wróć do kreatora",
  resource_wizard_close_discard: "Zamknij bez zapisu",
  resource_wizard_pool_added: "Pula „@{name}” dodana.",
  resource_wizard_resource_added: "Zasób „@{name}” dodany.",
  resource_wizard_saved: "Zapisano zmiany.",
  resource_wizard_in_practice: "Co to znaczy w praktyce",
  resource_wizard_example_always:
    "Każda rezerwacja usług, które korzystają z puli „@{pool}”, może dostać „@{name}”, jeśli o tej godzinie nie ma tam innej rezerwacji.",
  resource_wizard_example_manual:
    "System nigdy sam nie da „@{name}”. Przydzielasz to w oknie rezerwacji.",
  resource_wizard_example_manual_counts:
    "Rezerwacja, która czeka na Twój przydział, też zajmuje miejsce w puli. Gdy wszystkie pozycje są zajęte albo czekają na przydział, klienci nie zobaczą tej godziny.",
  resource_wizard_example_fits:
    "@{service}, prowadzi @{employee}: może dostać „@{name}”, jeśli o tej godzinie nie ma tam innej rezerwacji.",
  resource_wizard_example_misses:
    "@{service}, prowadzi @{employee}: nie dostanie „@{name}”. System da inną wolną pozycję.",
  resource_wizard_preview_example_title: "Na Twoim przykładzie",
  resource_wizard_preview_type_name_first:
    "Wpisz nazwę po lewej, a pokażemy, jak będzie wyglądać w rezerwacji.",
  resource_wizard_preview_label_title: "Tak to zobaczysz w rezerwacji",
  resource_wizard_preview_label_caption: "W oknie rezerwacji i w kalendarzu.",
  resource_wizard_preview_booking_resources: "Zasoby rezerwacji",
  resource_wizard_preview_label_pool_note:
    "Za „…” podstawimy nazwę jednej z pozycji puli „@{name}”. Wpiszesz je w następnym kroku.",
  resource_wizard_preview_label_resource_note:
    "Ile sztuk „@{name}” masz, ustawisz w następnym kroku.",
  resource_wizard_preview_names_caption:
    "Każda rezerwacja dostaje jedną z tych pozycji. W kalendarzu i w oknie rezerwacji zobaczysz ją razem z nazwą puli.",
  resource_wizard_preview_names_examples: "Zasoby rezerwacji, przykłady",
  resource_wizard_preview_names_empty: "Wpisz nazwy po lewej.",
  resource_wizard_preview_names_note:
    "@{positions} pozycja to najwyżej @{bookings} rezerwacja o tej samej godzinie. Kto ją dostaje, ustawisz w kroku „Przydział”.|@{positions} pozycje to najwyżej @{bookings} rezerwacje o tej samej godzinie. Kto je dostaje, ustawisz w kroku „Przydział”.|@{positions} pozycji to najwyżej @{bookings} rezerwacji o tej samej godzinie. Kto je dostaje, ustawisz w kroku „Przydział”.",
  resource_wizard_preview_more_positions:
    "i jeszcze @{count} pozycja|i jeszcze @{count} pozycje|i jeszcze @{count} pozycji",
  resource_wizard_preview_quantity_title: "Ile rezerwacji naraz?",
  resource_wizard_preview_quantity_caption:
    "Tyle rezerwacji o tej samej godzinie może zająć „@{name}”.",
  resource_wizard_preview_quantity_at_once:
    "@{count} rezerwacja naraz|@{count} rezerwacje naraz|@{count} rezerwacji naraz",
  resource_wizard_preview_quantity_note:
    "Kalendarz będzie wyświetlał dostępność na tę godzinę do czasu, aż powstanie @{count} rezerwacja.|Kalendarz będzie wyświetlał dostępność na tę godzinę do czasu, aż powstaną @{count} rezerwacje.|Kalendarz będzie wyświetlał dostępność na tę godzinę do czasu, aż powstanie @{count} rezerwacji.",
  resource_wizard_preview_services_title: "Które rezerwacje zajmą „@{name}”?",
  resource_wizard_preview_services_caption:
    "Na podstawie usług, które zaznaczasz.",
  resource_wizard_preview_services_empty: "Zaznacz usługi po lewej.",
  resource_wizard_preview_service_one_place: "Zajmie jedno miejsce.",
  resource_wizard_preview_service_group_one_place:
    "Zajmie jedno miejsce na całą grupę.",
  resource_wizard_preview_service_run_by: "Prowadzi: @{names}",
  resource_wizard_insight_people_one_service:
    "Tę usługę prowadzi @{count} osoba|Tę usługę prowadzą @{count} osoby|Tę usługę prowadzi @{count} osób",
  resource_wizard_insight_people_services:
    "Te usługi prowadzi @{count} osoba|Te usługi prowadzą @{count} osoby|Te usługi prowadzi @{count} osób",
  resource_wizard_insight_pool_capacity:
    "a pula „@{name}” ma @{count} pozycję.|a pula „@{name}” ma @{count} pozycje.|a pula „@{name}” ma @{count} pozycji.",
  resource_wizard_insight_resource_capacity:
    "a zasób „@{name}” jest dostępny w liczbie @{count}.",
  resource_wizard_insight_short:
    "O tej samej godzinie kalendarz nie pozwoli na rezerwację u jednej z nich.|O tej samej godzinie kalendarz nie pozwoli na rezerwację u @{count} z nich.|O tej samej godzinie kalendarz nie pozwoli na rezerwację u @{count} z nich.",
  resource_wizard_insight_enough_all:
    "Miejsca nie zabraknie, nawet gdy wszyscy przyjmują o tej samej godzinie.",
  resource_wizard_insight_enough: "Miejsca nie zabraknie.",
  resource_wizard_preview_group_caption:
    "Do @{max} osób na jednych zajęciach. „@{name}”: @{units}.",
  resource_wizard_preview_group_slot_box: "@{service}, @{max} zapisanych osób",
  resource_wizard_preview_group_slot_takes:
    "zajmie 1 z @{capacity} miejsc w „@{name}”",
  resource_wizard_preview_group_left_positions:
    "Dla innych rezerwacji o tej godzinie zostaje @{count} wolna pozycja.|Dla innych rezerwacji o tej godzinie zostają @{count} wolne pozycje.|Dla innych rezerwacji o tej godzinie zostaje @{count} wolnych pozycji.",
  resource_wizard_preview_group_left_units:
    "Dla innych rezerwacji o tej godzinie zostaje @{count} wolna sztuka.|Dla innych rezerwacji o tej godzinie zostają @{count} wolne sztuki.|Dla innych rezerwacji o tej godzinie zostaje @{count} wolnych sztuk.",
  resource_wizard_preview_group_none_left:
    "Innych rezerwacji o tej godzinie już nie będzie.",
  resource_wizard_preview_group_participants_fit:
    "Zapisze się najwyżej @{count} osoba|Zapiszą się najwyżej @{count} osoby|Zapisze się najwyżej @{count} osób",
  resource_wizard_preview_group_participants_left:
    "Każda osoba zajmie swoje miejsce. Dla innych rezerwacji o tej godzinie zostanie @{count} wolne miejsce.|Każda osoba zajmie swoje miejsce. Dla innych rezerwacji o tej godzinie zostaną @{count} wolne miejsca.|Każda osoba zajmie swoje miejsce. Dla innych rezerwacji o tej godzinie zostanie @{count} wolnych miejsc.",
  resource_wizard_preview_group_too_small:
    "Usługa przyjmuje do @{max} osób, ale każda potrzebuje swojego miejsca, a masz ich @{capacity}. Jeśli grupa siedzi w jednym miejscu, wybierz drugą opcję.",
  resource_wizard_preview_day_title: "Przykładowy dzień",
  resource_wizard_preview_day_caption:
    "Wszyscy przyjmują o 10:00, a @{first} także o 11:00.",
  resource_wizard_preview_bookings_row: "Rezerwacje",
  resource_wizard_preview_legend_gets: "ma miejsce",
  resource_wizard_preview_legend_waits: "czeka na przydział",
  resource_wizard_preview_legend_missed:
    "brak miejsca, klienci nie zobaczą tej godziny",
  resource_wizard_preview_day_needs_services:
    "Zaznacz usługi w kroku „Usługi”, a pokażemy przykładowy dzień z Twoimi pracownikami.",
  resource_wizard_preview_taken: "Zajęte",
  resource_wizard_preview_customers_see: "Klienci widzą",
  resource_wizard_preview_free: "wolne",
  resource_wizard_preview_gone: "brak",
  resource_wizard_preview_log_takes:
    "@{employee}, @{hour}, @{service}: zajmuje jedną sztukę „@{resource}”.",
  resource_wizard_preview_log_gets:
    "@{employee}, @{hour}, @{service}: dostaje „@{unit}”.",
  resource_wizard_preview_log_waits:
    "@{employee}, @{hour}, @{service}: system nie ma czego dać sam. Rezerwacja się zapisze i czeka, aż ją przydzielisz. Do tego czasu zajmuje miejsce, np. „@{unit}”.",
  resource_wizard_preview_log_full:
    "@{employee}, @{hour}, @{service}: brak wolnego miejsca, więc klienci nie zobaczą tej godziny u tej osoby. W panelu możesz zapisać taką rezerwację.",
  resource_wizard_preview_log_no_match:
    "@{employee}, @{hour}, @{service}: żadna wolna pozycja nie jest dla tej rezerwacji, więc klienci nie zobaczą tej godziny u tej osoby.",
  resource_wizard_preview_manual_note:
    "Rezerwacja czekająca na ręczny przydział też zajmuje miejsce. Dlatego „@{name}” przyjmie najwyżej @{count} rezerwację o tej samej godzinie, nawet zanim cokolwiek przydzielisz.|Rezerwacja czekająca na ręczny przydział też zajmuje miejsce. Dlatego „@{name}” przyjmie najwyżej @{count} rezerwacje o tej samej godzinie, nawet zanim cokolwiek przydzielisz.|Rezerwacja czekająca na ręczny przydział też zajmuje miejsce. Dlatego „@{name}” przyjmie najwyżej @{count} rezerwacji o tej samej godzinie, nawet zanim cokolwiek przydzielisz.",
  resource_wizard_preview_order_note:
    "Gdy pasuje kilka wolnych pozycji, system daje najpierw tę, która jest dla najmniejszej grupy rezerwacji, a pozycje „Wszystkim rezerwacjom” zostawia na koniec. Dzięki temu klienci widzą jak najwięcej wolnych godzin.",
  resource_wizard_example_no_fit:
    "Teraz żadna rezerwacja nie pasuje do tego wyboru, więc system nie da „@{name}” nikomu.",
  booking_awaiting_resource: "Czeka na zasób",
  booking_not_awaiting_resource: "Nie czeka na zasób",
  booking_awaiting_resource_info:
    "Rezerwacja ma usługę z pulą zasobów, ale nie ma jeszcze przydzielonej pozycji. Przydziel ją w edycji rezerwacji.",
  availability_schedule_resource_blocked:
    "@{employee}: w tych godzinach klienci nie zobaczą wolnych terminów. Wybrane pozycje puli „@{pool}” są przeznaczone dla innych rezerwacji.",
  availability_schedule_resource_manual:
    "@{employee}: w tych godzinach klienci nie zobaczą wolnych terminów, bo wybrane pozycje puli „@{pool}” przydzielasz ręcznie. Ustaw im „Wszystkim rezerwacjom” albo „Tylko wybranym rezerwacjom” albo wybierz inne pozycje.",
  resource_wizard_schedule_blocked:
    "W grafiku „@{schedule}” @{employee} ma wskazane tylko pozycje tej puli. Po zapisie klienci nie zobaczą u tej osoby wolnych terminów w tych godzinach.",
  recurring_series_length_locked:
    "W istniejącej serii nie zmienisz liczby powtórzeń. Żeby ją skrócić, usuń „To wydarzenie oraz wszystkie kolejne” od pierwszego niepotrzebnego terminu. Żeby ją wydłużyć, dodaj nową serię.",
  recurring_series_day_move_not_possible:
    "Tej serii nie przeniesiesz na wybrany dzień, bo jej rytm (na przykład „ostatni dzień roboczy miesiąca”) po przesunięciu przestałby się zgadzać. Usuń „To wydarzenie oraz wszystkie kolejne” i dodaj nową serię od wybranego dnia.",
  recurring_series_changed_meanwhile:
    "Ta seria zmieniła się w międzyczasie. Odśwież kalendarz i spróbuj jeszcze raz.",
  class_capacity_exceeded:
    "Limit miejsc w zajęciach: @{max}. Po tej zmianie zapisanych byłoby @{total}.",
  remove_tag_title: "Usuń etykietę",
  remove_tag_named:
    "Etykieta „@{name}” zniknie ze wszystkich rezerwacji i klientów, którzy ją mają.",
  remove_group_title: "Usuń grupę",
  remove_group_named:
    "Klienci z grupy „@{name}” przestaną do niej należeć. Sami klienci zostaną.",
  remove_resource_title: "Usuń zasób",
  remove_resource_named:
    "Zasób „@{name}” zniknie z usług i ze wszystkich rezerwacji, które go mają. Same rezerwacje zostaną.",
  remove_pool_title: "Usuń pulę",
  remove_pool_named:
    "Pula „@{name}” zniknie z usług razem ze swoimi pozycjami, a pozycje znikną z rezerwacji, do których były przypisane. Same rezerwacje zostaną.",
  remove_position_title: "Usuń pozycję",
  remove_position_named:
    "Pozycja „@{name}” zniknie ze wszystkich rezerwacji, które ją mają. Same rezerwacje zostaną.",
  resource_wizard_remove_positions_title: "Usunąć pozycje?",
  resource_wizard_remove_positions_warning:
    "Usuniesz pozycje: @{names}. Rezerwacje od dziś, które je mają: @{count}. Stracą te pozycje, ale same zostaną.",
  resource_wizard_remove_positions_button: "Usuń pozycje",
  resource_wizard_remove_positions_warning_no_count:
    "Usuniesz pozycje: @{names}. Rezerwacje, które je mają, stracą te pozycje, ale same zostaną.",
  service_description_title: "Opis usługi",
  service_description_hint: "Klient zobaczy go przy wyborze usługi.",
  service_description_placeholder: "Napisz krótko, na czym polega usługa",
  service_advanced_texts_title: "Teksty dla klienta",
  service_advanced_texts_hint:
    "Dodatkowe treści przy rezerwacji i w e-mailach o rezerwacji.",
  upselling_description_placeholder: "Np. polecenie produktu dodatkowego",
  additional_information_after_booking_placeholder:
    "Np. jak do nas dojechać albo co zabrać na spotkanie",
  additional_information_after_booking_variable_info:
    "Jeśli Twoje powiadomienia mają własną treść, dodaj do nich zmienną [ADDITIONAL_INFORMATION_AFTER_BOOKING]. Bez niej te informacje się nie pojawią.",
  service_advanced_availability_title: "Dostępność i zasoby",
  service_advanced_availability_hint:
    "Dodatkowe ograniczenie terminów i zasoby, których potrzebuje usługa.",
  service_advanced_resources_title: "Zasoby",
  service_advanced_resources_hint: "Sale i sprzęt, których potrzebuje usługa.",
  recurrence_too_long:
    "Ta seria ma za dużo powtórzeń. Ustaw wcześniejszą datę zakończenia albo mniej powtórzeń.",
  overlap_check_occurrences_truncated:
    "Sprawdziliśmy tylko pierwsze 1000 powtórzeń tej serii.",
  series_saved_occurrences_truncated:
    "Zapisano. Konflikty sprawdziliśmy tylko w pierwszych 1000 powtórzeniach tej serii.",
  location_skype_retired_info:
    "Skype nie działa od maja 2025. Wybierz Microsoft Teams albo inną lokalizację.",
  service_resource_hold_checkbox: "Zwolnij zasoby przed końcem rezerwacji",
  service_resource_hold_label: "Czas zajęcia",
  service_resource_hold_whole: "Cała rezerwacja",
  service_resource_hold_too_long: "Najwyżej tyle, ile trwa usługa: @{duration}",
  service_resource_hold_info:
    "Po tym czasie zasób jest znów dostępny dla innych rezerwacji, choć ta wciąż trwa. Pracownik zostaje zajęty do końca. Zmiana obejmuje też rezerwacje, które już są w kalendarzu.",
  resource_daily_limit_checkbox: "Ustaw limit dzienny",
  resource_daily_limit_label: "Limit",
  resource_daily_limit_unit_minutes: "minut",
  resource_daily_limit_unit_bookings: "rezerwacji",
  resource_daily_limit_per_day: "dziennie",
  resource_daily_limit_per_position: "na każdą pozycję",
  resource_daily_limit_per_unit: "na każdą sztukę",
  resource_daily_limit_total: "Razem @{total} dziennie (@{units} × @{limit})",
  resource_daily_limit_bookings_count:
    "@{count} rezerwacja|@{count} rezerwacje|@{count} rezerwacji",
  resource_daily_limit_caption: "limit @{limit} dziennie",
  resource_wizard_error_daily_limit_minutes: "Wpisz od 1 do 1440 minut.",
  resource_wizard_error_daily_limit_bookings: "Wpisz od 1 do 100 rezerwacji.",
  resource_daily_usage_minutes: "@{used} z @{limit} min",
  resource_daily_usage_bookings: "@{used} z @{limit} rezerwacji",
  resource_daily_over_limit: "ponad limit",
  resource_limit_warning_title: "Limit dzienny zasobu",
  resource_limit_warning_minutes:
    "Ta rezerwacja przekroczy limit zasobu „@{label}” na @{date}: wolnego czasu zostało @{left} z @{limit} min, a ona zajmie @{needed} min.",
  resource_limit_warning_minutes_full:
    "Ta rezerwacja przekroczy limit zasobu „@{label}” na @{date}: cały limit @{limit} min jest już wykorzystany, a ona doda @{needed} min.",
  resource_limit_warning_bookings:
    "Ta rezerwacja przekroczy limit zasobu „@{label}” na @{date}: wolnych miejsc zostało @{left} z @{limit}, a ona liczy się za @{needed}.",
  resource_limit_warning_bookings_full:
    "Ta rezerwacja przekroczy limit zasobu „@{label}” na @{date}: cały limit @{limit} rezerwacji jest już wykorzystany.",
  resource_limit_warnings_truncated:
    "Ponad limit jest więcej terminów, pokazujemy tylko pierwsze.",
  booking_helper_tile: "Pomoc",
  booking_helper_led_by: "prowadzi",
  booking_helpers_preview_label: "Pomagają",
  booking_helpers_title: "Pracownicy przy rezerwacji",
  booking_helpers_role_lead: "Prowadzi",
  booking_helpers_role_helper: "Pomaga",
  booking_helpers_window_whole_booking: "Cała rezerwacja",
  booking_helpers_window_outside: "Poza rezerwacją",
  booking_helpers_window_title: "Czas pomocy",
  booking_helpers_time_from: "Pomaga od",
  booking_helpers_time_to: "Pomaga do",
  booking_helpers_time_outside:
    "Ustaw czas pomocy w godzinach rezerwacji (@{start}-@{end}), co najmniej 5 minut.",
  booking_helpers_help_one:
    "@{name} będzie mieć zablokowany czas @{window}. Zobaczy go w kalendarzu Calendesk.",
  booking_helpers_help_outside:
    "Pomoc zaczyna się po końcu rezerwacji, więc nikt nie będzie mieć zablokowanego czasu. Zmień początek pomocy.",
  booking_helpers_remove: "Usuń pracownika",
  booking_helpers_hint:
    "Ostatnio do tej usługi dodano: @{names} (@{window}). Dodać znowu?",
  booking_helpers_hint_dismiss: "Nie teraz",
  booking_helpers_window_whole: "cała rezerwacja",
  booking_helpers_window_first: "pierwsze @{minutes} min",
  booking_helpers_window_from_for: "@{minutes} min od @{offset}. minuty",
  booking_helpers_window_from_to_end: "od @{offset}. minuty do końca",
  booking_helpers_add_another: "Dodaj kolejnego pracownika pomagającego",
  booking_helpers_add: "Dodaj pracownika pomagającego",
  booking_helper_busy_chip: "Pomoc niedostępna",
  booking_helper_conflicts_title: "Nie wszyscy mogą wtedy pomóc",
  booking_helper_conflict_outside_hours:
    "@{name}: @{when}-@{end}, poza godzinami pracy.",
  booking_helper_conflict_booking:
    "@{name}: @{when}-@{end}, ma inną rezerwację.",
  booking_helper_conflict_booking_details:
    "@{name}: @{when}-@{end}, ma rezerwację: @{details}.",
  booking_helper_conflict_blockade:
    "@{name}: @{when}-@{end}, ma blokadę w kalendarzu.",
  booking_helper_conflict_helper_time:
    "@{name}: @{when}-@{end}, pomaga już przy innej rezerwacji.",
  booking_helper_conflict_helper_time_details:
    "@{name}: @{when}-@{end}, pomaga już przy rezerwacji: @{details}.",
  booking_helper_conflicts_truncated: "Pokazujemy tylko pierwsze konflikty.",
  booking_helper_conflicts_question: "Zapisać mimo to?",
  helper_time_overlaps_count: "Pomoc przy innych rezerwacjach",
  helper_notifications_headline:
    "Powiadomienia dla pracowników pomagających przy rezerwacji",
  helper_notifications_checkbox:
    "Powiadamiaj pracowników, którzy pomagają przy rezerwacji",
  helper_notifications_info:
    "Pracownik pomagający to ktoś z zespołu, kto pracuje przy rezerwacji obok prowadzącego, np. druga terapeutka na sesji dla par. Dodajesz go w oknie rezerwacji, w sekcji „Pracownicy przy rezerwacji”, na całą rezerwację albo jej część. Po włączeniu dostaje te same wiadomości co prowadzący: o nowej rezerwacji, zmianie, odwołaniu i przypomnienie. Wysyłamy je e-mailem, SMS-em i jako push w aplikacji mobilnej, tak jak masz ustawione kanały dla pracowników. SMS-y zużywają pakiet konta.",
  resource_example_label: "Sale › Sala A",
  variable_booking_resource_names: "Nazwy zasobów bez puli (np. Sala A)",
  booking_helpers_add_label: "Kto pomaga?",
  cookie_settings: "Ustawienia cookies",
  cookie_settings_description:
    "Sprawdź albo zmień, na które cookies zgadzasz się w tym panelu.",
  cookie_settings_button: "Otwórz ustawienia",
  event_filter_helper: "Pracownik pomagający",
  helper_conflict_reason_outside_hours: "Poza godzinami pracy",
  helper_conflict_reason_booking: "Ma rezerwację",
  helper_conflict_reason_blockade: "Ma blokadę w kalendarzu",
  helper_conflict_reason_helper_time: "Pomaga przy innej rezerwacji",
  helper_conflicts_back: "Wróć i zmień",
  helper_conflicts_save_anyway: "Zapisz mimo to",
  event_customer_hidden: "Dane klienta niedostępne",
  payment_paid_info_invoice:
    "Oznaczymy rezerwację jako opłaconą i wystawimy fakturę.",
  payment_paid_info: "Oznaczymy rezerwację jako opłaconą.",
  payment_unpaid_info_invoice:
    "Zapiszemy tylko płatność. Rezerwacja pozostanie nieopłacona, a faktury nie wystawimy ani teraz, ani gdy później oznaczysz ją jako opłaconą. Jeśli klient ma dostać fakturę, zaznacz „@{label}”.",
  payment_unpaid_info:
    "Zapiszemy tylko płatność. Rezerwacja pozostanie nieopłacona.",
  invoice_state_issuing: "Wystawianie faktury…",
  invoice_state_blocked: "Bez faktury",
  invoice_customer_data_missing:
    "Brakuje danych klienta do faktury: @{fields}. Uzupełnij je, a potem wystaw fakturę.",
  invoice_customer_data_complete:
    "Klient ma już pełne dane. Możesz wystawić fakturę.",
  invoice_customer_data_edit: "Popraw dane klienta do faktury",
  invoice_issue_button: "Wystaw fakturę",
  invoice_issue_confirm_title: "Wystawić fakturę?",
  invoice_issue_confirm_warning:
    "Wystawimy fakturę z obecnymi danymi klienta. Jako datę sprzedaży wpiszemy datę płatności, a klient otrzyma ją tak jak każdą inną fakturę.",
  invoice_failure_authorization:
    "Fakturownia nie przyjęła klucza API. Wpisz nowy w Integracje › Fakturownia, w polu „API Token”, potem wystaw fakturę ponownie.",
  invoice_failure_rejected:
    "Fakturownia odrzuciła fakturę. Zwykle chodzi o dane klienta, np. NIP. Popraw je, potem wystaw fakturę ponownie.",
  invoice_failure_unreachable:
    "Kilka razy próbowaliśmy połączyć się z Fakturownią i nie odpowiadała. Wystaw fakturę ponownie za kilka minut.",
  invoice_failure_account_url:
    "Adres konta w integracji nie prowadzi do Fakturowni. Wpisz w Integracje › Fakturownia adres, na który się logujesz, potem wystaw fakturę ponownie.",
  invoice_customer_field_name: "nazwa firmy lub imię i nazwisko",
  invoice_customer_field_street: "ulica",
  invoice_customer_field_post_code: "kod pocztowy",
  invoice_customer_field_city: "miasto",
  invoice_customer_field_country: "kraj",
  invoice_retry_skipped_customer_data_incomplete:
    "Klient nadal nie ma pełnych danych do faktury. Brakuje: @{fields}.",
  invoice_failure_unknown:
    "Nie udało się wystawić faktury. Wystaw ją ponownie, a jeśli błąd się powtórzy, napisz do nas.",
  invoice_failure_authorization_chip: "Zły klucz API",
  invoice_failure_rejected_chip: "Fakturownia odrzuciła",
  invoice_failure_unreachable_chip: "Brak połączenia",
  invoice_failure_account_url_chip: "Zły adres konta",
  invoice_fix_integration: "Popraw integrację Fakturowni",
  delete_payment_invoice_issued:
    "Faktura @{number} zostanie w Fakturowni. Usunięcie płatności jej nie anuluje. Jeśli trzeba, wystaw korektę w Fakturowni.",
  delete_payment_invoice_issued_no_number:
    "Faktura do tej płatności zostanie w Fakturowni. Usunięcie płatności jej nie anuluje. Jeśli trzeba, wystaw korektę w Fakturowni.",
  delete_payment_invoice_pending:
    "Faktura do tej płatności jest właśnie wystawiana i zostanie w Fakturowni.",
  delete_payments_invoice_count:
    "@{amount} z zaznaczonych płatności ma fakturę w Fakturowni. Usunięcie płatności jej nie anuluje. Jeśli trzeba, wystaw korektę w Fakturowni.|@{amount} z zaznaczonych płatności mają faktury w Fakturowni. Usunięcie płatności ich nie anuluje. Jeśli trzeba, wystaw korekty w Fakturowni.|@{amount} z zaznaczonych płatności ma faktury w Fakturowni. Usunięcie płatności ich nie anuluje. Jeśli trzeba, wystaw korekty w Fakturowni.",
  delete_payments_invoice_any:
    "Jeśli któraś z tych płatności ma fakturę, faktura zostanie w Fakturowni. Usunięcie płatności jej nie anuluje.",
  subscription_payment_invoice_issued:
    "Ta subskrypcja ma już płatność z fakturą @{number} z dnia @{date}. Nowa płatność dostanie osobną fakturę.",
  subscription_payment_invoice_issued_no_number:
    "Ta subskrypcja ma już płatność z fakturą z dnia @{date}. Nowa płatność dostanie osobną fakturę.",
  subscription_payment_invoice_pending:
    "Ta subskrypcja ma już płatność z dnia @{date}, do której właśnie wystawiamy fakturę. Nowa płatność dostanie osobną fakturę.",
  group_count: "@{name} ×@{count} z @{total}",
  group_count_all: "@{name} ×@{count}",
  select_service_variant: "Wybierz wariant usługi.",
  booking_accept: "Akceptuj",
  booking_reject: "Odrzuć",
  booking_accept_this: "Akceptuj tę rezerwację",
  booking_accept_series: "Akceptuj całą serię",
  booking_waiting_banner: "Ta rezerwacja czeka na Twoją akceptację.",
  booking_waiting_banner_series:
    "Należy do serii. Akceptacja samej tej rezerwacji odłączy ją od serii.",
  accept_waiting_bookings: "Akceptuj oczekujące",
  accept_selected_bookings: "Akceptuj zaznaczone",
  reject_selected_bookings: "Odrzuć zaznaczone",
  no_waiting_bookings_selected:
    "Żadna z zaznaczonych rezerwacji nie czeka na akceptację.",
  waiting_bookings_banner: "Rezerwacje czekające na akceptację: @{count}",
  waiting_bookings_show: "Pokaż",
  service_requires_acceptance_label: "Wymagaj akceptacji rezerwacji online",
  service_requires_acceptance_info:
    "Rezerwacje złożone przez klientów online czekają, aż ktoś z zespołu je zaakceptuje albo odrzuci. Klient dostaje wiadomość, że rezerwacja czeka na potwierdzenie (jeśli to powiadomienie jest włączone).",
  service_default_booking_status_disabled:
    "Gdy płatność online jest wymagana albo usługa jest tylko dla subskrybentów, rezerwację potwierdza płatność lub subskrypcja, więc nie może czekać na akceptację.",
  booking_waiting_participant_fixed:
    "Czeka na akceptację: zaakceptuj albo odrzuć tego uczestnika w podglądzie rezerwacji.",
  booking_waiting: "Rezerwacja czeka na akceptację",
  booking_waiting_info:
    "Powiadomienie jest wysyłane do klienta i pracownika, gdy powstanie rezerwacja, która czeka na akceptację. Po akceptacji dostają powiadomienie „Potwierdzenie rezerwacji”. Powiadomienie nie jest wysyłane, jeśli ten rodzaj powiadomień jest wyłączony lub jeśli opcja „Nie informuj o stworzeniu wizyty” została wybrana.",
  booking_waiting_email_subject_client:
    "Rezerwacja czeka na potwierdzenie: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_waiting_email_text_client:
    '<h1>Numer rezerwacji: [BOOKING_ID]</h1><hr/><p>Cześć,</p><p>Otrzymaliśmy Twoją rezerwację na usługę <b>[SERVICE_NAME]</b>. Będzie ważna, gdy ją potwierdzimy.</p><p><b>Data i godzina:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_CUSTOMER_BOOKING_BUTTON]',
  booking_waiting_sms_text_client:
    "[COMPANY_NAME]: rezerwacja na usluge [SERVICE_NAME], [BOOKING_START_DATE] o godz. [BOOKING_START_TIME], czeka na potwierdzenie.",
  booking_waiting_email_subject_tenant:
    "Rezerwacja do akceptacji: [BOOKING_START_DATE] [BOOKING_START_TIME] - [SERVICE_NAME]",
  booking_waiting_email_text_tenant:
    '<h1>Numer rezerwacji: [BOOKING_ID]</h1><hr/><p>Cześć,</p><p><b>Pojawiła się nowa rezerwacja na usługę:</b><br> [SERVICE_NAME]</p><p><b>Rezerwacja czeka na akceptację. Zaakceptuj ją albo odrzuć w panelu.</b></p><p><b>Klient:</b><br>[CUSTOMER_FULL_NAME]</p><p><b>Pracownik:</b><br>[EMPLOYEE_FULL_NAME]</p><p><b>Data i godzina:</b><br>[BOOKING_START_DATE] [BOOKING_START_TIME] ([BOOKING_TIME_ZONE])</p><p><b>Lokalizacja:</b><br>[BOOKING_LOCATION] [BOOKING_ONLINE_MEETING_URL]</p>[BOOKING_CUSTOM_FIELDS] [ADDITIONAL_INFORMATION_AFTER_BOOKING]<p class="cd-paragraph"></p>[MANAGE_EMPLOYEE_BOOKING_BUTTON]',
  booking_waiting_sms_text_tenant:
    "[COMPANY_NAME] - Rezerwacja do akceptacji: [SERVICE_NAME]. Klient: [CUSTOMER_FULL_NAME], data: [BOOKING_START_DATE], godzina: [BOOKING_START_TIME].",
  notification_category_15: "Rezerwacja czeka na akceptację",
  service_waiting_slot_label: "Czy oczekująca rezerwacja blokuje termin?",
  service_waiting_slot_held: "Tak, termin jest zajęty do decyzji",
  service_waiting_slot_held_description:
    "Inni klienci nie mogą zarezerwować tego terminu, dopóki nie zaakceptujesz albo nie odrzucisz rezerwacji.",
  service_waiting_slot_free: "Nie, termin zostaje wolny",
  service_waiting_slot_free_description:
    "Inni klienci nadal mogą go zarezerwować. Przy akceptacji zobaczysz, jeśli termin jest już zajęty.",
  accept_conflicts_title: "Część tych terminów jest już zajęta:",
  accept_conflicts_line:
    "Rezerwacja @{id} (@{date}): inne rezerwacje w tym czasie: @{count}",
  accept_selection_overlaps_title:
    "Zaznaczone rezerwacje nakładają się na siebie:",
  accept_selection_overlap_line: "@{date}, @{employee}: @{bookings}",
  booking_accept_anyway: "Akceptuj mimo to",
  resources_filter_whole_pool:
    "Cała pula, @{count} pozycja|Cała pula, @{count} pozycje|Cała pula, @{count} pozycji",
  resources_filter_in_whole_pool: "W całej puli",
  resources_filter_pool_chip: "Pula: @{name}",
  resources_filter_label: "Zasoby i pule",
  accept_effects_intro: "Po akceptacji:",
  accept_channel_email: "e-mailem",
  accept_channel_sms: "SMS-em",
  accept_channel_push: "w aplikacji mobilnej",
  accept_effect_customer:
    "@{name} dostanie potwierdzenie rezerwacji @{channels}.",
  accept_effect_customers:
    "Klienci dostaną potwierdzenie rezerwacji @{channels}.",
  accept_effect_employee:
    "@{name} dostanie powiadomienie o nowej rezerwacji @{channels}.",
  accept_effect_employees:
    "Pracownicy dostaną powiadomienie o nowych rezerwacjach @{channels}.",
  accept_effect_company:
    "Firma dostanie powiadomienie o nowej rezerwacji @{channels}.",
  accept_effect_silent: "Nie wyślemy żadnych powiadomień.",
  accept_effect_calendar:
    "Rezerwacja trafi do połączonego kalendarza (@{calendars}).",
  accept_effect_calendars:
    "Rezerwacje trafią do połączonych kalendarzy (@{calendars}).",
  accept_effect_meeting: "Powstanie link do spotkania online (@{meeting}).",
  accept_effect_meetings: "Powstaną linki do spotkań online (@{meeting}).",
  accept_effect_reminders:
    "Przypomnienia wyślemy tak jak przy każdej rezerwacji.",
  accept_effect_generic:
    "Wyślemy potwierdzenia zgodnie z ustawieniami powiadomień.",
  accept_footer_sent:
    "Wysłanych powiadomień nie da się cofnąć. Rezerwację możesz później anulować.|Wysłanych powiadomień nie da się cofnąć. Rezerwacje możesz później anulować.|Wysłanych powiadomień nie da się cofnąć. Rezerwacje możesz później anulować.",
  accept_footer:
    "Rezerwację możesz później anulować.|Rezerwacje możesz później anulować.|Rezerwacje możesz później anulować.",
  accept_title_one: "Zaakceptować rezerwację?",
  accept_title_many:
    "Zaakceptować @{count} rezerwację?|Zaakceptować @{count} rezerwacje?|Zaakceptować @{count} rezerwacji?",
  accept_title_series: "Zaakceptować wszystkie rezerwacje z serii?",
  accept_conflict_info: "Inne rezerwacje w tym samym czasie:",
  waiting_to_accept: "Do akceptacji",
  waiting_to_accept_count: "Do akceptacji (@{count})",
};
